import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_card_proto from './dcei_wildsky_card_proto';
import * as dcei_wildsky_map_event_proto from './dcei_wildsky_map_event_proto';
export class TournamentDeck {
  get descriptor() {
    return TournamentDeck.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cards = [];
  }
  isEmpty() {
    if (this._cards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentDeck) {
      return value;
    }
    return TournamentDeck.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentDeck();
    result._cards = JsonToList(json.cards, dcei_wildsky_card_proto.CardProgression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cards.length > 0) {
      result.cards = ArrayToJson(this._cards, dcei_wildsky_card_proto.CardProgression);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_card_proto.CardProgression[]}
   */
  get cards() {
    return this._cards;
  }
  addCards(path, value) {
    return {type: 'ADD', path: path.concat(['cards']), value: value.toJson()};
  }
  setCards(path, value) {
    return {type: 'SET', path: path.concat(['cards']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardProgression)};
  }
  setCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cards', key]), value: value.toJson()};
  }
  deleteCards(path) {
    return {type: 'DELETE', path: path.concat(['cards'])};
  }
  deleteCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentDeck(this);
              copy._cards = [];        for (let i of value) {
                copy._cards.push(dcei_wildsky_card_proto.CardProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentDeck(this);
              copy._cards = copy._cards.concat([dcei_wildsky_card_proto.CardProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cards.length === 0) {
                return this;
              }
              const copy = new TournamentDeck(this);
              copy._cards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentDeck(this);
              copy._cards = copy._cards.slice();
              copy._cards[path[1]] = dcei_wildsky_card_proto.CardProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentDeck(this);
              copy._cards = copy._cards.slice(0, path[1]).concat(copy._cards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cards.length) {
            return this;
          }
          const oldValue = this._cards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentDeck(this);
          copy._cards = copy._cards.slice();
          copy._cards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentDeck} other
   * @returns {TournamentDeck}
   */
  merge(other) {
    const copy = new TournamentDeck(this);
    copy._cards = this._cards.concat(other._cards);
    return copy;
  }
}
TournamentDeck.default = new TournamentDeck();
class TournamentDeck_Builder {
  constructor(value) {
    this._value = new TournamentDeck(value);
  }
  build() {
    return new TournamentDeck(this._value);
  }
  addAllCards(values) {
    this._value._cards = this._value._cards.concat(values);
    return this;
  }
  addCards(value) {
    this._value._cards = this._value._cards.concat([value]);
    return this;
  }
  setCards(index, value) {
    this._value._cards = this._value._cards.concat();
    this._value._cards[index] = value;
    return this;
  }
  clearCards() {
    this._value._cards = [];
    return this;
  }
}
TournamentDeck.Builder = TournamentDeck_Builder;
class TournamentDeck_WithParent {
  /**
   * @param {TournamentDeck} value
   * @param {TournamentDeck_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentDeck.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCards() {
    if (!this._selfCards) {
      this._selfCards = [];
      for (let i of this._value.cards) {
        this._selfCards.push(new dcei_wildsky_card_proto.CardProgression.WithParent(i, null));
      }
    }
    return this._selfCards;
  }
  get inherentCards() {
    if (!this._inherentCards) {
      this._inherentCards = this._parent ? this._parent.cards : [];
    }
    return this._inherentCards;
  }
  get cards() {
    if (!this._allCards) {
      this._allCards = this._parent ? this._parent.cards.concat(this.selfCards) : this.selfCards;
    }
    return this._allCards;
  }
  update(current, parent) {
    const result = new TournamentDeck_WithParent(current, parent);
    if (this._selfCards) {
      if (this._value.cards === current.cards) {
        result._selfCards = this._selfCards;
      } else {
        result._selfCards = [];
        for (let i = 0; i < current.cards.length; i++) {
          const oldValue = this._value.cards[i];
          if (oldValue) {
            const oldCache = this._selfCards[i];
            if (oldValue === current.cards[i]) {
              result._selfCards[i] = oldCache;
            } else {
              result._selfCards[i] = oldCache.update(current.cards[i], null);
            }
          } else {
            result._selfCards[i] = new dcei_wildsky_card_proto.CardProgression.WithParent(current.cards[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentDeck_WithParent.default = new TournamentDeck_WithParent(TournamentDeck.default, null);
TournamentDeck.WithParent = TournamentDeck_WithParent;
class TournamentDeck_Descriptor {
  get cards() {
    if (!this._cards) {
      this._cards = {
        name: "cards",
        Name: "Cards",
        number: 1,
        protoType: 11,
        protoName: "cards",
        type: dcei_wildsky_card_proto.CardProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TournamentDeck.descriptor = new TournamentDeck_Descriptor();
export class TournamentRewardItem {
  get descriptor() {
    return TournamentRewardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentRewardItem) {
      return value;
    }
    return TournamentRewardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentRewardItem();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentRewardItem(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TournamentRewardItem(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentRewardItem(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new TournamentRewardItem(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentRewardItem} other
   * @returns {TournamentRewardItem}
   */
  merge(other) {
    const copy = new TournamentRewardItem(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
TournamentRewardItem.default = new TournamentRewardItem();
class TournamentRewardItem_Builder {
  constructor(value) {
    this._value = new TournamentRewardItem(value);
  }
  build() {
    return new TournamentRewardItem(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
TournamentRewardItem.Builder = TournamentRewardItem_Builder;
class TournamentRewardItem_WithParent {
  /**
   * @param {TournamentRewardItem} value
   * @param {TournamentRewardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentRewardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new TournamentRewardItem_WithParent(current, parent);
    return result;
  }
}
TournamentRewardItem_WithParent.default = new TournamentRewardItem_WithParent(TournamentRewardItem.default, null);
TournamentRewardItem.WithParent = TournamentRewardItem_WithParent;
class TournamentRewardItem_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentRewardItem.descriptor = new TournamentRewardItem_Descriptor();
export class TournamentHistoryItem {
  get descriptor() {
    return TournamentHistoryItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTournamentId = false;
    this._tournamentId = null;
    this._hasRank = false;
    this._rank = null;
    this._hasDeck = false;
    this._deck = null;
    this._rewards = [];
    this._gmRewards = [];
    this._hasRewardClaimed = false;
    this._rewardClaimed = null;
    this._hasTournamentName = false;
    this._tournamentName = null;
    this._hasLeague = false;
    this._league = null;
    this._hasSeason = false;
    this._season = null;
  }
  isEmpty() {
    if (this._hasTournamentId) return false;
    if (this._hasRank) return false;
    if (this._hasDeck && !this._deck.isEmpty()) return false;
    if (this._rewards.length > 0) return false;
    if (this._gmRewards.length > 0) return false;
    if (this._hasRewardClaimed) return false;
    if (this._hasTournamentName) return false;
    if (this._hasLeague) return false;
    if (this._hasSeason) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentHistoryItem) {
      return value;
    }
    return TournamentHistoryItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentHistoryItem();
    if (json.tournamentId != null) {
      result._hasTournamentId = true;
      result._tournamentId = JsonToString.fromJson(json.tournamentId);
    }
    if (json.rank != null) {
      result._hasRank = true;
      result._rank = JsonToInt32.fromJson(json.rank);
    }
    if (json.deck != null) {
      result._hasDeck = true;
      result._deck = TournamentDeck.fromJson(json.deck);
    }
    result._rewards = JsonToList(json.rewards, TournamentRewardItem);
    result._gmRewards = JsonToList(json.gmRewards, TournamentRewardItem);
    if (json.rewardClaimed != null) {
      result._hasRewardClaimed = true;
      result._rewardClaimed = JsonToBoolean.fromJson(json.rewardClaimed);
    }
    if (json.tournamentName != null) {
      result._hasTournamentName = true;
      result._tournamentName = JsonToString.fromJson(json.tournamentName);
    }
    if (json.league != null) {
      result._hasLeague = true;
      result._league = JsonToInt32.fromJson(json.league);
    }
    if (json.season != null) {
      result._hasSeason = true;
      result._season = JsonToInt32.fromJson(json.season);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTournamentId) {
      result.tournamentId = JsonToString.toJson(this._tournamentId);
    }
    if (this._hasRank) {
      result.rank = JsonToInt32.toJson(this._rank);
    }
    if (this._hasDeck && !this._deck.isEmpty()) {
      result.deck = TournamentDeck.toJson(this._deck);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, TournamentRewardItem);
    }
    if (this._gmRewards.length > 0) {
      result.gmRewards = ArrayToJson(this._gmRewards, TournamentRewardItem);
    }
    if (this._hasRewardClaimed) {
      result.rewardClaimed = JsonToBoolean.toJson(this._rewardClaimed);
    }
    if (this._hasTournamentName) {
      result.tournamentName = JsonToString.toJson(this._tournamentName);
    }
    if (this._hasLeague) {
      result.league = JsonToInt32.toJson(this._league);
    }
    if (this._hasSeason) {
      result.season = JsonToInt32.toJson(this._season);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get tournamentId() {
    return this._hasTournamentId ? this._tournamentId : JsonToString.default;
  }
  get hasTournamentId() {
    return this._hasTournamentId;
  }
  setTournamentId(path, value) {
    return {type: 'SET', path: path.concat(['tournamentId']), value};
  }
  deleteTournamentId(path) {
    return {type: 'DELETE', path: path.concat(['tournamentId'])};
  }
  /**
   * @returns {number}
   */
  get rank() {
    return this._hasRank ? this._rank : JsonToInt32.default;
  }
  get hasRank() {
    return this._hasRank;
  }
  setRank(path, value) {
    return {type: 'SET', path: path.concat(['rank']), value};
  }
  deleteRank(path) {
    return {type: 'DELETE', path: path.concat(['rank'])};
  }
  /**
   * @returns {TournamentDeck}
   */
  get deck() {
    return this._hasDeck ? this._deck : TournamentDeck.default;
  }
  get hasDeck() {
    return this._hasDeck;
  }
  setDeck(path, value) {
    return {type: 'SET', path: path.concat(['deck']), value: value.toJson()};
  }
  deleteDeck(path) {
    return {type: 'DELETE', path: path.concat(['deck'])};
  }
  /**
   * @returns {TournamentRewardItem[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, TournamentRewardItem)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  /**
   * @returns {TournamentRewardItem[]}
   */
  get gmRewards() {
    return this._gmRewards;
  }
  addGmRewards(path, value) {
    return {type: 'ADD', path: path.concat(['gmRewards']), value: value.toJson()};
  }
  setGmRewards(path, value) {
    return {type: 'SET', path: path.concat(['gmRewards']), value: ArrayToJson(value, TournamentRewardItem)};
  }
  setGmRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gmRewards', key]), value: value.toJson()};
  }
  deleteGmRewards(path) {
    return {type: 'DELETE', path: path.concat(['gmRewards'])};
  }
  deleteGmRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gmRewards', key])};
  }
  /**
   * @returns {boolean}
   */
  get rewardClaimed() {
    return this._hasRewardClaimed ? this._rewardClaimed : JsonToBoolean.default;
  }
  get hasRewardClaimed() {
    return this._hasRewardClaimed;
  }
  setRewardClaimed(path, value) {
    return {type: 'SET', path: path.concat(['rewardClaimed']), value};
  }
  deleteRewardClaimed(path) {
    return {type: 'DELETE', path: path.concat(['rewardClaimed'])};
  }
  /**
   * @returns {string}
   */
  get tournamentName() {
    return this._hasTournamentName ? this._tournamentName : JsonToString.default;
  }
  get hasTournamentName() {
    return this._hasTournamentName;
  }
  setTournamentName(path, value) {
    return {type: 'SET', path: path.concat(['tournamentName']), value};
  }
  deleteTournamentName(path) {
    return {type: 'DELETE', path: path.concat(['tournamentName'])};
  }
  /**
   * @returns {number}
   */
  get league() {
    return this._hasLeague ? this._league : JsonToInt32.default;
  }
  get hasLeague() {
    return this._hasLeague;
  }
  setLeague(path, value) {
    return {type: 'SET', path: path.concat(['league']), value};
  }
  deleteLeague(path) {
    return {type: 'DELETE', path: path.concat(['league'])};
  }
  /**
   * @returns {number}
   */
  get season() {
    return this._hasSeason ? this._season : JsonToInt32.default;
  }
  get hasSeason() {
    return this._hasSeason;
  }
  setSeason(path, value) {
    return {type: 'SET', path: path.concat(['season']), value};
  }
  deleteSeason(path) {
    return {type: 'DELETE', path: path.concat(['season'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tournamentId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasTournamentId = true;
              copy._tournamentId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentId) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasTournamentId = false;
              copy._tournamentId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rank": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasRank = true;
              copy._rank = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRank) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasRank = false;
              copy._rank = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "deck": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasDeck = true;
              copy._deck = TournamentDeck.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeck) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasDeck = false;
              copy._deck = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeck) {
            const copy = new TournamentHistoryItem(this);
            copy._hasDeck = true;
            copy._deck = TournamentDeck.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._deck.apply(type, path.slice(1), value);
          if (newValue === this._deck) {
            return this;
          }
          const copy = new TournamentHistoryItem(this);
          copy._deck = copy._deck.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(TournamentRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentHistoryItem(this);
              copy._rewards = copy._rewards.concat([TournamentRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentHistoryItem(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentHistoryItem(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      case "gmRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._gmRewards = [];        for (let i of value) {
                copy._gmRewards.push(TournamentRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentHistoryItem(this);
              copy._gmRewards = copy._gmRewards.concat([TournamentRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gmRewards.length === 0) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._gmRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gmRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._gmRewards = copy._gmRewards.slice();
              copy._gmRewards[path[1]] = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentHistoryItem(this);
              copy._gmRewards = copy._gmRewards.slice(0, path[1]).concat(copy._gmRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gmRewards.length) {
            return this;
          }
          const oldValue = this._gmRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentHistoryItem(this);
          copy._gmRewards = copy._gmRewards.slice();
          copy._gmRewards[key] = newValue;
          return copy;
        }
      }
      case "rewardClaimed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasRewardClaimed = true;
              copy._rewardClaimed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardClaimed) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasRewardClaimed = false;
              copy._rewardClaimed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tournamentName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasTournamentName = true;
              copy._tournamentName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentName) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasTournamentName = false;
              copy._tournamentName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "league": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasLeague = true;
              copy._league = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeague) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasLeague = false;
              copy._league = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "season": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentHistoryItem(this);
              copy._hasSeason = true;
              copy._season = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSeason) {
                return this;
              }
              const copy = new TournamentHistoryItem(this);
              copy._hasSeason = false;
              copy._season = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentHistoryItem} other
   * @returns {TournamentHistoryItem}
   */
  merge(other) {
    const copy = new TournamentHistoryItem(this);
    if (other._hasTournamentId) {
      copy._hasTournamentId = true;
      copy._tournamentId = other._tournamentId;
    }
    if (other._hasRank) {
      copy._hasRank = true;
      copy._rank = other._rank;
    }
    if (other._hasDeck) {
      if (copy._hasDeck) {
        copy._deck = copy.deck.merge(other.deck);
      } else {
        copy._deck = other._deck;
      }
      copy._hasDeck = true;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    copy._gmRewards = this._gmRewards.concat(other._gmRewards);
    if (other._hasRewardClaimed) {
      copy._hasRewardClaimed = true;
      copy._rewardClaimed = other._rewardClaimed;
    }
    if (other._hasTournamentName) {
      copy._hasTournamentName = true;
      copy._tournamentName = other._tournamentName;
    }
    if (other._hasLeague) {
      copy._hasLeague = true;
      copy._league = other._league;
    }
    if (other._hasSeason) {
      copy._hasSeason = true;
      copy._season = other._season;
    }
    return copy;
  }
}
TournamentHistoryItem.default = new TournamentHistoryItem();
class TournamentHistoryItem_Builder {
  constructor(value) {
    this._value = new TournamentHistoryItem(value);
  }
  build() {
    return new TournamentHistoryItem(this._value);
  }
  setTournamentId(value) {
    this._value._hasTournamentId = true;
    this._value._tournamentId = value;
    return this;
  }
  deleteTournamentId() {
    this._value._hasTournamentId = false;
    this._value._tournamentId = null;
    return this;
  }
  setRank(value) {
    this._value._hasRank = true;
    this._value._rank = value;
    return this;
  }
  deleteRank() {
    this._value._hasRank = false;
    this._value._rank = null;
    return this;
  }
  setDeck(value) {
    this._value._hasDeck = true;
    this._value._deck = value;
    return this;
  }
  deleteDeck() {
    this._value._hasDeck = false;
    this._value._deck = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
  addAllGmRewards(values) {
    this._value._gmRewards = this._value._gmRewards.concat(values);
    return this;
  }
  addGmRewards(value) {
    this._value._gmRewards = this._value._gmRewards.concat([value]);
    return this;
  }
  setGmRewards(index, value) {
    this._value._gmRewards = this._value._gmRewards.concat();
    this._value._gmRewards[index] = value;
    return this;
  }
  clearGmRewards() {
    this._value._gmRewards = [];
    return this;
  }
  setRewardClaimed(value) {
    this._value._hasRewardClaimed = true;
    this._value._rewardClaimed = value;
    return this;
  }
  deleteRewardClaimed() {
    this._value._hasRewardClaimed = false;
    this._value._rewardClaimed = null;
    return this;
  }
  setTournamentName(value) {
    this._value._hasTournamentName = true;
    this._value._tournamentName = value;
    return this;
  }
  deleteTournamentName() {
    this._value._hasTournamentName = false;
    this._value._tournamentName = null;
    return this;
  }
  setLeague(value) {
    this._value._hasLeague = true;
    this._value._league = value;
    return this;
  }
  deleteLeague() {
    this._value._hasLeague = false;
    this._value._league = null;
    return this;
  }
  setSeason(value) {
    this._value._hasSeason = true;
    this._value._season = value;
    return this;
  }
  deleteSeason() {
    this._value._hasSeason = false;
    this._value._season = null;
    return this;
  }
}
TournamentHistoryItem.Builder = TournamentHistoryItem_Builder;
class TournamentHistoryItem_WithParent {
  /**
   * @param {TournamentHistoryItem} value
   * @param {TournamentHistoryItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentHistoryItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTournamentId() {
    if (this._cachedHasTournamentId === undefined) {
      if (this._value.hasTournamentId) {
        this._cachedHasTournamentId = true;
      } else {
        this._cachedHasTournamentId = this._parent ? this._parent.hasTournamentId : false;
      }
    }
    return this._cachedHasTournamentId;
  }
  get tournamentId() {
    if (this._cachedTournamentId === undefined) {
      if (this._value.hasTournamentId) {
        this._cachedTournamentId = this._value.tournamentId;
      } else {
        this._cachedTournamentId = this._parent ? this._parent.tournamentId : this._value.tournamentId;
      }
    }
    return this._cachedTournamentId;
  }
  get hasRank() {
    if (this._cachedHasRank === undefined) {
      if (this._value.hasRank) {
        this._cachedHasRank = true;
      } else {
        this._cachedHasRank = this._parent ? this._parent.hasRank : false;
      }
    }
    return this._cachedHasRank;
  }
  get rank() {
    if (this._cachedRank === undefined) {
      if (this._value.hasRank) {
        this._cachedRank = this._value.rank;
      } else {
        this._cachedRank = this._parent ? this._parent.rank : this._value.rank;
      }
    }
    return this._cachedRank;
  }
  get hasDeck() {
    if (this._cachedHasDeck === undefined) {
      if (this._value.hasDeck) {
        this._cachedHasDeck = true;
      } else {
        this._cachedHasDeck = this._parent ? this._parent.hasDeck : false;
      }
    }
    return this._cachedHasDeck;
  }
  get deck() {
    if (!this._cachedDeck) {
      if (this._value.hasDeck) {
        this._cachedDeck = new TournamentDeck.WithParent(this._value.deck, this._parent && this._parent.hasDeck ? this._parent.deck : null);
      } else {
        this._cachedDeck = this._parent ? new TournamentDeck.WithParent(TournamentDeck.default, this._parent.deck) : TournamentDeck.WithParent.default;
      }
    }
    return this._cachedDeck;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new TournamentRewardItem.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  get selfGmRewards() {
    if (!this._selfGmRewards) {
      this._selfGmRewards = [];
      for (let i of this._value.gmRewards) {
        this._selfGmRewards.push(new TournamentRewardItem.WithParent(i, null));
      }
    }
    return this._selfGmRewards;
  }
  get inherentGmRewards() {
    if (!this._inherentGmRewards) {
      this._inherentGmRewards = this._parent ? this._parent.gmRewards : [];
    }
    return this._inherentGmRewards;
  }
  get gmRewards() {
    if (!this._allGmRewards) {
      this._allGmRewards = this._parent ? this._parent.gmRewards.concat(this.selfGmRewards) : this.selfGmRewards;
    }
    return this._allGmRewards;
  }
  get hasRewardClaimed() {
    if (this._cachedHasRewardClaimed === undefined) {
      if (this._value.hasRewardClaimed) {
        this._cachedHasRewardClaimed = true;
      } else {
        this._cachedHasRewardClaimed = this._parent ? this._parent.hasRewardClaimed : false;
      }
    }
    return this._cachedHasRewardClaimed;
  }
  get rewardClaimed() {
    if (this._cachedRewardClaimed === undefined) {
      if (this._value.hasRewardClaimed) {
        this._cachedRewardClaimed = this._value.rewardClaimed;
      } else {
        this._cachedRewardClaimed = this._parent ? this._parent.rewardClaimed : this._value.rewardClaimed;
      }
    }
    return this._cachedRewardClaimed;
  }
  get hasTournamentName() {
    if (this._cachedHasTournamentName === undefined) {
      if (this._value.hasTournamentName) {
        this._cachedHasTournamentName = true;
      } else {
        this._cachedHasTournamentName = this._parent ? this._parent.hasTournamentName : false;
      }
    }
    return this._cachedHasTournamentName;
  }
  get tournamentName() {
    if (this._cachedTournamentName === undefined) {
      if (this._value.hasTournamentName) {
        this._cachedTournamentName = this._value.tournamentName;
      } else {
        this._cachedTournamentName = this._parent ? this._parent.tournamentName : this._value.tournamentName;
      }
    }
    return this._cachedTournamentName;
  }
  get hasLeague() {
    if (this._cachedHasLeague === undefined) {
      if (this._value.hasLeague) {
        this._cachedHasLeague = true;
      } else {
        this._cachedHasLeague = this._parent ? this._parent.hasLeague : false;
      }
    }
    return this._cachedHasLeague;
  }
  get league() {
    if (this._cachedLeague === undefined) {
      if (this._value.hasLeague) {
        this._cachedLeague = this._value.league;
      } else {
        this._cachedLeague = this._parent ? this._parent.league : this._value.league;
      }
    }
    return this._cachedLeague;
  }
  get hasSeason() {
    if (this._cachedHasSeason === undefined) {
      if (this._value.hasSeason) {
        this._cachedHasSeason = true;
      } else {
        this._cachedHasSeason = this._parent ? this._parent.hasSeason : false;
      }
    }
    return this._cachedHasSeason;
  }
  get season() {
    if (this._cachedSeason === undefined) {
      if (this._value.hasSeason) {
        this._cachedSeason = this._value.season;
      } else {
        this._cachedSeason = this._parent ? this._parent.season : this._value.season;
      }
    }
    return this._cachedSeason;
  }
  update(current, parent) {
    const result = new TournamentHistoryItem_WithParent(current, parent);
    if (this._cachedDeck && this._value.hasDeck && current.hasDeck) {
      if (this._value.deck === current.deck && this._parent === parent) {
        result._cachedDeck = this._cachedDeck;
      } else {
        result._cachedDeck = this._cachedDeck.update(current.deck, parent && parent.hasDeck ? parent.deck : null);
      }
    }
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new TournamentRewardItem.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    if (this._selfGmRewards) {
      if (this._value.gmRewards === current.gmRewards) {
        result._selfGmRewards = this._selfGmRewards;
      } else {
        result._selfGmRewards = [];
        for (let i = 0; i < current.gmRewards.length; i++) {
          const oldValue = this._value.gmRewards[i];
          if (oldValue) {
            const oldCache = this._selfGmRewards[i];
            if (oldValue === current.gmRewards[i]) {
              result._selfGmRewards[i] = oldCache;
            } else {
              result._selfGmRewards[i] = oldCache.update(current.gmRewards[i], null);
            }
          } else {
            result._selfGmRewards[i] = new TournamentRewardItem.WithParent(current.gmRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentHistoryItem_WithParent.default = new TournamentHistoryItem_WithParent(TournamentHistoryItem.default, null);
TournamentHistoryItem.WithParent = TournamentHistoryItem_WithParent;
class TournamentHistoryItem_Descriptor {
  get tournamentId() {
    if (!this._tournamentId) {
      this._tournamentId = {
        name: "tournamentId",
        Name: "TournamentId",
        number: 1,
        protoType: 9,
        protoName: "tournament_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentId;
  }
  get rank() {
    if (!this._rank) {
      this._rank = {
        name: "rank",
        Name: "Rank",
        number: 2,
        protoType: 5,
        protoName: "rank",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rank;
  }
  get deck() {
    if (!this._deck) {
      this._deck = {
        name: "deck",
        Name: "Deck",
        number: 3,
        protoType: 11,
        protoName: "deck",
        type: TournamentDeck,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._deck;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 4,
        protoType: 11,
        protoName: "rewards",
        type: TournamentRewardItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get gmRewards() {
    if (!this._gmRewards) {
      this._gmRewards = {
        name: "gmRewards",
        Name: "GmRewards",
        number: 8,
        protoType: 11,
        protoName: "gm_rewards",
        type: TournamentRewardItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gmRewards;
  }
  get rewardClaimed() {
    if (!this._rewardClaimed) {
      this._rewardClaimed = {
        name: "rewardClaimed",
        Name: "RewardClaimed",
        number: 5,
        protoType: 8,
        protoName: "reward_claimed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardClaimed;
  }
  get tournamentName() {
    if (!this._tournamentName) {
      this._tournamentName = {
        name: "tournamentName",
        Name: "TournamentName",
        number: 6,
        protoType: 9,
        protoName: "tournament_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentName;
  }
  get league() {
    if (!this._league) {
      this._league = {
        name: "league",
        Name: "League",
        number: 7,
        protoType: 5,
        protoName: "league",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._league;
  }
  get season() {
    if (!this._season) {
      this._season = {
        name: "season",
        Name: "Season",
        number: 9,
        protoType: 5,
        protoName: "season",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._season;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tournamentId,
        this.rank,
        this.deck,
        this.rewards,
        this.gmRewards,
        this.rewardClaimed,
        this.tournamentName,
        this.league,
        this.season,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTournamentId",
        Name: "DummyOneofForTournamentId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRank",
        Name: "DummyOneofForRank",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeck",
        Name: "DummyOneofForDeck",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewardClaimed",
        Name: "DummyOneofForRewardClaimed",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTournamentName",
        Name: "DummyOneofForTournamentName",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLeague",
        Name: "DummyOneofForLeague",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSeason",
        Name: "DummyOneofForSeason",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentHistoryItem.descriptor = new TournamentHistoryItem_Descriptor();
export class TournamentPlayerScore {
  get descriptor() {
    return TournamentPlayerScore.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUuid = false;
    this._uuid = null;
    this._hasScore = false;
    this._score = null;
    this._hasDeck = false;
    this._deck = null;
    this._hasName = false;
    this._name = null;
    this._hasPlayCount = false;
    this._playCount = null;
    this._hasGuildName = false;
    this._guildName = null;
    this._hasGuildId = false;
    this._guildId = null;
    this._hasLeague = false;
    this._league = null;
    this._hasNextLeague = false;
    this._nextLeague = null;
    this._hasGuildBadgeBackground = false;
    this._guildBadgeBackground = null;
    this._hasGuildBadgePattern = false;
    this._guildBadgePattern = null;
    this._hasGuildBadgeIcon = false;
    this._guildBadgeIcon = null;
    this._hasGrandmaster = false;
    this._grandmaster = null;
  }
  isEmpty() {
    if (this._hasUuid) return false;
    if (this._hasScore) return false;
    if (this._hasDeck && !this._deck.isEmpty()) return false;
    if (this._hasName) return false;
    if (this._hasPlayCount) return false;
    if (this._hasGuildName) return false;
    if (this._hasGuildId) return false;
    if (this._hasLeague) return false;
    if (this._hasNextLeague) return false;
    if (this._hasGuildBadgeBackground) return false;
    if (this._hasGuildBadgePattern) return false;
    if (this._hasGuildBadgeIcon) return false;
    if (this._hasGrandmaster) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentPlayerScore) {
      return value;
    }
    return TournamentPlayerScore.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentPlayerScore();
    if (json.uuid != null) {
      result._hasUuid = true;
      result._uuid = JsonToString.fromJson(json.uuid);
    }
    if (json.score != null) {
      result._hasScore = true;
      result._score = JsonToInt32.fromJson(json.score);
    }
    if (json.deck != null) {
      result._hasDeck = true;
      result._deck = TournamentDeck.fromJson(json.deck);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.playCount != null) {
      result._hasPlayCount = true;
      result._playCount = JsonToInt32.fromJson(json.playCount);
    }
    if (json.guildName != null) {
      result._hasGuildName = true;
      result._guildName = JsonToString.fromJson(json.guildName);
    }
    if (json.guildId != null) {
      result._hasGuildId = true;
      result._guildId = JsonToString.fromJson(json.guildId);
    }
    if (json.league != null) {
      result._hasLeague = true;
      result._league = JsonToInt32.fromJson(json.league);
    }
    if (json.nextLeague != null) {
      result._hasNextLeague = true;
      result._nextLeague = JsonToInt32.fromJson(json.nextLeague);
    }
    if (json.guildBadgeBackground != null) {
      result._hasGuildBadgeBackground = true;
      result._guildBadgeBackground = JsonToInt32.fromJson(json.guildBadgeBackground);
    }
    if (json.guildBadgePattern != null) {
      result._hasGuildBadgePattern = true;
      result._guildBadgePattern = JsonToInt32.fromJson(json.guildBadgePattern);
    }
    if (json.guildBadgeIcon != null) {
      result._hasGuildBadgeIcon = true;
      result._guildBadgeIcon = JsonToInt32.fromJson(json.guildBadgeIcon);
    }
    if (json.grandmaster != null) {
      result._hasGrandmaster = true;
      result._grandmaster = JsonToInt32.fromJson(json.grandmaster);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUuid) {
      result.uuid = JsonToString.toJson(this._uuid);
    }
    if (this._hasScore) {
      result.score = JsonToInt32.toJson(this._score);
    }
    if (this._hasDeck && !this._deck.isEmpty()) {
      result.deck = TournamentDeck.toJson(this._deck);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasPlayCount) {
      result.playCount = JsonToInt32.toJson(this._playCount);
    }
    if (this._hasGuildName) {
      result.guildName = JsonToString.toJson(this._guildName);
    }
    if (this._hasGuildId) {
      result.guildId = JsonToString.toJson(this._guildId);
    }
    if (this._hasLeague) {
      result.league = JsonToInt32.toJson(this._league);
    }
    if (this._hasNextLeague) {
      result.nextLeague = JsonToInt32.toJson(this._nextLeague);
    }
    if (this._hasGuildBadgeBackground) {
      result.guildBadgeBackground = JsonToInt32.toJson(this._guildBadgeBackground);
    }
    if (this._hasGuildBadgePattern) {
      result.guildBadgePattern = JsonToInt32.toJson(this._guildBadgePattern);
    }
    if (this._hasGuildBadgeIcon) {
      result.guildBadgeIcon = JsonToInt32.toJson(this._guildBadgeIcon);
    }
    if (this._hasGrandmaster) {
      result.grandmaster = JsonToInt32.toJson(this._grandmaster);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get uuid() {
    return this._hasUuid ? this._uuid : JsonToString.default;
  }
  get hasUuid() {
    return this._hasUuid;
  }
  setUuid(path, value) {
    return {type: 'SET', path: path.concat(['uuid']), value};
  }
  deleteUuid(path) {
    return {type: 'DELETE', path: path.concat(['uuid'])};
  }
  /**
   * @returns {number}
   */
  get score() {
    return this._hasScore ? this._score : JsonToInt32.default;
  }
  get hasScore() {
    return this._hasScore;
  }
  setScore(path, value) {
    return {type: 'SET', path: path.concat(['score']), value};
  }
  deleteScore(path) {
    return {type: 'DELETE', path: path.concat(['score'])};
  }
  /**
   * @returns {TournamentDeck}
   */
  get deck() {
    return this._hasDeck ? this._deck : TournamentDeck.default;
  }
  get hasDeck() {
    return this._hasDeck;
  }
  setDeck(path, value) {
    return {type: 'SET', path: path.concat(['deck']), value: value.toJson()};
  }
  deleteDeck(path) {
    return {type: 'DELETE', path: path.concat(['deck'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get playCount() {
    return this._hasPlayCount ? this._playCount : JsonToInt32.default;
  }
  get hasPlayCount() {
    return this._hasPlayCount;
  }
  setPlayCount(path, value) {
    return {type: 'SET', path: path.concat(['playCount']), value};
  }
  deletePlayCount(path) {
    return {type: 'DELETE', path: path.concat(['playCount'])};
  }
  /**
   * @returns {string}
   */
  get guildName() {
    return this._hasGuildName ? this._guildName : JsonToString.default;
  }
  get hasGuildName() {
    return this._hasGuildName;
  }
  setGuildName(path, value) {
    return {type: 'SET', path: path.concat(['guildName']), value};
  }
  deleteGuildName(path) {
    return {type: 'DELETE', path: path.concat(['guildName'])};
  }
  /**
   * @returns {string}
   */
  get guildId() {
    return this._hasGuildId ? this._guildId : JsonToString.default;
  }
  get hasGuildId() {
    return this._hasGuildId;
  }
  setGuildId(path, value) {
    return {type: 'SET', path: path.concat(['guildId']), value};
  }
  deleteGuildId(path) {
    return {type: 'DELETE', path: path.concat(['guildId'])};
  }
  /**
   * @returns {number}
   */
  get league() {
    return this._hasLeague ? this._league : JsonToInt32.default;
  }
  get hasLeague() {
    return this._hasLeague;
  }
  setLeague(path, value) {
    return {type: 'SET', path: path.concat(['league']), value};
  }
  deleteLeague(path) {
    return {type: 'DELETE', path: path.concat(['league'])};
  }
  /**
   * @returns {number}
   */
  get nextLeague() {
    return this._hasNextLeague ? this._nextLeague : JsonToInt32.default;
  }
  get hasNextLeague() {
    return this._hasNextLeague;
  }
  setNextLeague(path, value) {
    return {type: 'SET', path: path.concat(['nextLeague']), value};
  }
  deleteNextLeague(path) {
    return {type: 'DELETE', path: path.concat(['nextLeague'])};
  }
  /**
   * @returns {number}
   */
  get guildBadgeBackground() {
    return this._hasGuildBadgeBackground ? this._guildBadgeBackground : JsonToInt32.default;
  }
  get hasGuildBadgeBackground() {
    return this._hasGuildBadgeBackground;
  }
  setGuildBadgeBackground(path, value) {
    return {type: 'SET', path: path.concat(['guildBadgeBackground']), value};
  }
  deleteGuildBadgeBackground(path) {
    return {type: 'DELETE', path: path.concat(['guildBadgeBackground'])};
  }
  /**
   * @returns {number}
   */
  get guildBadgePattern() {
    return this._hasGuildBadgePattern ? this._guildBadgePattern : JsonToInt32.default;
  }
  get hasGuildBadgePattern() {
    return this._hasGuildBadgePattern;
  }
  setGuildBadgePattern(path, value) {
    return {type: 'SET', path: path.concat(['guildBadgePattern']), value};
  }
  deleteGuildBadgePattern(path) {
    return {type: 'DELETE', path: path.concat(['guildBadgePattern'])};
  }
  /**
   * @returns {number}
   */
  get guildBadgeIcon() {
    return this._hasGuildBadgeIcon ? this._guildBadgeIcon : JsonToInt32.default;
  }
  get hasGuildBadgeIcon() {
    return this._hasGuildBadgeIcon;
  }
  setGuildBadgeIcon(path, value) {
    return {type: 'SET', path: path.concat(['guildBadgeIcon']), value};
  }
  deleteGuildBadgeIcon(path) {
    return {type: 'DELETE', path: path.concat(['guildBadgeIcon'])};
  }
  /**
   * @returns {number}
   */
  get grandmaster() {
    return this._hasGrandmaster ? this._grandmaster : JsonToInt32.default;
  }
  get hasGrandmaster() {
    return this._hasGrandmaster;
  }
  setGrandmaster(path, value) {
    return {type: 'SET', path: path.concat(['grandmaster']), value};
  }
  deleteGrandmaster(path) {
    return {type: 'DELETE', path: path.concat(['grandmaster'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "uuid": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasUuid = true;
              copy._uuid = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUuid) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasUuid = false;
              copy._uuid = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "score": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasScore = true;
              copy._score = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScore) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasScore = false;
              copy._score = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "deck": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasDeck = true;
              copy._deck = TournamentDeck.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeck) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasDeck = false;
              copy._deck = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeck) {
            const copy = new TournamentPlayerScore(this);
            copy._hasDeck = true;
            copy._deck = TournamentDeck.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._deck.apply(type, path.slice(1), value);
          if (newValue === this._deck) {
            return this;
          }
          const copy = new TournamentPlayerScore(this);
          copy._deck = copy._deck.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasPlayCount = true;
              copy._playCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayCount) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasPlayCount = false;
              copy._playCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guildName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildName = true;
              copy._guildName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildName) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildName = false;
              copy._guildName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guildId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildId = true;
              copy._guildId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildId) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildId = false;
              copy._guildId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "league": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasLeague = true;
              copy._league = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeague) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasLeague = false;
              copy._league = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "nextLeague": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasNextLeague = true;
              copy._nextLeague = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNextLeague) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasNextLeague = false;
              copy._nextLeague = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guildBadgeBackground": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildBadgeBackground = true;
              copy._guildBadgeBackground = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildBadgeBackground) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildBadgeBackground = false;
              copy._guildBadgeBackground = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guildBadgePattern": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildBadgePattern = true;
              copy._guildBadgePattern = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildBadgePattern) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildBadgePattern = false;
              copy._guildBadgePattern = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "guildBadgeIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildBadgeIcon = true;
              copy._guildBadgeIcon = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGuildBadgeIcon) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasGuildBadgeIcon = false;
              copy._guildBadgeIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "grandmaster": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentPlayerScore(this);
              copy._hasGrandmaster = true;
              copy._grandmaster = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGrandmaster) {
                return this;
              }
              const copy = new TournamentPlayerScore(this);
              copy._hasGrandmaster = false;
              copy._grandmaster = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentPlayerScore} other
   * @returns {TournamentPlayerScore}
   */
  merge(other) {
    const copy = new TournamentPlayerScore(this);
    if (other._hasUuid) {
      copy._hasUuid = true;
      copy._uuid = other._uuid;
    }
    if (other._hasScore) {
      copy._hasScore = true;
      copy._score = other._score;
    }
    if (other._hasDeck) {
      if (copy._hasDeck) {
        copy._deck = copy.deck.merge(other.deck);
      } else {
        copy._deck = other._deck;
      }
      copy._hasDeck = true;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasPlayCount) {
      copy._hasPlayCount = true;
      copy._playCount = other._playCount;
    }
    if (other._hasGuildName) {
      copy._hasGuildName = true;
      copy._guildName = other._guildName;
    }
    if (other._hasGuildId) {
      copy._hasGuildId = true;
      copy._guildId = other._guildId;
    }
    if (other._hasLeague) {
      copy._hasLeague = true;
      copy._league = other._league;
    }
    if (other._hasNextLeague) {
      copy._hasNextLeague = true;
      copy._nextLeague = other._nextLeague;
    }
    if (other._hasGuildBadgeBackground) {
      copy._hasGuildBadgeBackground = true;
      copy._guildBadgeBackground = other._guildBadgeBackground;
    }
    if (other._hasGuildBadgePattern) {
      copy._hasGuildBadgePattern = true;
      copy._guildBadgePattern = other._guildBadgePattern;
    }
    if (other._hasGuildBadgeIcon) {
      copy._hasGuildBadgeIcon = true;
      copy._guildBadgeIcon = other._guildBadgeIcon;
    }
    if (other._hasGrandmaster) {
      copy._hasGrandmaster = true;
      copy._grandmaster = other._grandmaster;
    }
    return copy;
  }
}
TournamentPlayerScore.default = new TournamentPlayerScore();
class TournamentPlayerScore_Builder {
  constructor(value) {
    this._value = new TournamentPlayerScore(value);
  }
  build() {
    return new TournamentPlayerScore(this._value);
  }
  setUuid(value) {
    this._value._hasUuid = true;
    this._value._uuid = value;
    return this;
  }
  deleteUuid() {
    this._value._hasUuid = false;
    this._value._uuid = null;
    return this;
  }
  setScore(value) {
    this._value._hasScore = true;
    this._value._score = value;
    return this;
  }
  deleteScore() {
    this._value._hasScore = false;
    this._value._score = null;
    return this;
  }
  setDeck(value) {
    this._value._hasDeck = true;
    this._value._deck = value;
    return this;
  }
  deleteDeck() {
    this._value._hasDeck = false;
    this._value._deck = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setPlayCount(value) {
    this._value._hasPlayCount = true;
    this._value._playCount = value;
    return this;
  }
  deletePlayCount() {
    this._value._hasPlayCount = false;
    this._value._playCount = null;
    return this;
  }
  setGuildName(value) {
    this._value._hasGuildName = true;
    this._value._guildName = value;
    return this;
  }
  deleteGuildName() {
    this._value._hasGuildName = false;
    this._value._guildName = null;
    return this;
  }
  setGuildId(value) {
    this._value._hasGuildId = true;
    this._value._guildId = value;
    return this;
  }
  deleteGuildId() {
    this._value._hasGuildId = false;
    this._value._guildId = null;
    return this;
  }
  setLeague(value) {
    this._value._hasLeague = true;
    this._value._league = value;
    return this;
  }
  deleteLeague() {
    this._value._hasLeague = false;
    this._value._league = null;
    return this;
  }
  setNextLeague(value) {
    this._value._hasNextLeague = true;
    this._value._nextLeague = value;
    return this;
  }
  deleteNextLeague() {
    this._value._hasNextLeague = false;
    this._value._nextLeague = null;
    return this;
  }
  setGuildBadgeBackground(value) {
    this._value._hasGuildBadgeBackground = true;
    this._value._guildBadgeBackground = value;
    return this;
  }
  deleteGuildBadgeBackground() {
    this._value._hasGuildBadgeBackground = false;
    this._value._guildBadgeBackground = null;
    return this;
  }
  setGuildBadgePattern(value) {
    this._value._hasGuildBadgePattern = true;
    this._value._guildBadgePattern = value;
    return this;
  }
  deleteGuildBadgePattern() {
    this._value._hasGuildBadgePattern = false;
    this._value._guildBadgePattern = null;
    return this;
  }
  setGuildBadgeIcon(value) {
    this._value._hasGuildBadgeIcon = true;
    this._value._guildBadgeIcon = value;
    return this;
  }
  deleteGuildBadgeIcon() {
    this._value._hasGuildBadgeIcon = false;
    this._value._guildBadgeIcon = null;
    return this;
  }
  setGrandmaster(value) {
    this._value._hasGrandmaster = true;
    this._value._grandmaster = value;
    return this;
  }
  deleteGrandmaster() {
    this._value._hasGrandmaster = false;
    this._value._grandmaster = null;
    return this;
  }
}
TournamentPlayerScore.Builder = TournamentPlayerScore_Builder;
class TournamentPlayerScore_WithParent {
  /**
   * @param {TournamentPlayerScore} value
   * @param {TournamentPlayerScore_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentPlayerScore.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUuid() {
    if (this._cachedHasUuid === undefined) {
      if (this._value.hasUuid) {
        this._cachedHasUuid = true;
      } else {
        this._cachedHasUuid = this._parent ? this._parent.hasUuid : false;
      }
    }
    return this._cachedHasUuid;
  }
  get uuid() {
    if (this._cachedUuid === undefined) {
      if (this._value.hasUuid) {
        this._cachedUuid = this._value.uuid;
      } else {
        this._cachedUuid = this._parent ? this._parent.uuid : this._value.uuid;
      }
    }
    return this._cachedUuid;
  }
  get hasScore() {
    if (this._cachedHasScore === undefined) {
      if (this._value.hasScore) {
        this._cachedHasScore = true;
      } else {
        this._cachedHasScore = this._parent ? this._parent.hasScore : false;
      }
    }
    return this._cachedHasScore;
  }
  get score() {
    if (this._cachedScore === undefined) {
      if (this._value.hasScore) {
        this._cachedScore = this._value.score;
      } else {
        this._cachedScore = this._parent ? this._parent.score : this._value.score;
      }
    }
    return this._cachedScore;
  }
  get hasDeck() {
    if (this._cachedHasDeck === undefined) {
      if (this._value.hasDeck) {
        this._cachedHasDeck = true;
      } else {
        this._cachedHasDeck = this._parent ? this._parent.hasDeck : false;
      }
    }
    return this._cachedHasDeck;
  }
  get deck() {
    if (!this._cachedDeck) {
      if (this._value.hasDeck) {
        this._cachedDeck = new TournamentDeck.WithParent(this._value.deck, this._parent && this._parent.hasDeck ? this._parent.deck : null);
      } else {
        this._cachedDeck = this._parent ? new TournamentDeck.WithParent(TournamentDeck.default, this._parent.deck) : TournamentDeck.WithParent.default;
      }
    }
    return this._cachedDeck;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasPlayCount() {
    if (this._cachedHasPlayCount === undefined) {
      if (this._value.hasPlayCount) {
        this._cachedHasPlayCount = true;
      } else {
        this._cachedHasPlayCount = this._parent ? this._parent.hasPlayCount : false;
      }
    }
    return this._cachedHasPlayCount;
  }
  get playCount() {
    if (this._cachedPlayCount === undefined) {
      if (this._value.hasPlayCount) {
        this._cachedPlayCount = this._value.playCount;
      } else {
        this._cachedPlayCount = this._parent ? this._parent.playCount : this._value.playCount;
      }
    }
    return this._cachedPlayCount;
  }
  get hasGuildName() {
    if (this._cachedHasGuildName === undefined) {
      if (this._value.hasGuildName) {
        this._cachedHasGuildName = true;
      } else {
        this._cachedHasGuildName = this._parent ? this._parent.hasGuildName : false;
      }
    }
    return this._cachedHasGuildName;
  }
  get guildName() {
    if (this._cachedGuildName === undefined) {
      if (this._value.hasGuildName) {
        this._cachedGuildName = this._value.guildName;
      } else {
        this._cachedGuildName = this._parent ? this._parent.guildName : this._value.guildName;
      }
    }
    return this._cachedGuildName;
  }
  get hasGuildId() {
    if (this._cachedHasGuildId === undefined) {
      if (this._value.hasGuildId) {
        this._cachedHasGuildId = true;
      } else {
        this._cachedHasGuildId = this._parent ? this._parent.hasGuildId : false;
      }
    }
    return this._cachedHasGuildId;
  }
  get guildId() {
    if (this._cachedGuildId === undefined) {
      if (this._value.hasGuildId) {
        this._cachedGuildId = this._value.guildId;
      } else {
        this._cachedGuildId = this._parent ? this._parent.guildId : this._value.guildId;
      }
    }
    return this._cachedGuildId;
  }
  get hasLeague() {
    if (this._cachedHasLeague === undefined) {
      if (this._value.hasLeague) {
        this._cachedHasLeague = true;
      } else {
        this._cachedHasLeague = this._parent ? this._parent.hasLeague : false;
      }
    }
    return this._cachedHasLeague;
  }
  get league() {
    if (this._cachedLeague === undefined) {
      if (this._value.hasLeague) {
        this._cachedLeague = this._value.league;
      } else {
        this._cachedLeague = this._parent ? this._parent.league : this._value.league;
      }
    }
    return this._cachedLeague;
  }
  get hasNextLeague() {
    if (this._cachedHasNextLeague === undefined) {
      if (this._value.hasNextLeague) {
        this._cachedHasNextLeague = true;
      } else {
        this._cachedHasNextLeague = this._parent ? this._parent.hasNextLeague : false;
      }
    }
    return this._cachedHasNextLeague;
  }
  get nextLeague() {
    if (this._cachedNextLeague === undefined) {
      if (this._value.hasNextLeague) {
        this._cachedNextLeague = this._value.nextLeague;
      } else {
        this._cachedNextLeague = this._parent ? this._parent.nextLeague : this._value.nextLeague;
      }
    }
    return this._cachedNextLeague;
  }
  get hasGuildBadgeBackground() {
    if (this._cachedHasGuildBadgeBackground === undefined) {
      if (this._value.hasGuildBadgeBackground) {
        this._cachedHasGuildBadgeBackground = true;
      } else {
        this._cachedHasGuildBadgeBackground = this._parent ? this._parent.hasGuildBadgeBackground : false;
      }
    }
    return this._cachedHasGuildBadgeBackground;
  }
  get guildBadgeBackground() {
    if (this._cachedGuildBadgeBackground === undefined) {
      if (this._value.hasGuildBadgeBackground) {
        this._cachedGuildBadgeBackground = this._value.guildBadgeBackground;
      } else {
        this._cachedGuildBadgeBackground = this._parent ? this._parent.guildBadgeBackground : this._value.guildBadgeBackground;
      }
    }
    return this._cachedGuildBadgeBackground;
  }
  get hasGuildBadgePattern() {
    if (this._cachedHasGuildBadgePattern === undefined) {
      if (this._value.hasGuildBadgePattern) {
        this._cachedHasGuildBadgePattern = true;
      } else {
        this._cachedHasGuildBadgePattern = this._parent ? this._parent.hasGuildBadgePattern : false;
      }
    }
    return this._cachedHasGuildBadgePattern;
  }
  get guildBadgePattern() {
    if (this._cachedGuildBadgePattern === undefined) {
      if (this._value.hasGuildBadgePattern) {
        this._cachedGuildBadgePattern = this._value.guildBadgePattern;
      } else {
        this._cachedGuildBadgePattern = this._parent ? this._parent.guildBadgePattern : this._value.guildBadgePattern;
      }
    }
    return this._cachedGuildBadgePattern;
  }
  get hasGuildBadgeIcon() {
    if (this._cachedHasGuildBadgeIcon === undefined) {
      if (this._value.hasGuildBadgeIcon) {
        this._cachedHasGuildBadgeIcon = true;
      } else {
        this._cachedHasGuildBadgeIcon = this._parent ? this._parent.hasGuildBadgeIcon : false;
      }
    }
    return this._cachedHasGuildBadgeIcon;
  }
  get guildBadgeIcon() {
    if (this._cachedGuildBadgeIcon === undefined) {
      if (this._value.hasGuildBadgeIcon) {
        this._cachedGuildBadgeIcon = this._value.guildBadgeIcon;
      } else {
        this._cachedGuildBadgeIcon = this._parent ? this._parent.guildBadgeIcon : this._value.guildBadgeIcon;
      }
    }
    return this._cachedGuildBadgeIcon;
  }
  get hasGrandmaster() {
    if (this._cachedHasGrandmaster === undefined) {
      if (this._value.hasGrandmaster) {
        this._cachedHasGrandmaster = true;
      } else {
        this._cachedHasGrandmaster = this._parent ? this._parent.hasGrandmaster : false;
      }
    }
    return this._cachedHasGrandmaster;
  }
  get grandmaster() {
    if (this._cachedGrandmaster === undefined) {
      if (this._value.hasGrandmaster) {
        this._cachedGrandmaster = this._value.grandmaster;
      } else {
        this._cachedGrandmaster = this._parent ? this._parent.grandmaster : this._value.grandmaster;
      }
    }
    return this._cachedGrandmaster;
  }
  update(current, parent) {
    const result = new TournamentPlayerScore_WithParent(current, parent);
    if (this._cachedDeck && this._value.hasDeck && current.hasDeck) {
      if (this._value.deck === current.deck && this._parent === parent) {
        result._cachedDeck = this._cachedDeck;
      } else {
        result._cachedDeck = this._cachedDeck.update(current.deck, parent && parent.hasDeck ? parent.deck : null);
      }
    }
    return result;
  }
}
TournamentPlayerScore_WithParent.default = new TournamentPlayerScore_WithParent(TournamentPlayerScore.default, null);
TournamentPlayerScore.WithParent = TournamentPlayerScore_WithParent;
class TournamentPlayerScore_Descriptor {
  get uuid() {
    if (!this._uuid) {
      this._uuid = {
        name: "uuid",
        Name: "Uuid",
        number: 1,
        protoType: 9,
        protoName: "uuid",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uuid;
  }
  get score() {
    if (!this._score) {
      this._score = {
        name: "score",
        Name: "Score",
        number: 2,
        protoType: 5,
        protoName: "score",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._score;
  }
  get deck() {
    if (!this._deck) {
      this._deck = {
        name: "deck",
        Name: "Deck",
        number: 3,
        protoType: 11,
        protoName: "deck",
        type: TournamentDeck,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._deck;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 4,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get playCount() {
    if (!this._playCount) {
      this._playCount = {
        name: "playCount",
        Name: "PlayCount",
        number: 5,
        protoType: 5,
        protoName: "play_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playCount;
  }
  get guildName() {
    if (!this._guildName) {
      this._guildName = {
        name: "guildName",
        Name: "GuildName",
        number: 6,
        protoType: 9,
        protoName: "guild_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildName;
  }
  get guildId() {
    if (!this._guildId) {
      this._guildId = {
        name: "guildId",
        Name: "GuildId",
        number: 7,
        protoType: 9,
        protoName: "guild_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildId;
  }
  get league() {
    if (!this._league) {
      this._league = {
        name: "league",
        Name: "League",
        number: 8,
        protoType: 5,
        protoName: "league",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._league;
  }
  get nextLeague() {
    if (!this._nextLeague) {
      this._nextLeague = {
        name: "nextLeague",
        Name: "NextLeague",
        number: 9,
        protoType: 5,
        protoName: "next_league",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nextLeague;
  }
  get guildBadgeBackground() {
    if (!this._guildBadgeBackground) {
      this._guildBadgeBackground = {
        name: "guildBadgeBackground",
        Name: "GuildBadgeBackground",
        number: 10,
        protoType: 5,
        protoName: "guild_badge_background",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildBadgeBackground;
  }
  get guildBadgePattern() {
    if (!this._guildBadgePattern) {
      this._guildBadgePattern = {
        name: "guildBadgePattern",
        Name: "GuildBadgePattern",
        number: 11,
        protoType: 5,
        protoName: "guild_badge_pattern",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildBadgePattern;
  }
  get guildBadgeIcon() {
    if (!this._guildBadgeIcon) {
      this._guildBadgeIcon = {
        name: "guildBadgeIcon",
        Name: "GuildBadgeIcon",
        number: 12,
        protoType: 5,
        protoName: "guild_badge_icon",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._guildBadgeIcon;
  }
  get grandmaster() {
    if (!this._grandmaster) {
      this._grandmaster = {
        name: "grandmaster",
        Name: "Grandmaster",
        number: 13,
        protoType: 5,
        protoName: "grandmaster",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._grandmaster;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.uuid,
        this.score,
        this.deck,
        this.name,
        this.playCount,
        this.guildName,
        this.guildId,
        this.league,
        this.nextLeague,
        this.guildBadgeBackground,
        this.guildBadgePattern,
        this.guildBadgeIcon,
        this.grandmaster,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUuid",
        Name: "DummyOneofForUuid",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScore",
        Name: "DummyOneofForScore",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeck",
        Name: "DummyOneofForDeck",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayCount",
        Name: "DummyOneofForPlayCount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildName",
        Name: "DummyOneofForGuildName",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildId",
        Name: "DummyOneofForGuildId",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLeague",
        Name: "DummyOneofForLeague",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNextLeague",
        Name: "DummyOneofForNextLeague",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildBadgeBackground",
        Name: "DummyOneofForGuildBadgeBackground",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildBadgePattern",
        Name: "DummyOneofForGuildBadgePattern",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGuildBadgeIcon",
        Name: "DummyOneofForGuildBadgeIcon",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGrandmaster",
        Name: "DummyOneofForGrandmaster",
        fields: [
          this.fields[12],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentPlayerScore.descriptor = new TournamentPlayerScore_Descriptor();
export class TournamentAttempt {
  get descriptor() {
    return TournamentAttempt.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIndex = false;
    this._index = null;
    this._hasScore = false;
    this._score = null;
    this._hasDeck = false;
    this._deck = null;
    this._hasTime = false;
    this._time = null;
  }
  isEmpty() {
    if (this._hasIndex) return false;
    if (this._hasScore) return false;
    if (this._hasDeck && !this._deck.isEmpty()) return false;
    if (this._hasTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentAttempt) {
      return value;
    }
    return TournamentAttempt.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentAttempt();
    if (json.index != null) {
      result._hasIndex = true;
      result._index = JsonToInt32.fromJson(json.index);
    }
    if (json.score != null) {
      result._hasScore = true;
      result._score = JsonToInt32.fromJson(json.score);
    }
    if (json.deck != null) {
      result._hasDeck = true;
      result._deck = TournamentDeck.fromJson(json.deck);
    }
    if (json.time != null) {
      result._hasTime = true;
      result._time = JsonToInt32.fromJson(json.time);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIndex) {
      result.index = JsonToInt32.toJson(this._index);
    }
    if (this._hasScore) {
      result.score = JsonToInt32.toJson(this._score);
    }
    if (this._hasDeck && !this._deck.isEmpty()) {
      result.deck = TournamentDeck.toJson(this._deck);
    }
    if (this._hasTime) {
      result.time = JsonToInt32.toJson(this._time);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get index() {
    return this._hasIndex ? this._index : JsonToInt32.default;
  }
  get hasIndex() {
    return this._hasIndex;
  }
  setIndex(path, value) {
    return {type: 'SET', path: path.concat(['index']), value};
  }
  deleteIndex(path) {
    return {type: 'DELETE', path: path.concat(['index'])};
  }
  /**
   * @returns {number}
   */
  get score() {
    return this._hasScore ? this._score : JsonToInt32.default;
  }
  get hasScore() {
    return this._hasScore;
  }
  setScore(path, value) {
    return {type: 'SET', path: path.concat(['score']), value};
  }
  deleteScore(path) {
    return {type: 'DELETE', path: path.concat(['score'])};
  }
  /**
   * @returns {TournamentDeck}
   */
  get deck() {
    return this._hasDeck ? this._deck : TournamentDeck.default;
  }
  get hasDeck() {
    return this._hasDeck;
  }
  setDeck(path, value) {
    return {type: 'SET', path: path.concat(['deck']), value: value.toJson()};
  }
  deleteDeck(path) {
    return {type: 'DELETE', path: path.concat(['deck'])};
  }
  /**
   * @returns {number}
   */
  get time() {
    return this._hasTime ? this._time : JsonToInt32.default;
  }
  get hasTime() {
    return this._hasTime;
  }
  setTime(path, value) {
    return {type: 'SET', path: path.concat(['time']), value};
  }
  deleteTime(path) {
    return {type: 'DELETE', path: path.concat(['time'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "index": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentAttempt(this);
              copy._hasIndex = true;
              copy._index = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIndex) {
                return this;
              }
              const copy = new TournamentAttempt(this);
              copy._hasIndex = false;
              copy._index = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "score": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentAttempt(this);
              copy._hasScore = true;
              copy._score = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScore) {
                return this;
              }
              const copy = new TournamentAttempt(this);
              copy._hasScore = false;
              copy._score = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "deck": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentAttempt(this);
              copy._hasDeck = true;
              copy._deck = TournamentDeck.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeck) {
                return this;
              }
              const copy = new TournamentAttempt(this);
              copy._hasDeck = false;
              copy._deck = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasDeck) {
            const copy = new TournamentAttempt(this);
            copy._hasDeck = true;
            copy._deck = TournamentDeck.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._deck.apply(type, path.slice(1), value);
          if (newValue === this._deck) {
            return this;
          }
          const copy = new TournamentAttempt(this);
          copy._deck = copy._deck.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "time": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentAttempt(this);
              copy._hasTime = true;
              copy._time = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTime) {
                return this;
              }
              const copy = new TournamentAttempt(this);
              copy._hasTime = false;
              copy._time = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentAttempt} other
   * @returns {TournamentAttempt}
   */
  merge(other) {
    const copy = new TournamentAttempt(this);
    if (other._hasIndex) {
      copy._hasIndex = true;
      copy._index = other._index;
    }
    if (other._hasScore) {
      copy._hasScore = true;
      copy._score = other._score;
    }
    if (other._hasDeck) {
      if (copy._hasDeck) {
        copy._deck = copy.deck.merge(other.deck);
      } else {
        copy._deck = other._deck;
      }
      copy._hasDeck = true;
    }
    if (other._hasTime) {
      copy._hasTime = true;
      copy._time = other._time;
    }
    return copy;
  }
}
TournamentAttempt.default = new TournamentAttempt();
class TournamentAttempt_Builder {
  constructor(value) {
    this._value = new TournamentAttempt(value);
  }
  build() {
    return new TournamentAttempt(this._value);
  }
  setIndex(value) {
    this._value._hasIndex = true;
    this._value._index = value;
    return this;
  }
  deleteIndex() {
    this._value._hasIndex = false;
    this._value._index = null;
    return this;
  }
  setScore(value) {
    this._value._hasScore = true;
    this._value._score = value;
    return this;
  }
  deleteScore() {
    this._value._hasScore = false;
    this._value._score = null;
    return this;
  }
  setDeck(value) {
    this._value._hasDeck = true;
    this._value._deck = value;
    return this;
  }
  deleteDeck() {
    this._value._hasDeck = false;
    this._value._deck = null;
    return this;
  }
  setTime(value) {
    this._value._hasTime = true;
    this._value._time = value;
    return this;
  }
  deleteTime() {
    this._value._hasTime = false;
    this._value._time = null;
    return this;
  }
}
TournamentAttempt.Builder = TournamentAttempt_Builder;
class TournamentAttempt_WithParent {
  /**
   * @param {TournamentAttempt} value
   * @param {TournamentAttempt_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentAttempt.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIndex() {
    if (this._cachedHasIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedHasIndex = true;
      } else {
        this._cachedHasIndex = this._parent ? this._parent.hasIndex : false;
      }
    }
    return this._cachedHasIndex;
  }
  get index() {
    if (this._cachedIndex === undefined) {
      if (this._value.hasIndex) {
        this._cachedIndex = this._value.index;
      } else {
        this._cachedIndex = this._parent ? this._parent.index : this._value.index;
      }
    }
    return this._cachedIndex;
  }
  get hasScore() {
    if (this._cachedHasScore === undefined) {
      if (this._value.hasScore) {
        this._cachedHasScore = true;
      } else {
        this._cachedHasScore = this._parent ? this._parent.hasScore : false;
      }
    }
    return this._cachedHasScore;
  }
  get score() {
    if (this._cachedScore === undefined) {
      if (this._value.hasScore) {
        this._cachedScore = this._value.score;
      } else {
        this._cachedScore = this._parent ? this._parent.score : this._value.score;
      }
    }
    return this._cachedScore;
  }
  get hasDeck() {
    if (this._cachedHasDeck === undefined) {
      if (this._value.hasDeck) {
        this._cachedHasDeck = true;
      } else {
        this._cachedHasDeck = this._parent ? this._parent.hasDeck : false;
      }
    }
    return this._cachedHasDeck;
  }
  get deck() {
    if (!this._cachedDeck) {
      if (this._value.hasDeck) {
        this._cachedDeck = new TournamentDeck.WithParent(this._value.deck, this._parent && this._parent.hasDeck ? this._parent.deck : null);
      } else {
        this._cachedDeck = this._parent ? new TournamentDeck.WithParent(TournamentDeck.default, this._parent.deck) : TournamentDeck.WithParent.default;
      }
    }
    return this._cachedDeck;
  }
  get hasTime() {
    if (this._cachedHasTime === undefined) {
      if (this._value.hasTime) {
        this._cachedHasTime = true;
      } else {
        this._cachedHasTime = this._parent ? this._parent.hasTime : false;
      }
    }
    return this._cachedHasTime;
  }
  get time() {
    if (this._cachedTime === undefined) {
      if (this._value.hasTime) {
        this._cachedTime = this._value.time;
      } else {
        this._cachedTime = this._parent ? this._parent.time : this._value.time;
      }
    }
    return this._cachedTime;
  }
  update(current, parent) {
    const result = new TournamentAttempt_WithParent(current, parent);
    if (this._cachedDeck && this._value.hasDeck && current.hasDeck) {
      if (this._value.deck === current.deck && this._parent === parent) {
        result._cachedDeck = this._cachedDeck;
      } else {
        result._cachedDeck = this._cachedDeck.update(current.deck, parent && parent.hasDeck ? parent.deck : null);
      }
    }
    return result;
  }
}
TournamentAttempt_WithParent.default = new TournamentAttempt_WithParent(TournamentAttempt.default, null);
TournamentAttempt.WithParent = TournamentAttempt_WithParent;
class TournamentAttempt_Descriptor {
  get index() {
    if (!this._index) {
      this._index = {
        name: "index",
        Name: "Index",
        number: 1,
        protoType: 5,
        protoName: "index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._index;
  }
  get score() {
    if (!this._score) {
      this._score = {
        name: "score",
        Name: "Score",
        number: 2,
        protoType: 5,
        protoName: "score",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._score;
  }
  get deck() {
    if (!this._deck) {
      this._deck = {
        name: "deck",
        Name: "Deck",
        number: 3,
        protoType: 11,
        protoName: "deck",
        type: TournamentDeck,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._deck;
  }
  get time() {
    if (!this._time) {
      this._time = {
        name: "time",
        Name: "Time",
        number: 4,
        protoType: 5,
        protoName: "time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._time;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.index,
        this.score,
        this.deck,
        this.time,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIndex",
        Name: "DummyOneofForIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScore",
        Name: "DummyOneofForScore",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeck",
        Name: "DummyOneofForDeck",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTime",
        Name: "DummyOneofForTime",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentAttempt.descriptor = new TournamentAttempt_Descriptor();
class TournamentConfig_TournamentModeData {
  get descriptor() {
    return TournamentConfig_TournamentModeData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTotalCardLimit = false;
    this._totalCardLimit = null;
  }
  isEmpty() {
    if (this._hasTotalCardLimit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig_TournamentModeData) {
      return value;
    }
    return TournamentConfig_TournamentModeData.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig_TournamentModeData();
    if (json.totalCardLimit != null) {
      result._hasTotalCardLimit = true;
      result._totalCardLimit = JsonToInt32.fromJson(json.totalCardLimit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTotalCardLimit) {
      result.totalCardLimit = JsonToInt32.toJson(this._totalCardLimit);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get totalCardLimit() {
    return this._hasTotalCardLimit ? this._totalCardLimit : JsonToInt32.default;
  }
  get hasTotalCardLimit() {
    return this._hasTotalCardLimit;
  }
  setTotalCardLimit(path, value) {
    return {type: 'SET', path: path.concat(['totalCardLimit']), value};
  }
  deleteTotalCardLimit(path) {
    return {type: 'DELETE', path: path.concat(['totalCardLimit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "totalCardLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentModeData(this);
              copy._hasTotalCardLimit = true;
              copy._totalCardLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTotalCardLimit) {
                return this;
              }
              const copy = new TournamentConfig_TournamentModeData(this);
              copy._hasTotalCardLimit = false;
              copy._totalCardLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig_TournamentModeData} other
   * @returns {TournamentConfig_TournamentModeData}
   */
  merge(other) {
    const copy = new TournamentConfig_TournamentModeData(this);
    if (other._hasTotalCardLimit) {
      copy._hasTotalCardLimit = true;
      copy._totalCardLimit = other._totalCardLimit;
    }
    return copy;
  }
}
TournamentConfig_TournamentModeData.default = new TournamentConfig_TournamentModeData();
class TournamentConfig_TournamentModeData_Builder {
  constructor(value) {
    this._value = new TournamentConfig_TournamentModeData(value);
  }
  build() {
    return new TournamentConfig_TournamentModeData(this._value);
  }
  setTotalCardLimit(value) {
    this._value._hasTotalCardLimit = true;
    this._value._totalCardLimit = value;
    return this;
  }
  deleteTotalCardLimit() {
    this._value._hasTotalCardLimit = false;
    this._value._totalCardLimit = null;
    return this;
  }
}
TournamentConfig_TournamentModeData.Builder = TournamentConfig_TournamentModeData_Builder;
class TournamentConfig_TournamentModeData_WithParent {
  /**
   * @param {TournamentConfig_TournamentModeData} value
   * @param {TournamentConfig_TournamentModeData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig_TournamentModeData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTotalCardLimit() {
    if (this._cachedHasTotalCardLimit === undefined) {
      if (this._value.hasTotalCardLimit) {
        this._cachedHasTotalCardLimit = true;
      } else {
        this._cachedHasTotalCardLimit = this._parent ? this._parent.hasTotalCardLimit : false;
      }
    }
    return this._cachedHasTotalCardLimit;
  }
  get totalCardLimit() {
    if (this._cachedTotalCardLimit === undefined) {
      if (this._value.hasTotalCardLimit) {
        this._cachedTotalCardLimit = this._value.totalCardLimit;
      } else {
        this._cachedTotalCardLimit = this._parent ? this._parent.totalCardLimit : this._value.totalCardLimit;
      }
    }
    return this._cachedTotalCardLimit;
  }
  update(current, parent) {
    const result = new TournamentConfig_TournamentModeData_WithParent(current, parent);
    return result;
  }
}
TournamentConfig_TournamentModeData_WithParent.default = new TournamentConfig_TournamentModeData_WithParent(TournamentConfig_TournamentModeData.default, null);
TournamentConfig_TournamentModeData.WithParent = TournamentConfig_TournamentModeData_WithParent;
class TournamentConfig_TournamentModeData_Descriptor {
  get totalCardLimit() {
    if (!this._totalCardLimit) {
      this._totalCardLimit = {
        name: "totalCardLimit",
        Name: "TotalCardLimit",
        number: 1,
        protoType: 5,
        protoName: "total_card_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._totalCardLimit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.totalCardLimit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTotalCardLimit",
        Name: "DummyOneofForTotalCardLimit",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentConfig_TournamentModeData.descriptor = new TournamentConfig_TournamentModeData_Descriptor();
class TournamentConfig_TournamentRewardConfig {
  get descriptor() {
    return TournamentConfig_TournamentRewardConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMinRank = false;
    this._minRank = null;
    this._hasMaxRank = false;
    this._maxRank = null;
    this._items = [];
    this._hasDisplayName = false;
    this._displayName = null;
  }
  isEmpty() {
    if (this._hasMinRank) return false;
    if (this._hasMaxRank) return false;
    if (this._items.length > 0) return false;
    if (this._hasDisplayName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig_TournamentRewardConfig) {
      return value;
    }
    return TournamentConfig_TournamentRewardConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig_TournamentRewardConfig();
    if (json.minRank != null) {
      result._hasMinRank = true;
      result._minRank = JsonToInt32.fromJson(json.minRank);
    }
    if (json.maxRank != null) {
      result._hasMaxRank = true;
      result._maxRank = JsonToInt32.fromJson(json.maxRank);
    }
    result._items = JsonToList(json.items, TournamentRewardItem);
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMinRank) {
      result.minRank = JsonToInt32.toJson(this._minRank);
    }
    if (this._hasMaxRank) {
      result.maxRank = JsonToInt32.toJson(this._maxRank);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, TournamentRewardItem);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get minRank() {
    return this._hasMinRank ? this._minRank : JsonToInt32.default;
  }
  get hasMinRank() {
    return this._hasMinRank;
  }
  setMinRank(path, value) {
    return {type: 'SET', path: path.concat(['minRank']), value};
  }
  deleteMinRank(path) {
    return {type: 'DELETE', path: path.concat(['minRank'])};
  }
  /**
   * @returns {number}
   */
  get maxRank() {
    return this._hasMaxRank ? this._maxRank : JsonToInt32.default;
  }
  get hasMaxRank() {
    return this._hasMaxRank;
  }
  setMaxRank(path, value) {
    return {type: 'SET', path: path.concat(['maxRank']), value};
  }
  deleteMaxRank(path) {
    return {type: 'DELETE', path: path.concat(['maxRank'])};
  }
  /**
   * @returns {TournamentRewardItem[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, TournamentRewardItem)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "minRank": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._hasMinRank = true;
              copy._minRank = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMinRank) {
                return this;
              }
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._hasMinRank = false;
              copy._minRank = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxRank": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._hasMaxRank = true;
              copy._maxRank = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxRank) {
                return this;
              }
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._hasMaxRank = false;
              copy._maxRank = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(TournamentRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._items = copy._items.concat([TournamentRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig_TournamentRewardConfig(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new TournamentConfig_TournamentRewardConfig(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig_TournamentRewardConfig} other
   * @returns {TournamentConfig_TournamentRewardConfig}
   */
  merge(other) {
    const copy = new TournamentConfig_TournamentRewardConfig(this);
    if (other._hasMinRank) {
      copy._hasMinRank = true;
      copy._minRank = other._minRank;
    }
    if (other._hasMaxRank) {
      copy._hasMaxRank = true;
      copy._maxRank = other._maxRank;
    }
    copy._items = this._items.concat(other._items);
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    return copy;
  }
}
TournamentConfig_TournamentRewardConfig.default = new TournamentConfig_TournamentRewardConfig();
class TournamentConfig_TournamentRewardConfig_Builder {
  constructor(value) {
    this._value = new TournamentConfig_TournamentRewardConfig(value);
  }
  build() {
    return new TournamentConfig_TournamentRewardConfig(this._value);
  }
  setMinRank(value) {
    this._value._hasMinRank = true;
    this._value._minRank = value;
    return this;
  }
  deleteMinRank() {
    this._value._hasMinRank = false;
    this._value._minRank = null;
    return this;
  }
  setMaxRank(value) {
    this._value._hasMaxRank = true;
    this._value._maxRank = value;
    return this;
  }
  deleteMaxRank() {
    this._value._hasMaxRank = false;
    this._value._maxRank = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
}
TournamentConfig_TournamentRewardConfig.Builder = TournamentConfig_TournamentRewardConfig_Builder;
class TournamentConfig_TournamentRewardConfig_WithParent {
  /**
   * @param {TournamentConfig_TournamentRewardConfig} value
   * @param {TournamentConfig_TournamentRewardConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig_TournamentRewardConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMinRank() {
    if (this._cachedHasMinRank === undefined) {
      if (this._value.hasMinRank) {
        this._cachedHasMinRank = true;
      } else {
        this._cachedHasMinRank = this._parent ? this._parent.hasMinRank : false;
      }
    }
    return this._cachedHasMinRank;
  }
  get minRank() {
    if (this._cachedMinRank === undefined) {
      if (this._value.hasMinRank) {
        this._cachedMinRank = this._value.minRank;
      } else {
        this._cachedMinRank = this._parent ? this._parent.minRank : this._value.minRank;
      }
    }
    return this._cachedMinRank;
  }
  get hasMaxRank() {
    if (this._cachedHasMaxRank === undefined) {
      if (this._value.hasMaxRank) {
        this._cachedHasMaxRank = true;
      } else {
        this._cachedHasMaxRank = this._parent ? this._parent.hasMaxRank : false;
      }
    }
    return this._cachedHasMaxRank;
  }
  get maxRank() {
    if (this._cachedMaxRank === undefined) {
      if (this._value.hasMaxRank) {
        this._cachedMaxRank = this._value.maxRank;
      } else {
        this._cachedMaxRank = this._parent ? this._parent.maxRank : this._value.maxRank;
      }
    }
    return this._cachedMaxRank;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new TournamentRewardItem.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  update(current, parent) {
    const result = new TournamentConfig_TournamentRewardConfig_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new TournamentRewardItem.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentConfig_TournamentRewardConfig_WithParent.default = new TournamentConfig_TournamentRewardConfig_WithParent(TournamentConfig_TournamentRewardConfig.default, null);
TournamentConfig_TournamentRewardConfig.WithParent = TournamentConfig_TournamentRewardConfig_WithParent;
class TournamentConfig_TournamentRewardConfig_Descriptor {
  get minRank() {
    if (!this._minRank) {
      this._minRank = {
        name: "minRank",
        Name: "MinRank",
        number: 1,
        protoType: 5,
        protoName: "min_rank",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._minRank;
  }
  get maxRank() {
    if (!this._maxRank) {
      this._maxRank = {
        name: "maxRank",
        Name: "MaxRank",
        number: 2,
        protoType: 5,
        protoName: "max_rank",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxRank;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 3,
        protoType: 11,
        protoName: "items",
        type: TournamentRewardItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 4,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.minRank,
        this.maxRank,
        this.items,
        this.displayName,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMinRank",
        Name: "DummyOneofForMinRank",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxRank",
        Name: "DummyOneofForMaxRank",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentConfig_TournamentRewardConfig.descriptor = new TournamentConfig_TournamentRewardConfig_Descriptor();
class TournamentConfig_TournamentConsumableConfig {
  get descriptor() {
    return TournamentConfig_TournamentConsumableConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasPurchaseCost = false;
    this._purchaseCost = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasPurchaseCost && !this._purchaseCost.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig_TournamentConsumableConfig) {
      return value;
    }
    return TournamentConfig_TournamentConsumableConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig_TournamentConsumableConfig();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.purchaseCost != null) {
      result._hasPurchaseCost = true;
      result._purchaseCost = TournamentRewardItem.fromJson(json.purchaseCost);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasPurchaseCost && !this._purchaseCost.isEmpty()) {
      result.purchaseCost = TournamentRewardItem.toJson(this._purchaseCost);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {TournamentRewardItem}
   */
  get purchaseCost() {
    return this._hasPurchaseCost ? this._purchaseCost : TournamentRewardItem.default;
  }
  get hasPurchaseCost() {
    return this._hasPurchaseCost;
  }
  setPurchaseCost(path, value) {
    return {type: 'SET', path: path.concat(['purchaseCost']), value: value.toJson()};
  }
  deletePurchaseCost(path) {
    return {type: 'DELETE', path: path.concat(['purchaseCost'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentConsumableConfig(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TournamentConfig_TournamentConsumableConfig(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "purchaseCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentConsumableConfig(this);
              copy._hasPurchaseCost = true;
              copy._purchaseCost = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPurchaseCost) {
                return this;
              }
              const copy = new TournamentConfig_TournamentConsumableConfig(this);
              copy._hasPurchaseCost = false;
              copy._purchaseCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPurchaseCost) {
            const copy = new TournamentConfig_TournamentConsumableConfig(this);
            copy._hasPurchaseCost = true;
            copy._purchaseCost = TournamentRewardItem.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._purchaseCost.apply(type, path.slice(1), value);
          if (newValue === this._purchaseCost) {
            return this;
          }
          const copy = new TournamentConfig_TournamentConsumableConfig(this);
          copy._purchaseCost = copy._purchaseCost.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig_TournamentConsumableConfig} other
   * @returns {TournamentConfig_TournamentConsumableConfig}
   */
  merge(other) {
    const copy = new TournamentConfig_TournamentConsumableConfig(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasPurchaseCost) {
      if (copy._hasPurchaseCost) {
        copy._purchaseCost = copy.purchaseCost.merge(other.purchaseCost);
      } else {
        copy._purchaseCost = other._purchaseCost;
      }
      copy._hasPurchaseCost = true;
    }
    return copy;
  }
}
TournamentConfig_TournamentConsumableConfig.default = new TournamentConfig_TournamentConsumableConfig();
class TournamentConfig_TournamentConsumableConfig_Builder {
  constructor(value) {
    this._value = new TournamentConfig_TournamentConsumableConfig(value);
  }
  build() {
    return new TournamentConfig_TournamentConsumableConfig(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setPurchaseCost(value) {
    this._value._hasPurchaseCost = true;
    this._value._purchaseCost = value;
    return this;
  }
  deletePurchaseCost() {
    this._value._hasPurchaseCost = false;
    this._value._purchaseCost = null;
    return this;
  }
}
TournamentConfig_TournamentConsumableConfig.Builder = TournamentConfig_TournamentConsumableConfig_Builder;
class TournamentConfig_TournamentConsumableConfig_WithParent {
  /**
   * @param {TournamentConfig_TournamentConsumableConfig} value
   * @param {TournamentConfig_TournamentConsumableConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig_TournamentConsumableConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasPurchaseCost() {
    if (this._cachedHasPurchaseCost === undefined) {
      if (this._value.hasPurchaseCost) {
        this._cachedHasPurchaseCost = true;
      } else {
        this._cachedHasPurchaseCost = this._parent ? this._parent.hasPurchaseCost : false;
      }
    }
    return this._cachedHasPurchaseCost;
  }
  get purchaseCost() {
    if (!this._cachedPurchaseCost) {
      if (this._value.hasPurchaseCost) {
        this._cachedPurchaseCost = new TournamentRewardItem.WithParent(this._value.purchaseCost, this._parent && this._parent.hasPurchaseCost ? this._parent.purchaseCost : null);
      } else {
        this._cachedPurchaseCost = this._parent ? new TournamentRewardItem.WithParent(TournamentRewardItem.default, this._parent.purchaseCost) : TournamentRewardItem.WithParent.default;
      }
    }
    return this._cachedPurchaseCost;
  }
  update(current, parent) {
    const result = new TournamentConfig_TournamentConsumableConfig_WithParent(current, parent);
    if (this._cachedPurchaseCost && this._value.hasPurchaseCost && current.hasPurchaseCost) {
      if (this._value.purchaseCost === current.purchaseCost && this._parent === parent) {
        result._cachedPurchaseCost = this._cachedPurchaseCost;
      } else {
        result._cachedPurchaseCost = this._cachedPurchaseCost.update(current.purchaseCost, parent && parent.hasPurchaseCost ? parent.purchaseCost : null);
      }
    }
    return result;
  }
}
TournamentConfig_TournamentConsumableConfig_WithParent.default = new TournamentConfig_TournamentConsumableConfig_WithParent(TournamentConfig_TournamentConsumableConfig.default, null);
TournamentConfig_TournamentConsumableConfig.WithParent = TournamentConfig_TournamentConsumableConfig_WithParent;
class TournamentConfig_TournamentConsumableConfig_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get purchaseCost() {
    if (!this._purchaseCost) {
      this._purchaseCost = {
        name: "purchaseCost",
        Name: "PurchaseCost",
        number: 2,
        protoType: 11,
        protoName: "purchase_cost",
        type: TournamentRewardItem,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._purchaseCost;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.purchaseCost,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPurchaseCost",
        Name: "DummyOneofForPurchaseCost",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentConfig_TournamentConsumableConfig.descriptor = new TournamentConfig_TournamentConsumableConfig_Descriptor();
class TournamentConfig_TournamentLeagueConfig {
  get descriptor() {
    return TournamentConfig_TournamentLeagueConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._rewards = [];
    this._hasScoreCount = false;
    this._scoreCount = null;
    this._hasGroupSize = false;
    this._groupSize = null;
    this._hasMaxGroupSize = false;
    this._maxGroupSize = null;
    this._hasPromotionCount = false;
    this._promotionCount = null;
    this._hasDemotionCount = false;
    this._demotionCount = null;
  }
  isEmpty() {
    if (this._rewards.length > 0) return false;
    if (this._hasScoreCount) return false;
    if (this._hasGroupSize) return false;
    if (this._hasMaxGroupSize) return false;
    if (this._hasPromotionCount) return false;
    if (this._hasDemotionCount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig_TournamentLeagueConfig) {
      return value;
    }
    return TournamentConfig_TournamentLeagueConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig_TournamentLeagueConfig();
    result._rewards = JsonToList(json.rewards, TournamentConfig_TournamentRewardConfig);
    if (json.scoreCount != null) {
      result._hasScoreCount = true;
      result._scoreCount = JsonToInt32.fromJson(json.scoreCount);
    }
    if (json.groupSize != null) {
      result._hasGroupSize = true;
      result._groupSize = JsonToInt32.fromJson(json.groupSize);
    }
    if (json.maxGroupSize != null) {
      result._hasMaxGroupSize = true;
      result._maxGroupSize = JsonToInt32.fromJson(json.maxGroupSize);
    }
    if (json.promotionCount != null) {
      result._hasPromotionCount = true;
      result._promotionCount = JsonToInt32.fromJson(json.promotionCount);
    }
    if (json.demotionCount != null) {
      result._hasDemotionCount = true;
      result._demotionCount = JsonToInt32.fromJson(json.demotionCount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, TournamentConfig_TournamentRewardConfig);
    }
    if (this._hasScoreCount) {
      result.scoreCount = JsonToInt32.toJson(this._scoreCount);
    }
    if (this._hasGroupSize) {
      result.groupSize = JsonToInt32.toJson(this._groupSize);
    }
    if (this._hasMaxGroupSize) {
      result.maxGroupSize = JsonToInt32.toJson(this._maxGroupSize);
    }
    if (this._hasPromotionCount) {
      result.promotionCount = JsonToInt32.toJson(this._promotionCount);
    }
    if (this._hasDemotionCount) {
      result.demotionCount = JsonToInt32.toJson(this._demotionCount);
    }
    return result;
  }
  /**
   * @returns {TournamentConfig_TournamentRewardConfig[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, TournamentConfig_TournamentRewardConfig)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  /**
   * @returns {number}
   */
  get scoreCount() {
    return this._hasScoreCount ? this._scoreCount : JsonToInt32.default;
  }
  get hasScoreCount() {
    return this._hasScoreCount;
  }
  setScoreCount(path, value) {
    return {type: 'SET', path: path.concat(['scoreCount']), value};
  }
  deleteScoreCount(path) {
    return {type: 'DELETE', path: path.concat(['scoreCount'])};
  }
  /**
   * @returns {number}
   */
  get groupSize() {
    return this._hasGroupSize ? this._groupSize : JsonToInt32.default;
  }
  get hasGroupSize() {
    return this._hasGroupSize;
  }
  setGroupSize(path, value) {
    return {type: 'SET', path: path.concat(['groupSize']), value};
  }
  deleteGroupSize(path) {
    return {type: 'DELETE', path: path.concat(['groupSize'])};
  }
  /**
   * @returns {number}
   */
  get maxGroupSize() {
    return this._hasMaxGroupSize ? this._maxGroupSize : JsonToInt32.default;
  }
  get hasMaxGroupSize() {
    return this._hasMaxGroupSize;
  }
  setMaxGroupSize(path, value) {
    return {type: 'SET', path: path.concat(['maxGroupSize']), value};
  }
  deleteMaxGroupSize(path) {
    return {type: 'DELETE', path: path.concat(['maxGroupSize'])};
  }
  /**
   * @returns {number}
   */
  get promotionCount() {
    return this._hasPromotionCount ? this._promotionCount : JsonToInt32.default;
  }
  get hasPromotionCount() {
    return this._hasPromotionCount;
  }
  setPromotionCount(path, value) {
    return {type: 'SET', path: path.concat(['promotionCount']), value};
  }
  deletePromotionCount(path) {
    return {type: 'DELETE', path: path.concat(['promotionCount'])};
  }
  /**
   * @returns {number}
   */
  get demotionCount() {
    return this._hasDemotionCount ? this._demotionCount : JsonToInt32.default;
  }
  get hasDemotionCount() {
    return this._hasDemotionCount;
  }
  setDemotionCount(path, value) {
    return {type: 'SET', path: path.concat(['demotionCount']), value};
  }
  deleteDemotionCount(path) {
    return {type: 'DELETE', path: path.concat(['demotionCount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(TournamentConfig_TournamentRewardConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._rewards = copy._rewards.concat([TournamentConfig_TournamentRewardConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = TournamentConfig_TournamentRewardConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig_TournamentLeagueConfig(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      case "scoreCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasScoreCount = true;
              copy._scoreCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScoreCount) {
                return this;
              }
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasScoreCount = false;
              copy._scoreCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "groupSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasGroupSize = true;
              copy._groupSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGroupSize) {
                return this;
              }
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasGroupSize = false;
              copy._groupSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxGroupSize": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasMaxGroupSize = true;
              copy._maxGroupSize = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxGroupSize) {
                return this;
              }
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasMaxGroupSize = false;
              copy._maxGroupSize = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "promotionCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasPromotionCount = true;
              copy._promotionCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPromotionCount) {
                return this;
              }
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasPromotionCount = false;
              copy._promotionCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "demotionCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasDemotionCount = true;
              copy._demotionCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDemotionCount) {
                return this;
              }
              const copy = new TournamentConfig_TournamentLeagueConfig(this);
              copy._hasDemotionCount = false;
              copy._demotionCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig_TournamentLeagueConfig} other
   * @returns {TournamentConfig_TournamentLeagueConfig}
   */
  merge(other) {
    const copy = new TournamentConfig_TournamentLeagueConfig(this);
    copy._rewards = this._rewards.concat(other._rewards);
    if (other._hasScoreCount) {
      copy._hasScoreCount = true;
      copy._scoreCount = other._scoreCount;
    }
    if (other._hasGroupSize) {
      copy._hasGroupSize = true;
      copy._groupSize = other._groupSize;
    }
    if (other._hasMaxGroupSize) {
      copy._hasMaxGroupSize = true;
      copy._maxGroupSize = other._maxGroupSize;
    }
    if (other._hasPromotionCount) {
      copy._hasPromotionCount = true;
      copy._promotionCount = other._promotionCount;
    }
    if (other._hasDemotionCount) {
      copy._hasDemotionCount = true;
      copy._demotionCount = other._demotionCount;
    }
    return copy;
  }
}
TournamentConfig_TournamentLeagueConfig.default = new TournamentConfig_TournamentLeagueConfig();
class TournamentConfig_TournamentLeagueConfig_Builder {
  constructor(value) {
    this._value = new TournamentConfig_TournamentLeagueConfig(value);
  }
  build() {
    return new TournamentConfig_TournamentLeagueConfig(this._value);
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
  setScoreCount(value) {
    this._value._hasScoreCount = true;
    this._value._scoreCount = value;
    return this;
  }
  deleteScoreCount() {
    this._value._hasScoreCount = false;
    this._value._scoreCount = null;
    return this;
  }
  setGroupSize(value) {
    this._value._hasGroupSize = true;
    this._value._groupSize = value;
    return this;
  }
  deleteGroupSize() {
    this._value._hasGroupSize = false;
    this._value._groupSize = null;
    return this;
  }
  setMaxGroupSize(value) {
    this._value._hasMaxGroupSize = true;
    this._value._maxGroupSize = value;
    return this;
  }
  deleteMaxGroupSize() {
    this._value._hasMaxGroupSize = false;
    this._value._maxGroupSize = null;
    return this;
  }
  setPromotionCount(value) {
    this._value._hasPromotionCount = true;
    this._value._promotionCount = value;
    return this;
  }
  deletePromotionCount() {
    this._value._hasPromotionCount = false;
    this._value._promotionCount = null;
    return this;
  }
  setDemotionCount(value) {
    this._value._hasDemotionCount = true;
    this._value._demotionCount = value;
    return this;
  }
  deleteDemotionCount() {
    this._value._hasDemotionCount = false;
    this._value._demotionCount = null;
    return this;
  }
}
TournamentConfig_TournamentLeagueConfig.Builder = TournamentConfig_TournamentLeagueConfig_Builder;
class TournamentConfig_TournamentLeagueConfig_WithParent {
  /**
   * @param {TournamentConfig_TournamentLeagueConfig} value
   * @param {TournamentConfig_TournamentLeagueConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig_TournamentLeagueConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new TournamentConfig_TournamentRewardConfig.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  get hasScoreCount() {
    if (this._cachedHasScoreCount === undefined) {
      if (this._value.hasScoreCount) {
        this._cachedHasScoreCount = true;
      } else {
        this._cachedHasScoreCount = this._parent ? this._parent.hasScoreCount : false;
      }
    }
    return this._cachedHasScoreCount;
  }
  get scoreCount() {
    if (this._cachedScoreCount === undefined) {
      if (this._value.hasScoreCount) {
        this._cachedScoreCount = this._value.scoreCount;
      } else {
        this._cachedScoreCount = this._parent ? this._parent.scoreCount : this._value.scoreCount;
      }
    }
    return this._cachedScoreCount;
  }
  get hasGroupSize() {
    if (this._cachedHasGroupSize === undefined) {
      if (this._value.hasGroupSize) {
        this._cachedHasGroupSize = true;
      } else {
        this._cachedHasGroupSize = this._parent ? this._parent.hasGroupSize : false;
      }
    }
    return this._cachedHasGroupSize;
  }
  get groupSize() {
    if (this._cachedGroupSize === undefined) {
      if (this._value.hasGroupSize) {
        this._cachedGroupSize = this._value.groupSize;
      } else {
        this._cachedGroupSize = this._parent ? this._parent.groupSize : this._value.groupSize;
      }
    }
    return this._cachedGroupSize;
  }
  get hasMaxGroupSize() {
    if (this._cachedHasMaxGroupSize === undefined) {
      if (this._value.hasMaxGroupSize) {
        this._cachedHasMaxGroupSize = true;
      } else {
        this._cachedHasMaxGroupSize = this._parent ? this._parent.hasMaxGroupSize : false;
      }
    }
    return this._cachedHasMaxGroupSize;
  }
  get maxGroupSize() {
    if (this._cachedMaxGroupSize === undefined) {
      if (this._value.hasMaxGroupSize) {
        this._cachedMaxGroupSize = this._value.maxGroupSize;
      } else {
        this._cachedMaxGroupSize = this._parent ? this._parent.maxGroupSize : this._value.maxGroupSize;
      }
    }
    return this._cachedMaxGroupSize;
  }
  get hasPromotionCount() {
    if (this._cachedHasPromotionCount === undefined) {
      if (this._value.hasPromotionCount) {
        this._cachedHasPromotionCount = true;
      } else {
        this._cachedHasPromotionCount = this._parent ? this._parent.hasPromotionCount : false;
      }
    }
    return this._cachedHasPromotionCount;
  }
  get promotionCount() {
    if (this._cachedPromotionCount === undefined) {
      if (this._value.hasPromotionCount) {
        this._cachedPromotionCount = this._value.promotionCount;
      } else {
        this._cachedPromotionCount = this._parent ? this._parent.promotionCount : this._value.promotionCount;
      }
    }
    return this._cachedPromotionCount;
  }
  get hasDemotionCount() {
    if (this._cachedHasDemotionCount === undefined) {
      if (this._value.hasDemotionCount) {
        this._cachedHasDemotionCount = true;
      } else {
        this._cachedHasDemotionCount = this._parent ? this._parent.hasDemotionCount : false;
      }
    }
    return this._cachedHasDemotionCount;
  }
  get demotionCount() {
    if (this._cachedDemotionCount === undefined) {
      if (this._value.hasDemotionCount) {
        this._cachedDemotionCount = this._value.demotionCount;
      } else {
        this._cachedDemotionCount = this._parent ? this._parent.demotionCount : this._value.demotionCount;
      }
    }
    return this._cachedDemotionCount;
  }
  update(current, parent) {
    const result = new TournamentConfig_TournamentLeagueConfig_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new TournamentConfig_TournamentRewardConfig.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentConfig_TournamentLeagueConfig_WithParent.default = new TournamentConfig_TournamentLeagueConfig_WithParent(TournamentConfig_TournamentLeagueConfig.default, null);
TournamentConfig_TournamentLeagueConfig.WithParent = TournamentConfig_TournamentLeagueConfig_WithParent;
class TournamentConfig_TournamentLeagueConfig_Descriptor {
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 1,
        protoType: 11,
        protoName: "rewards",
        type: TournamentConfig_TournamentRewardConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get scoreCount() {
    if (!this._scoreCount) {
      this._scoreCount = {
        name: "scoreCount",
        Name: "ScoreCount",
        number: 2,
        protoType: 5,
        protoName: "score_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scoreCount;
  }
  get groupSize() {
    if (!this._groupSize) {
      this._groupSize = {
        name: "groupSize",
        Name: "GroupSize",
        number: 3,
        protoType: 5,
        protoName: "group_size",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._groupSize;
  }
  get maxGroupSize() {
    if (!this._maxGroupSize) {
      this._maxGroupSize = {
        name: "maxGroupSize",
        Name: "MaxGroupSize",
        number: 4,
        protoType: 5,
        protoName: "max_group_size",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxGroupSize;
  }
  get promotionCount() {
    if (!this._promotionCount) {
      this._promotionCount = {
        name: "promotionCount",
        Name: "PromotionCount",
        number: 5,
        protoType: 5,
        protoName: "promotion_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionCount;
  }
  get demotionCount() {
    if (!this._demotionCount) {
      this._demotionCount = {
        name: "demotionCount",
        Name: "DemotionCount",
        number: 6,
        protoType: 5,
        protoName: "demotion_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._demotionCount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.rewards,
        this.scoreCount,
        this.groupSize,
        this.maxGroupSize,
        this.promotionCount,
        this.demotionCount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForScoreCount",
        Name: "DummyOneofForScoreCount",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGroupSize",
        Name: "DummyOneofForGroupSize",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxGroupSize",
        Name: "DummyOneofForMaxGroupSize",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPromotionCount",
        Name: "DummyOneofForPromotionCount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDemotionCount",
        Name: "DummyOneofForDemotionCount",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentConfig_TournamentLeagueConfig.descriptor = new TournamentConfig_TournamentLeagueConfig_Descriptor();
class TournamentConfig_TournamentMarketConfig_TournamentStoreTab {
  get descriptor() {
    return TournamentConfig_TournamentMarketConfig_TournamentStoreTab.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStoreTab = false;
    this._storeTab = null;
    this._hasTokenKey = false;
    this._tokenKey = null;
    this._hasResetTokenWhenOpen = false;
    this._resetTokenWhenOpen = null;
  }
  isEmpty() {
    if (this._hasStoreTab) return false;
    if (this._hasTokenKey) return false;
    if (this._hasResetTokenWhenOpen) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig_TournamentMarketConfig_TournamentStoreTab) {
      return value;
    }
    return TournamentConfig_TournamentMarketConfig_TournamentStoreTab.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab();
    if (json.storeTab != null) {
      result._hasStoreTab = true;
      result._storeTab = JsonToString.fromJson(json.storeTab);
    }
    if (json.tokenKey != null) {
      result._hasTokenKey = true;
      result._tokenKey = JsonToString.fromJson(json.tokenKey);
    }
    if (json.resetTokenWhenOpen != null) {
      result._hasResetTokenWhenOpen = true;
      result._resetTokenWhenOpen = JsonToBoolean.fromJson(json.resetTokenWhenOpen);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStoreTab) {
      result.storeTab = JsonToString.toJson(this._storeTab);
    }
    if (this._hasTokenKey) {
      result.tokenKey = JsonToString.toJson(this._tokenKey);
    }
    if (this._hasResetTokenWhenOpen) {
      result.resetTokenWhenOpen = JsonToBoolean.toJson(this._resetTokenWhenOpen);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get storeTab() {
    return this._hasStoreTab ? this._storeTab : JsonToString.default;
  }
  get hasStoreTab() {
    return this._hasStoreTab;
  }
  setStoreTab(path, value) {
    return {type: 'SET', path: path.concat(['storeTab']), value};
  }
  deleteStoreTab(path) {
    return {type: 'DELETE', path: path.concat(['storeTab'])};
  }
  /**
   * @returns {string}
   */
  get tokenKey() {
    return this._hasTokenKey ? this._tokenKey : JsonToString.default;
  }
  get hasTokenKey() {
    return this._hasTokenKey;
  }
  setTokenKey(path, value) {
    return {type: 'SET', path: path.concat(['tokenKey']), value};
  }
  deleteTokenKey(path) {
    return {type: 'DELETE', path: path.concat(['tokenKey'])};
  }
  /**
   * @returns {boolean}
   */
  get resetTokenWhenOpen() {
    return this._hasResetTokenWhenOpen ? this._resetTokenWhenOpen : JsonToBoolean.default;
  }
  get hasResetTokenWhenOpen() {
    return this._hasResetTokenWhenOpen;
  }
  setResetTokenWhenOpen(path, value) {
    return {type: 'SET', path: path.concat(['resetTokenWhenOpen']), value};
  }
  deleteResetTokenWhenOpen(path) {
    return {type: 'DELETE', path: path.concat(['resetTokenWhenOpen'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storeTab": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
              copy._hasStoreTab = true;
              copy._storeTab = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStoreTab) {
                return this;
              }
              const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
              copy._hasStoreTab = false;
              copy._storeTab = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tokenKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
              copy._hasTokenKey = true;
              copy._tokenKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTokenKey) {
                return this;
              }
              const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
              copy._hasTokenKey = false;
              copy._tokenKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "resetTokenWhenOpen": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
              copy._hasResetTokenWhenOpen = true;
              copy._resetTokenWhenOpen = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetTokenWhenOpen) {
                return this;
              }
              const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
              copy._hasResetTokenWhenOpen = false;
              copy._resetTokenWhenOpen = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig_TournamentMarketConfig_TournamentStoreTab} other
   * @returns {TournamentConfig_TournamentMarketConfig_TournamentStoreTab}
   */
  merge(other) {
    const copy = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this);
    if (other._hasStoreTab) {
      copy._hasStoreTab = true;
      copy._storeTab = other._storeTab;
    }
    if (other._hasTokenKey) {
      copy._hasTokenKey = true;
      copy._tokenKey = other._tokenKey;
    }
    if (other._hasResetTokenWhenOpen) {
      copy._hasResetTokenWhenOpen = true;
      copy._resetTokenWhenOpen = other._resetTokenWhenOpen;
    }
    return copy;
  }
}
TournamentConfig_TournamentMarketConfig_TournamentStoreTab.default = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab();
class TournamentConfig_TournamentMarketConfig_TournamentStoreTab_Builder {
  constructor(value) {
    this._value = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(value);
  }
  build() {
    return new TournamentConfig_TournamentMarketConfig_TournamentStoreTab(this._value);
  }
  setStoreTab(value) {
    this._value._hasStoreTab = true;
    this._value._storeTab = value;
    return this;
  }
  deleteStoreTab() {
    this._value._hasStoreTab = false;
    this._value._storeTab = null;
    return this;
  }
  setTokenKey(value) {
    this._value._hasTokenKey = true;
    this._value._tokenKey = value;
    return this;
  }
  deleteTokenKey() {
    this._value._hasTokenKey = false;
    this._value._tokenKey = null;
    return this;
  }
  setResetTokenWhenOpen(value) {
    this._value._hasResetTokenWhenOpen = true;
    this._value._resetTokenWhenOpen = value;
    return this;
  }
  deleteResetTokenWhenOpen() {
    this._value._hasResetTokenWhenOpen = false;
    this._value._resetTokenWhenOpen = null;
    return this;
  }
}
TournamentConfig_TournamentMarketConfig_TournamentStoreTab.Builder = TournamentConfig_TournamentMarketConfig_TournamentStoreTab_Builder;
class TournamentConfig_TournamentMarketConfig_TournamentStoreTab_WithParent {
  /**
   * @param {TournamentConfig_TournamentMarketConfig_TournamentStoreTab} value
   * @param {TournamentConfig_TournamentMarketConfig_TournamentStoreTab_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig_TournamentMarketConfig_TournamentStoreTab.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStoreTab() {
    if (this._cachedHasStoreTab === undefined) {
      if (this._value.hasStoreTab) {
        this._cachedHasStoreTab = true;
      } else {
        this._cachedHasStoreTab = this._parent ? this._parent.hasStoreTab : false;
      }
    }
    return this._cachedHasStoreTab;
  }
  get storeTab() {
    if (this._cachedStoreTab === undefined) {
      if (this._value.hasStoreTab) {
        this._cachedStoreTab = this._value.storeTab;
      } else {
        this._cachedStoreTab = this._parent ? this._parent.storeTab : this._value.storeTab;
      }
    }
    return this._cachedStoreTab;
  }
  get hasTokenKey() {
    if (this._cachedHasTokenKey === undefined) {
      if (this._value.hasTokenKey) {
        this._cachedHasTokenKey = true;
      } else {
        this._cachedHasTokenKey = this._parent ? this._parent.hasTokenKey : false;
      }
    }
    return this._cachedHasTokenKey;
  }
  get tokenKey() {
    if (this._cachedTokenKey === undefined) {
      if (this._value.hasTokenKey) {
        this._cachedTokenKey = this._value.tokenKey;
      } else {
        this._cachedTokenKey = this._parent ? this._parent.tokenKey : this._value.tokenKey;
      }
    }
    return this._cachedTokenKey;
  }
  get hasResetTokenWhenOpen() {
    if (this._cachedHasResetTokenWhenOpen === undefined) {
      if (this._value.hasResetTokenWhenOpen) {
        this._cachedHasResetTokenWhenOpen = true;
      } else {
        this._cachedHasResetTokenWhenOpen = this._parent ? this._parent.hasResetTokenWhenOpen : false;
      }
    }
    return this._cachedHasResetTokenWhenOpen;
  }
  get resetTokenWhenOpen() {
    if (this._cachedResetTokenWhenOpen === undefined) {
      if (this._value.hasResetTokenWhenOpen) {
        this._cachedResetTokenWhenOpen = this._value.resetTokenWhenOpen;
      } else {
        this._cachedResetTokenWhenOpen = this._parent ? this._parent.resetTokenWhenOpen : this._value.resetTokenWhenOpen;
      }
    }
    return this._cachedResetTokenWhenOpen;
  }
  update(current, parent) {
    const result = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab_WithParent(current, parent);
    return result;
  }
}
TournamentConfig_TournamentMarketConfig_TournamentStoreTab_WithParent.default = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab_WithParent(TournamentConfig_TournamentMarketConfig_TournamentStoreTab.default, null);
TournamentConfig_TournamentMarketConfig_TournamentStoreTab.WithParent = TournamentConfig_TournamentMarketConfig_TournamentStoreTab_WithParent;
class TournamentConfig_TournamentMarketConfig_TournamentStoreTab_Descriptor {
  get storeTab() {
    if (!this._storeTab) {
      this._storeTab = {
        name: "storeTab",
        Name: "StoreTab",
        number: 1,
        protoType: 9,
        protoName: "store_tab",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storeTab;
  }
  get tokenKey() {
    if (!this._tokenKey) {
      this._tokenKey = {
        name: "tokenKey",
        Name: "TokenKey",
        number: 2,
        protoType: 9,
        protoName: "token_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tokenKey;
  }
  get resetTokenWhenOpen() {
    if (!this._resetTokenWhenOpen) {
      this._resetTokenWhenOpen = {
        name: "resetTokenWhenOpen",
        Name: "ResetTokenWhenOpen",
        number: 3,
        protoType: 8,
        protoName: "reset_token_when_open",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetTokenWhenOpen;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storeTab,
        this.tokenKey,
        this.resetTokenWhenOpen,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStoreTab",
        Name: "DummyOneofForStoreTab",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTokenKey",
        Name: "DummyOneofForTokenKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForResetTokenWhenOpen",
        Name: "DummyOneofForResetTokenWhenOpen",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentConfig_TournamentMarketConfig_TournamentStoreTab.descriptor = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab_Descriptor();
class TournamentConfig_TournamentMarketConfig {
  get descriptor() {
    return TournamentConfig_TournamentMarketConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._storeTabs = [];
  }
  isEmpty() {
    if (this._storeTabs.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig_TournamentMarketConfig) {
      return value;
    }
    return TournamentConfig_TournamentMarketConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig_TournamentMarketConfig();
    result._storeTabs = JsonToList(json.storeTabs, TournamentConfig_TournamentMarketConfig_TournamentStoreTab);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._storeTabs.length > 0) {
      result.storeTabs = ArrayToJson(this._storeTabs, TournamentConfig_TournamentMarketConfig_TournamentStoreTab);
    }
    return result;
  }
  /**
   * @returns {TournamentConfig_TournamentMarketConfig_TournamentStoreTab[]}
   */
  get storeTabs() {
    return this._storeTabs;
  }
  addStoreTabs(path, value) {
    return {type: 'ADD', path: path.concat(['storeTabs']), value: value.toJson()};
  }
  setStoreTabs(path, value) {
    return {type: 'SET', path: path.concat(['storeTabs']), value: ArrayToJson(value, TournamentConfig_TournamentMarketConfig_TournamentStoreTab)};
  }
  setStoreTabsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['storeTabs', key]), value: value.toJson()};
  }
  deleteStoreTabs(path) {
    return {type: 'DELETE', path: path.concat(['storeTabs'])};
  }
  deleteStoreTabsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['storeTabs', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "storeTabs": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentMarketConfig(this);
              copy._storeTabs = [];        for (let i of value) {
                copy._storeTabs.push(TournamentConfig_TournamentMarketConfig_TournamentStoreTab.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig_TournamentMarketConfig(this);
              copy._storeTabs = copy._storeTabs.concat([TournamentConfig_TournamentMarketConfig_TournamentStoreTab.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._storeTabs.length === 0) {
                return this;
              }
              const copy = new TournamentConfig_TournamentMarketConfig(this);
              copy._storeTabs = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._storeTabs.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig_TournamentMarketConfig(this);
              copy._storeTabs = copy._storeTabs.slice();
              copy._storeTabs[path[1]] = TournamentConfig_TournamentMarketConfig_TournamentStoreTab.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig_TournamentMarketConfig(this);
              copy._storeTabs = copy._storeTabs.slice(0, path[1]).concat(copy._storeTabs.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._storeTabs.length) {
            return this;
          }
          const oldValue = this._storeTabs[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig_TournamentMarketConfig(this);
          copy._storeTabs = copy._storeTabs.slice();
          copy._storeTabs[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig_TournamentMarketConfig} other
   * @returns {TournamentConfig_TournamentMarketConfig}
   */
  merge(other) {
    const copy = new TournamentConfig_TournamentMarketConfig(this);
    copy._storeTabs = this._storeTabs.concat(other._storeTabs);
    return copy;
  }
}
TournamentConfig_TournamentMarketConfig.default = new TournamentConfig_TournamentMarketConfig();
TournamentConfig_TournamentMarketConfig.TournamentStoreTab = TournamentConfig_TournamentMarketConfig_TournamentStoreTab;
class TournamentConfig_TournamentMarketConfig_Builder {
  constructor(value) {
    this._value = new TournamentConfig_TournamentMarketConfig(value);
  }
  build() {
    return new TournamentConfig_TournamentMarketConfig(this._value);
  }
  addAllStoreTabs(values) {
    this._value._storeTabs = this._value._storeTabs.concat(values);
    return this;
  }
  addStoreTabs(value) {
    this._value._storeTabs = this._value._storeTabs.concat([value]);
    return this;
  }
  setStoreTabs(index, value) {
    this._value._storeTabs = this._value._storeTabs.concat();
    this._value._storeTabs[index] = value;
    return this;
  }
  clearStoreTabs() {
    this._value._storeTabs = [];
    return this;
  }
}
TournamentConfig_TournamentMarketConfig.Builder = TournamentConfig_TournamentMarketConfig_Builder;
class TournamentConfig_TournamentMarketConfig_WithParent {
  /**
   * @param {TournamentConfig_TournamentMarketConfig} value
   * @param {TournamentConfig_TournamentMarketConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig_TournamentMarketConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfStoreTabs() {
    if (!this._selfStoreTabs) {
      this._selfStoreTabs = [];
      for (let i of this._value.storeTabs) {
        this._selfStoreTabs.push(new TournamentConfig_TournamentMarketConfig_TournamentStoreTab.WithParent(i, null));
      }
    }
    return this._selfStoreTabs;
  }
  get inherentStoreTabs() {
    if (!this._inherentStoreTabs) {
      this._inherentStoreTabs = this._parent ? this._parent.storeTabs : [];
    }
    return this._inherentStoreTabs;
  }
  get storeTabs() {
    if (!this._allStoreTabs) {
      this._allStoreTabs = this._parent ? this._parent.storeTabs.concat(this.selfStoreTabs) : this.selfStoreTabs;
    }
    return this._allStoreTabs;
  }
  update(current, parent) {
    const result = new TournamentConfig_TournamentMarketConfig_WithParent(current, parent);
    if (this._selfStoreTabs) {
      if (this._value.storeTabs === current.storeTabs) {
        result._selfStoreTabs = this._selfStoreTabs;
      } else {
        result._selfStoreTabs = [];
        for (let i = 0; i < current.storeTabs.length; i++) {
          const oldValue = this._value.storeTabs[i];
          if (oldValue) {
            const oldCache = this._selfStoreTabs[i];
            if (oldValue === current.storeTabs[i]) {
              result._selfStoreTabs[i] = oldCache;
            } else {
              result._selfStoreTabs[i] = oldCache.update(current.storeTabs[i], null);
            }
          } else {
            result._selfStoreTabs[i] = new TournamentConfig_TournamentMarketConfig_TournamentStoreTab.WithParent(current.storeTabs[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentConfig_TournamentMarketConfig_WithParent.default = new TournamentConfig_TournamentMarketConfig_WithParent(TournamentConfig_TournamentMarketConfig.default, null);
TournamentConfig_TournamentMarketConfig.WithParent = TournamentConfig_TournamentMarketConfig_WithParent;
class TournamentConfig_TournamentMarketConfig_Descriptor {
  get storeTabs() {
    if (!this._storeTabs) {
      this._storeTabs = {
        name: "storeTabs",
        Name: "StoreTabs",
        number: 1,
        protoType: 11,
        protoName: "store_tabs",
        type: TournamentConfig_TournamentMarketConfig_TournamentStoreTab,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._storeTabs;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.storeTabs,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TournamentConfig_TournamentMarketConfig.descriptor = new TournamentConfig_TournamentMarketConfig_Descriptor();
export class TournamentConfig {
  get descriptor() {
    return TournamentConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMap = false;
    this._map = null;
    this._rewards = [];
    this._gmRewards = [];
    this._hasStartTime = false;
    this._startTime = null;
    this._hasEndTime = false;
    this._endTime = null;
    this._hasName = false;
    this._name = null;
    this._hasScoreCount = false;
    this._scoreCount = null;
    this._hasCardBoostInfo = false;
    this._cardBoostInfo = null;
    this._hasSeason = false;
    this._season = null;
    this._leagueConfig = [];
    this._seasonData = [];
    this._consumableConfig = [];
    this._hasQuestData = false;
    this._questData = null;
    this._hasTournamentMode = false;
    this._tournamentMode = null;
    this._hasTournamentModeData = false;
    this._tournamentModeData = null;
    this._hasTournamentMarketConfig = false;
    this._tournamentMarketConfig = null;
  }
  isEmpty() {
    if (this._hasMap) return false;
    if (this._rewards.length > 0) return false;
    if (this._gmRewards.length > 0) return false;
    if (this._hasStartTime) return false;
    if (this._hasEndTime) return false;
    if (this._hasName) return false;
    if (this._hasScoreCount) return false;
    if (this._hasCardBoostInfo && !this._cardBoostInfo.isEmpty()) return false;
    if (this._hasSeason) return false;
    if (this._leagueConfig.length > 0) return false;
    if (this._seasonData.length > 0) return false;
    if (this._consumableConfig.length > 0) return false;
    if (this._hasQuestData && !this._questData.isEmpty()) return false;
    if (this._hasTournamentMode) return false;
    if (this._hasTournamentModeData && !this._tournamentModeData.isEmpty()) return false;
    if (this._hasTournamentMarketConfig && !this._tournamentMarketConfig.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentConfig) {
      return value;
    }
    return TournamentConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentConfig();
    if (json.map != null) {
      result._hasMap = true;
      result._map = JsonToString.fromJson(json.map);
    }
    result._rewards = JsonToList(json.rewards, TournamentConfig_TournamentRewardConfig);
    result._gmRewards = JsonToList(json.gmRewards, TournamentRewardItem);
    if (json.startTime != null) {
      result._hasStartTime = true;
      result._startTime = JsonToInt32.fromJson(json.startTime);
    }
    if (json.endTime != null) {
      result._hasEndTime = true;
      result._endTime = JsonToInt32.fromJson(json.endTime);
    }
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.scoreCount != null) {
      result._hasScoreCount = true;
      result._scoreCount = JsonToInt32.fromJson(json.scoreCount);
    }
    if (json.cardBoostInfo != null) {
      result._hasCardBoostInfo = true;
      result._cardBoostInfo = dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.fromJson(json.cardBoostInfo);
    }
    if (json.season != null) {
      result._hasSeason = true;
      result._season = JsonToInt32.fromJson(json.season);
    }
    result._leagueConfig = JsonToList(json.leagueConfig, TournamentConfig_TournamentLeagueConfig);
    result._seasonData = JsonToList(json.seasonData, TournamentSeason);
    result._consumableConfig = JsonToList(json.consumableConfig, TournamentConfig_TournamentConsumableConfig);
    if (json.questData != null) {
      result._hasQuestData = true;
      result._questData = TournamentQuestData.fromJson(json.questData);
    }
    if (json.tournamentMode != null) {
      result._hasTournamentMode = true;
      result._tournamentMode = TournamentMode.fromJson(json.tournamentMode);
    }
    if (json.tournamentModeData != null) {
      result._hasTournamentModeData = true;
      result._tournamentModeData = TournamentConfig_TournamentModeData.fromJson(json.tournamentModeData);
    }
    if (json.tournamentMarketConfig != null) {
      result._hasTournamentMarketConfig = true;
      result._tournamentMarketConfig = TournamentConfig_TournamentMarketConfig.fromJson(json.tournamentMarketConfig);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMap) {
      result.map = JsonToString.toJson(this._map);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, TournamentConfig_TournamentRewardConfig);
    }
    if (this._gmRewards.length > 0) {
      result.gmRewards = ArrayToJson(this._gmRewards, TournamentRewardItem);
    }
    if (this._hasStartTime) {
      result.startTime = JsonToInt32.toJson(this._startTime);
    }
    if (this._hasEndTime) {
      result.endTime = JsonToInt32.toJson(this._endTime);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasScoreCount) {
      result.scoreCount = JsonToInt32.toJson(this._scoreCount);
    }
    if (this._hasCardBoostInfo && !this._cardBoostInfo.isEmpty()) {
      result.cardBoostInfo = dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.toJson(this._cardBoostInfo);
    }
    if (this._hasSeason) {
      result.season = JsonToInt32.toJson(this._season);
    }
    if (this._leagueConfig.length > 0) {
      result.leagueConfig = ArrayToJson(this._leagueConfig, TournamentConfig_TournamentLeagueConfig);
    }
    if (this._seasonData.length > 0) {
      result.seasonData = ArrayToJson(this._seasonData, TournamentSeason);
    }
    if (this._consumableConfig.length > 0) {
      result.consumableConfig = ArrayToJson(this._consumableConfig, TournamentConfig_TournamentConsumableConfig);
    }
    if (this._hasQuestData && !this._questData.isEmpty()) {
      result.questData = TournamentQuestData.toJson(this._questData);
    }
    if (this._hasTournamentMode) {
      result.tournamentMode = TournamentMode.toJson(this._tournamentMode);
    }
    if (this._hasTournamentModeData && !this._tournamentModeData.isEmpty()) {
      result.tournamentModeData = TournamentConfig_TournamentModeData.toJson(this._tournamentModeData);
    }
    if (this._hasTournamentMarketConfig && !this._tournamentMarketConfig.isEmpty()) {
      result.tournamentMarketConfig = TournamentConfig_TournamentMarketConfig.toJson(this._tournamentMarketConfig);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get map() {
    return this._hasMap ? this._map : JsonToString.default;
  }
  get hasMap() {
    return this._hasMap;
  }
  setMap(path, value) {
    return {type: 'SET', path: path.concat(['map']), value};
  }
  deleteMap(path) {
    return {type: 'DELETE', path: path.concat(['map'])};
  }
  /**
   * @returns {TournamentConfig_TournamentRewardConfig[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, TournamentConfig_TournamentRewardConfig)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  /**
   * @returns {TournamentRewardItem[]}
   */
  get gmRewards() {
    return this._gmRewards;
  }
  addGmRewards(path, value) {
    return {type: 'ADD', path: path.concat(['gmRewards']), value: value.toJson()};
  }
  setGmRewards(path, value) {
    return {type: 'SET', path: path.concat(['gmRewards']), value: ArrayToJson(value, TournamentRewardItem)};
  }
  setGmRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['gmRewards', key]), value: value.toJson()};
  }
  deleteGmRewards(path) {
    return {type: 'DELETE', path: path.concat(['gmRewards'])};
  }
  deleteGmRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['gmRewards', key])};
  }
  /**
   * @returns {number}
   */
  get startTime() {
    return this._hasStartTime ? this._startTime : JsonToInt32.default;
  }
  get hasStartTime() {
    return this._hasStartTime;
  }
  setStartTime(path, value) {
    return {type: 'SET', path: path.concat(['startTime']), value};
  }
  deleteStartTime(path) {
    return {type: 'DELETE', path: path.concat(['startTime'])};
  }
  /**
   * @returns {number}
   */
  get endTime() {
    return this._hasEndTime ? this._endTime : JsonToInt32.default;
  }
  get hasEndTime() {
    return this._hasEndTime;
  }
  setEndTime(path, value) {
    return {type: 'SET', path: path.concat(['endTime']), value};
  }
  deleteEndTime(path) {
    return {type: 'DELETE', path: path.concat(['endTime'])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get scoreCount() {
    return this._hasScoreCount ? this._scoreCount : JsonToInt32.default;
  }
  get hasScoreCount() {
    return this._hasScoreCount;
  }
  setScoreCount(path, value) {
    return {type: 'SET', path: path.concat(['scoreCount']), value};
  }
  deleteScoreCount(path) {
    return {type: 'DELETE', path: path.concat(['scoreCount'])};
  }
  /**
   * @returns {dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo}
   */
  get cardBoostInfo() {
    return this._hasCardBoostInfo ? this._cardBoostInfo : dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.default;
  }
  get hasCardBoostInfo() {
    return this._hasCardBoostInfo;
  }
  setCardBoostInfo(path, value) {
    return {type: 'SET', path: path.concat(['cardBoostInfo']), value: value.toJson()};
  }
  deleteCardBoostInfo(path) {
    return {type: 'DELETE', path: path.concat(['cardBoostInfo'])};
  }
  /**
   * @returns {number}
   */
  get season() {
    return this._hasSeason ? this._season : JsonToInt32.default;
  }
  get hasSeason() {
    return this._hasSeason;
  }
  setSeason(path, value) {
    return {type: 'SET', path: path.concat(['season']), value};
  }
  deleteSeason(path) {
    return {type: 'DELETE', path: path.concat(['season'])};
  }
  /**
   * @returns {TournamentConfig_TournamentLeagueConfig[]}
   */
  get leagueConfig() {
    return this._leagueConfig;
  }
  addLeagueConfig(path, value) {
    return {type: 'ADD', path: path.concat(['leagueConfig']), value: value.toJson()};
  }
  setLeagueConfig(path, value) {
    return {type: 'SET', path: path.concat(['leagueConfig']), value: ArrayToJson(value, TournamentConfig_TournamentLeagueConfig)};
  }
  setLeagueConfigByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['leagueConfig', key]), value: value.toJson()};
  }
  deleteLeagueConfig(path) {
    return {type: 'DELETE', path: path.concat(['leagueConfig'])};
  }
  deleteLeagueConfigByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['leagueConfig', key])};
  }
  /**
   * @returns {TournamentSeason[]}
   */
  get seasonData() {
    return this._seasonData;
  }
  addSeasonData(path, value) {
    return {type: 'ADD', path: path.concat(['seasonData']), value: value.toJson()};
  }
  setSeasonData(path, value) {
    return {type: 'SET', path: path.concat(['seasonData']), value: ArrayToJson(value, TournamentSeason)};
  }
  setSeasonDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['seasonData', key]), value: value.toJson()};
  }
  deleteSeasonData(path) {
    return {type: 'DELETE', path: path.concat(['seasonData'])};
  }
  deleteSeasonDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['seasonData', key])};
  }
  /**
   * @returns {TournamentConfig_TournamentConsumableConfig[]}
   */
  get consumableConfig() {
    return this._consumableConfig;
  }
  addConsumableConfig(path, value) {
    return {type: 'ADD', path: path.concat(['consumableConfig']), value: value.toJson()};
  }
  setConsumableConfig(path, value) {
    return {type: 'SET', path: path.concat(['consumableConfig']), value: ArrayToJson(value, TournamentConfig_TournamentConsumableConfig)};
  }
  setConsumableConfigByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['consumableConfig', key]), value: value.toJson()};
  }
  deleteConsumableConfig(path) {
    return {type: 'DELETE', path: path.concat(['consumableConfig'])};
  }
  deleteConsumableConfigByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['consumableConfig', key])};
  }
  /**
   * @returns {TournamentQuestData}
   */
  get questData() {
    return this._hasQuestData ? this._questData : TournamentQuestData.default;
  }
  get hasQuestData() {
    return this._hasQuestData;
  }
  setQuestData(path, value) {
    return {type: 'SET', path: path.concat(['questData']), value: value.toJson()};
  }
  deleteQuestData(path) {
    return {type: 'DELETE', path: path.concat(['questData'])};
  }
  /**
   * @returns {number}
   */
  get tournamentMode() {
    return this._hasTournamentMode ? this._tournamentMode : TournamentMode.default;
  }
  get hasTournamentMode() {
    return this._hasTournamentMode;
  }
  setTournamentMode(path, value) {
    return {type: 'SET', path: path.concat(['tournamentMode']), value};
  }
  deleteTournamentMode(path) {
    return {type: 'DELETE', path: path.concat(['tournamentMode'])};
  }
  /**
   * @returns {TournamentConfig_TournamentModeData}
   */
  get tournamentModeData() {
    return this._hasTournamentModeData ? this._tournamentModeData : TournamentConfig_TournamentModeData.default;
  }
  get hasTournamentModeData() {
    return this._hasTournamentModeData;
  }
  setTournamentModeData(path, value) {
    return {type: 'SET', path: path.concat(['tournamentModeData']), value: value.toJson()};
  }
  deleteTournamentModeData(path) {
    return {type: 'DELETE', path: path.concat(['tournamentModeData'])};
  }
  /**
   * @returns {TournamentConfig_TournamentMarketConfig}
   */
  get tournamentMarketConfig() {
    return this._hasTournamentMarketConfig ? this._tournamentMarketConfig : TournamentConfig_TournamentMarketConfig.default;
  }
  get hasTournamentMarketConfig() {
    return this._hasTournamentMarketConfig;
  }
  setTournamentMarketConfig(path, value) {
    return {type: 'SET', path: path.concat(['tournamentMarketConfig']), value: value.toJson()};
  }
  deleteTournamentMarketConfig(path) {
    return {type: 'DELETE', path: path.concat(['tournamentMarketConfig'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "map": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasMap = true;
              copy._map = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMap) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasMap = false;
              copy._map = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(TournamentConfig_TournamentRewardConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig(this);
              copy._rewards = copy._rewards.concat([TournamentConfig_TournamentRewardConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = TournamentConfig_TournamentRewardConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      case "gmRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._gmRewards = [];        for (let i of value) {
                copy._gmRewards.push(TournamentRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig(this);
              copy._gmRewards = copy._gmRewards.concat([TournamentRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._gmRewards.length === 0) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._gmRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._gmRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._gmRewards = copy._gmRewards.slice();
              copy._gmRewards[path[1]] = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig(this);
              copy._gmRewards = copy._gmRewards.slice(0, path[1]).concat(copy._gmRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._gmRewards.length) {
            return this;
          }
          const oldValue = this._gmRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._gmRewards = copy._gmRewards.slice();
          copy._gmRewards[key] = newValue;
          return copy;
        }
      }
      case "startTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasStartTime = true;
              copy._startTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartTime) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasStartTime = false;
              copy._startTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "endTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasEndTime = true;
              copy._endTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEndTime) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasEndTime = false;
              copy._endTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "scoreCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasScoreCount = true;
              copy._scoreCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScoreCount) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasScoreCount = false;
              copy._scoreCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardBoostInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasCardBoostInfo = true;
              copy._cardBoostInfo = dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardBoostInfo) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasCardBoostInfo = false;
              copy._cardBoostInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCardBoostInfo) {
            const copy = new TournamentConfig(this);
            copy._hasCardBoostInfo = true;
            copy._cardBoostInfo = dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cardBoostInfo.apply(type, path.slice(1), value);
          if (newValue === this._cardBoostInfo) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._cardBoostInfo = copy._cardBoostInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "season": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasSeason = true;
              copy._season = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSeason) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasSeason = false;
              copy._season = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "leagueConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._leagueConfig = [];        for (let i of value) {
                copy._leagueConfig.push(TournamentConfig_TournamentLeagueConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig(this);
              copy._leagueConfig = copy._leagueConfig.concat([TournamentConfig_TournamentLeagueConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._leagueConfig.length === 0) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._leagueConfig = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._leagueConfig.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._leagueConfig = copy._leagueConfig.slice();
              copy._leagueConfig[path[1]] = TournamentConfig_TournamentLeagueConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig(this);
              copy._leagueConfig = copy._leagueConfig.slice(0, path[1]).concat(copy._leagueConfig.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._leagueConfig.length) {
            return this;
          }
          const oldValue = this._leagueConfig[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._leagueConfig = copy._leagueConfig.slice();
          copy._leagueConfig[key] = newValue;
          return copy;
        }
      }
      case "seasonData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._seasonData = [];        for (let i of value) {
                copy._seasonData.push(TournamentSeason.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig(this);
              copy._seasonData = copy._seasonData.concat([TournamentSeason.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._seasonData.length === 0) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._seasonData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._seasonData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._seasonData = copy._seasonData.slice();
              copy._seasonData[path[1]] = TournamentSeason.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig(this);
              copy._seasonData = copy._seasonData.slice(0, path[1]).concat(copy._seasonData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._seasonData.length) {
            return this;
          }
          const oldValue = this._seasonData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._seasonData = copy._seasonData.slice();
          copy._seasonData[key] = newValue;
          return copy;
        }
      }
      case "consumableConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._consumableConfig = [];        for (let i of value) {
                copy._consumableConfig.push(TournamentConfig_TournamentConsumableConfig.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentConfig(this);
              copy._consumableConfig = copy._consumableConfig.concat([TournamentConfig_TournamentConsumableConfig.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._consumableConfig.length === 0) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._consumableConfig = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._consumableConfig.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._consumableConfig = copy._consumableConfig.slice();
              copy._consumableConfig[path[1]] = TournamentConfig_TournamentConsumableConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentConfig(this);
              copy._consumableConfig = copy._consumableConfig.slice(0, path[1]).concat(copy._consumableConfig.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._consumableConfig.length) {
            return this;
          }
          const oldValue = this._consumableConfig[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._consumableConfig = copy._consumableConfig.slice();
          copy._consumableConfig[key] = newValue;
          return copy;
        }
      }
      case "questData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasQuestData = true;
              copy._questData = TournamentQuestData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasQuestData) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasQuestData = false;
              copy._questData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasQuestData) {
            const copy = new TournamentConfig(this);
            copy._hasQuestData = true;
            copy._questData = TournamentQuestData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._questData.apply(type, path.slice(1), value);
          if (newValue === this._questData) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._questData = copy._questData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "tournamentMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasTournamentMode = true;
              copy._tournamentMode = TournamentMode.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentMode) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasTournamentMode = false;
              copy._tournamentMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tournamentModeData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasTournamentModeData = true;
              copy._tournamentModeData = TournamentConfig_TournamentModeData.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentModeData) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasTournamentModeData = false;
              copy._tournamentModeData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTournamentModeData) {
            const copy = new TournamentConfig(this);
            copy._hasTournamentModeData = true;
            copy._tournamentModeData = TournamentConfig_TournamentModeData.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tournamentModeData.apply(type, path.slice(1), value);
          if (newValue === this._tournamentModeData) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._tournamentModeData = copy._tournamentModeData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "tournamentMarketConfig": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentConfig(this);
              copy._hasTournamentMarketConfig = true;
              copy._tournamentMarketConfig = TournamentConfig_TournamentMarketConfig.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentMarketConfig) {
                return this;
              }
              const copy = new TournamentConfig(this);
              copy._hasTournamentMarketConfig = false;
              copy._tournamentMarketConfig = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTournamentMarketConfig) {
            const copy = new TournamentConfig(this);
            copy._hasTournamentMarketConfig = true;
            copy._tournamentMarketConfig = TournamentConfig_TournamentMarketConfig.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tournamentMarketConfig.apply(type, path.slice(1), value);
          if (newValue === this._tournamentMarketConfig) {
            return this;
          }
          const copy = new TournamentConfig(this);
          copy._tournamentMarketConfig = copy._tournamentMarketConfig.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentConfig} other
   * @returns {TournamentConfig}
   */
  merge(other) {
    const copy = new TournamentConfig(this);
    if (other._hasMap) {
      copy._hasMap = true;
      copy._map = other._map;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    copy._gmRewards = this._gmRewards.concat(other._gmRewards);
    if (other._hasStartTime) {
      copy._hasStartTime = true;
      copy._startTime = other._startTime;
    }
    if (other._hasEndTime) {
      copy._hasEndTime = true;
      copy._endTime = other._endTime;
    }
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasScoreCount) {
      copy._hasScoreCount = true;
      copy._scoreCount = other._scoreCount;
    }
    if (other._hasCardBoostInfo) {
      if (copy._hasCardBoostInfo) {
        copy._cardBoostInfo = copy.cardBoostInfo.merge(other.cardBoostInfo);
      } else {
        copy._cardBoostInfo = other._cardBoostInfo;
      }
      copy._hasCardBoostInfo = true;
    }
    if (other._hasSeason) {
      copy._hasSeason = true;
      copy._season = other._season;
    }
    copy._leagueConfig = this._leagueConfig.concat(other._leagueConfig);
    copy._seasonData = this._seasonData.concat(other._seasonData);
    copy._consumableConfig = this._consumableConfig.concat(other._consumableConfig);
    if (other._hasQuestData) {
      if (copy._hasQuestData) {
        copy._questData = copy.questData.merge(other.questData);
      } else {
        copy._questData = other._questData;
      }
      copy._hasQuestData = true;
    }
    if (other._hasTournamentMode) {
      copy._hasTournamentMode = true;
      copy._tournamentMode = other._tournamentMode;
    }
    if (other._hasTournamentModeData) {
      if (copy._hasTournamentModeData) {
        copy._tournamentModeData = copy.tournamentModeData.merge(other.tournamentModeData);
      } else {
        copy._tournamentModeData = other._tournamentModeData;
      }
      copy._hasTournamentModeData = true;
    }
    if (other._hasTournamentMarketConfig) {
      if (copy._hasTournamentMarketConfig) {
        copy._tournamentMarketConfig = copy.tournamentMarketConfig.merge(other.tournamentMarketConfig);
      } else {
        copy._tournamentMarketConfig = other._tournamentMarketConfig;
      }
      copy._hasTournamentMarketConfig = true;
    }
    return copy;
  }
}
TournamentConfig.default = new TournamentConfig();
TournamentConfig.TournamentModeData = TournamentConfig_TournamentModeData;
TournamentConfig.TournamentRewardConfig = TournamentConfig_TournamentRewardConfig;
TournamentConfig.TournamentConsumableConfig = TournamentConfig_TournamentConsumableConfig;
TournamentConfig.TournamentLeagueConfig = TournamentConfig_TournamentLeagueConfig;
TournamentConfig.TournamentMarketConfig = TournamentConfig_TournamentMarketConfig;
class TournamentConfig_Builder {
  constructor(value) {
    this._value = new TournamentConfig(value);
  }
  build() {
    return new TournamentConfig(this._value);
  }
  setMap(value) {
    this._value._hasMap = true;
    this._value._map = value;
    return this;
  }
  deleteMap() {
    this._value._hasMap = false;
    this._value._map = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
  addAllGmRewards(values) {
    this._value._gmRewards = this._value._gmRewards.concat(values);
    return this;
  }
  addGmRewards(value) {
    this._value._gmRewards = this._value._gmRewards.concat([value]);
    return this;
  }
  setGmRewards(index, value) {
    this._value._gmRewards = this._value._gmRewards.concat();
    this._value._gmRewards[index] = value;
    return this;
  }
  clearGmRewards() {
    this._value._gmRewards = [];
    return this;
  }
  setStartTime(value) {
    this._value._hasStartTime = true;
    this._value._startTime = value;
    return this;
  }
  deleteStartTime() {
    this._value._hasStartTime = false;
    this._value._startTime = null;
    return this;
  }
  setEndTime(value) {
    this._value._hasEndTime = true;
    this._value._endTime = value;
    return this;
  }
  deleteEndTime() {
    this._value._hasEndTime = false;
    this._value._endTime = null;
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setScoreCount(value) {
    this._value._hasScoreCount = true;
    this._value._scoreCount = value;
    return this;
  }
  deleteScoreCount() {
    this._value._hasScoreCount = false;
    this._value._scoreCount = null;
    return this;
  }
  setCardBoostInfo(value) {
    this._value._hasCardBoostInfo = true;
    this._value._cardBoostInfo = value;
    return this;
  }
  deleteCardBoostInfo() {
    this._value._hasCardBoostInfo = false;
    this._value._cardBoostInfo = null;
    return this;
  }
  setSeason(value) {
    this._value._hasSeason = true;
    this._value._season = value;
    return this;
  }
  deleteSeason() {
    this._value._hasSeason = false;
    this._value._season = null;
    return this;
  }
  addAllLeagueConfig(values) {
    this._value._leagueConfig = this._value._leagueConfig.concat(values);
    return this;
  }
  addLeagueConfig(value) {
    this._value._leagueConfig = this._value._leagueConfig.concat([value]);
    return this;
  }
  setLeagueConfig(index, value) {
    this._value._leagueConfig = this._value._leagueConfig.concat();
    this._value._leagueConfig[index] = value;
    return this;
  }
  clearLeagueConfig() {
    this._value._leagueConfig = [];
    return this;
  }
  addAllSeasonData(values) {
    this._value._seasonData = this._value._seasonData.concat(values);
    return this;
  }
  addSeasonData(value) {
    this._value._seasonData = this._value._seasonData.concat([value]);
    return this;
  }
  setSeasonData(index, value) {
    this._value._seasonData = this._value._seasonData.concat();
    this._value._seasonData[index] = value;
    return this;
  }
  clearSeasonData() {
    this._value._seasonData = [];
    return this;
  }
  addAllConsumableConfig(values) {
    this._value._consumableConfig = this._value._consumableConfig.concat(values);
    return this;
  }
  addConsumableConfig(value) {
    this._value._consumableConfig = this._value._consumableConfig.concat([value]);
    return this;
  }
  setConsumableConfig(index, value) {
    this._value._consumableConfig = this._value._consumableConfig.concat();
    this._value._consumableConfig[index] = value;
    return this;
  }
  clearConsumableConfig() {
    this._value._consumableConfig = [];
    return this;
  }
  setQuestData(value) {
    this._value._hasQuestData = true;
    this._value._questData = value;
    return this;
  }
  deleteQuestData() {
    this._value._hasQuestData = false;
    this._value._questData = null;
    return this;
  }
  setTournamentMode(value) {
    this._value._hasTournamentMode = true;
    this._value._tournamentMode = value;
    return this;
  }
  deleteTournamentMode() {
    this._value._hasTournamentMode = false;
    this._value._tournamentMode = null;
    return this;
  }
  setTournamentModeData(value) {
    this._value._hasTournamentModeData = true;
    this._value._tournamentModeData = value;
    return this;
  }
  deleteTournamentModeData() {
    this._value._hasTournamentModeData = false;
    this._value._tournamentModeData = null;
    return this;
  }
  setTournamentMarketConfig(value) {
    this._value._hasTournamentMarketConfig = true;
    this._value._tournamentMarketConfig = value;
    return this;
  }
  deleteTournamentMarketConfig() {
    this._value._hasTournamentMarketConfig = false;
    this._value._tournamentMarketConfig = null;
    return this;
  }
}
TournamentConfig.Builder = TournamentConfig_Builder;
class TournamentConfig_WithParent {
  /**
   * @param {TournamentConfig} value
   * @param {TournamentConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMap() {
    if (this._cachedHasMap === undefined) {
      if (this._value.hasMap) {
        this._cachedHasMap = true;
      } else {
        this._cachedHasMap = this._parent ? this._parent.hasMap : false;
      }
    }
    return this._cachedHasMap;
  }
  get map() {
    if (this._cachedMap === undefined) {
      if (this._value.hasMap) {
        this._cachedMap = this._value.map;
      } else {
        this._cachedMap = this._parent ? this._parent.map : this._value.map;
      }
    }
    return this._cachedMap;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new TournamentConfig_TournamentRewardConfig.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  get selfGmRewards() {
    if (!this._selfGmRewards) {
      this._selfGmRewards = [];
      for (let i of this._value.gmRewards) {
        this._selfGmRewards.push(new TournamentRewardItem.WithParent(i, null));
      }
    }
    return this._selfGmRewards;
  }
  get inherentGmRewards() {
    if (!this._inherentGmRewards) {
      this._inherentGmRewards = this._parent ? this._parent.gmRewards : [];
    }
    return this._inherentGmRewards;
  }
  get gmRewards() {
    if (!this._allGmRewards) {
      this._allGmRewards = this._parent ? this._parent.gmRewards.concat(this.selfGmRewards) : this.selfGmRewards;
    }
    return this._allGmRewards;
  }
  get hasStartTime() {
    if (this._cachedHasStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedHasStartTime = true;
      } else {
        this._cachedHasStartTime = this._parent ? this._parent.hasStartTime : false;
      }
    }
    return this._cachedHasStartTime;
  }
  get startTime() {
    if (this._cachedStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedStartTime = this._value.startTime;
      } else {
        this._cachedStartTime = this._parent ? this._parent.startTime : this._value.startTime;
      }
    }
    return this._cachedStartTime;
  }
  get hasEndTime() {
    if (this._cachedHasEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedHasEndTime = true;
      } else {
        this._cachedHasEndTime = this._parent ? this._parent.hasEndTime : false;
      }
    }
    return this._cachedHasEndTime;
  }
  get endTime() {
    if (this._cachedEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedEndTime = this._value.endTime;
      } else {
        this._cachedEndTime = this._parent ? this._parent.endTime : this._value.endTime;
      }
    }
    return this._cachedEndTime;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasScoreCount() {
    if (this._cachedHasScoreCount === undefined) {
      if (this._value.hasScoreCount) {
        this._cachedHasScoreCount = true;
      } else {
        this._cachedHasScoreCount = this._parent ? this._parent.hasScoreCount : false;
      }
    }
    return this._cachedHasScoreCount;
  }
  get scoreCount() {
    if (this._cachedScoreCount === undefined) {
      if (this._value.hasScoreCount) {
        this._cachedScoreCount = this._value.scoreCount;
      } else {
        this._cachedScoreCount = this._parent ? this._parent.scoreCount : this._value.scoreCount;
      }
    }
    return this._cachedScoreCount;
  }
  get hasCardBoostInfo() {
    if (this._cachedHasCardBoostInfo === undefined) {
      if (this._value.hasCardBoostInfo) {
        this._cachedHasCardBoostInfo = true;
      } else {
        this._cachedHasCardBoostInfo = this._parent ? this._parent.hasCardBoostInfo : false;
      }
    }
    return this._cachedHasCardBoostInfo;
  }
  get cardBoostInfo() {
    if (!this._cachedCardBoostInfo) {
      if (this._value.hasCardBoostInfo) {
        this._cachedCardBoostInfo = new dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.WithParent(this._value.cardBoostInfo, this._parent && this._parent.hasCardBoostInfo ? this._parent.cardBoostInfo : null);
      } else {
        this._cachedCardBoostInfo = this._parent ? new dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.WithParent(dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.default, this._parent.cardBoostInfo) : dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo.WithParent.default;
      }
    }
    return this._cachedCardBoostInfo;
  }
  get hasSeason() {
    if (this._cachedHasSeason === undefined) {
      if (this._value.hasSeason) {
        this._cachedHasSeason = true;
      } else {
        this._cachedHasSeason = this._parent ? this._parent.hasSeason : false;
      }
    }
    return this._cachedHasSeason;
  }
  get season() {
    if (this._cachedSeason === undefined) {
      if (this._value.hasSeason) {
        this._cachedSeason = this._value.season;
      } else {
        this._cachedSeason = this._parent ? this._parent.season : this._value.season;
      }
    }
    return this._cachedSeason;
  }
  get selfLeagueConfig() {
    if (!this._selfLeagueConfig) {
      this._selfLeagueConfig = [];
      for (let i of this._value.leagueConfig) {
        this._selfLeagueConfig.push(new TournamentConfig_TournamentLeagueConfig.WithParent(i, null));
      }
    }
    return this._selfLeagueConfig;
  }
  get inherentLeagueConfig() {
    if (!this._inherentLeagueConfig) {
      this._inherentLeagueConfig = this._parent ? this._parent.leagueConfig : [];
    }
    return this._inherentLeagueConfig;
  }
  get leagueConfig() {
    if (!this._allLeagueConfig) {
      this._allLeagueConfig = this._parent ? this._parent.leagueConfig.concat(this.selfLeagueConfig) : this.selfLeagueConfig;
    }
    return this._allLeagueConfig;
  }
  get selfSeasonData() {
    if (!this._selfSeasonData) {
      this._selfSeasonData = [];
      for (let i of this._value.seasonData) {
        this._selfSeasonData.push(new TournamentSeason.WithParent(i, null));
      }
    }
    return this._selfSeasonData;
  }
  get inherentSeasonData() {
    if (!this._inherentSeasonData) {
      this._inherentSeasonData = this._parent ? this._parent.seasonData : [];
    }
    return this._inherentSeasonData;
  }
  get seasonData() {
    if (!this._allSeasonData) {
      this._allSeasonData = this._parent ? this._parent.seasonData.concat(this.selfSeasonData) : this.selfSeasonData;
    }
    return this._allSeasonData;
  }
  get selfConsumableConfig() {
    if (!this._selfConsumableConfig) {
      this._selfConsumableConfig = [];
      for (let i of this._value.consumableConfig) {
        this._selfConsumableConfig.push(new TournamentConfig_TournamentConsumableConfig.WithParent(i, null));
      }
    }
    return this._selfConsumableConfig;
  }
  get inherentConsumableConfig() {
    if (!this._inherentConsumableConfig) {
      this._inherentConsumableConfig = this._parent ? this._parent.consumableConfig : [];
    }
    return this._inherentConsumableConfig;
  }
  get consumableConfig() {
    if (!this._allConsumableConfig) {
      this._allConsumableConfig = this._parent ? this._parent.consumableConfig.concat(this.selfConsumableConfig) : this.selfConsumableConfig;
    }
    return this._allConsumableConfig;
  }
  get hasQuestData() {
    if (this._cachedHasQuestData === undefined) {
      if (this._value.hasQuestData) {
        this._cachedHasQuestData = true;
      } else {
        this._cachedHasQuestData = this._parent ? this._parent.hasQuestData : false;
      }
    }
    return this._cachedHasQuestData;
  }
  get questData() {
    if (!this._cachedQuestData) {
      if (this._value.hasQuestData) {
        this._cachedQuestData = new TournamentQuestData.WithParent(this._value.questData, this._parent && this._parent.hasQuestData ? this._parent.questData : null);
      } else {
        this._cachedQuestData = this._parent ? new TournamentQuestData.WithParent(TournamentQuestData.default, this._parent.questData) : TournamentQuestData.WithParent.default;
      }
    }
    return this._cachedQuestData;
  }
  get hasTournamentMode() {
    if (this._cachedHasTournamentMode === undefined) {
      if (this._value.hasTournamentMode) {
        this._cachedHasTournamentMode = true;
      } else {
        this._cachedHasTournamentMode = this._parent ? this._parent.hasTournamentMode : false;
      }
    }
    return this._cachedHasTournamentMode;
  }
  get tournamentMode() {
    if (this._cachedTournamentMode === undefined) {
      if (this._value.hasTournamentMode) {
        this._cachedTournamentMode = this._value.tournamentMode;
      } else {
        this._cachedTournamentMode = this._parent ? this._parent.tournamentMode : this._value.tournamentMode;
      }
    }
    return this._cachedTournamentMode;
  }
  get hasTournamentModeData() {
    if (this._cachedHasTournamentModeData === undefined) {
      if (this._value.hasTournamentModeData) {
        this._cachedHasTournamentModeData = true;
      } else {
        this._cachedHasTournamentModeData = this._parent ? this._parent.hasTournamentModeData : false;
      }
    }
    return this._cachedHasTournamentModeData;
  }
  get tournamentModeData() {
    if (!this._cachedTournamentModeData) {
      if (this._value.hasTournamentModeData) {
        this._cachedTournamentModeData = new TournamentConfig_TournamentModeData.WithParent(this._value.tournamentModeData, this._parent && this._parent.hasTournamentModeData ? this._parent.tournamentModeData : null);
      } else {
        this._cachedTournamentModeData = this._parent ? new TournamentConfig_TournamentModeData.WithParent(TournamentConfig_TournamentModeData.default, this._parent.tournamentModeData) : TournamentConfig_TournamentModeData.WithParent.default;
      }
    }
    return this._cachedTournamentModeData;
  }
  get hasTournamentMarketConfig() {
    if (this._cachedHasTournamentMarketConfig === undefined) {
      if (this._value.hasTournamentMarketConfig) {
        this._cachedHasTournamentMarketConfig = true;
      } else {
        this._cachedHasTournamentMarketConfig = this._parent ? this._parent.hasTournamentMarketConfig : false;
      }
    }
    return this._cachedHasTournamentMarketConfig;
  }
  get tournamentMarketConfig() {
    if (!this._cachedTournamentMarketConfig) {
      if (this._value.hasTournamentMarketConfig) {
        this._cachedTournamentMarketConfig = new TournamentConfig_TournamentMarketConfig.WithParent(this._value.tournamentMarketConfig, this._parent && this._parent.hasTournamentMarketConfig ? this._parent.tournamentMarketConfig : null);
      } else {
        this._cachedTournamentMarketConfig = this._parent ? new TournamentConfig_TournamentMarketConfig.WithParent(TournamentConfig_TournamentMarketConfig.default, this._parent.tournamentMarketConfig) : TournamentConfig_TournamentMarketConfig.WithParent.default;
      }
    }
    return this._cachedTournamentMarketConfig;
  }
  update(current, parent) {
    const result = new TournamentConfig_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new TournamentConfig_TournamentRewardConfig.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    if (this._selfGmRewards) {
      if (this._value.gmRewards === current.gmRewards) {
        result._selfGmRewards = this._selfGmRewards;
      } else {
        result._selfGmRewards = [];
        for (let i = 0; i < current.gmRewards.length; i++) {
          const oldValue = this._value.gmRewards[i];
          if (oldValue) {
            const oldCache = this._selfGmRewards[i];
            if (oldValue === current.gmRewards[i]) {
              result._selfGmRewards[i] = oldCache;
            } else {
              result._selfGmRewards[i] = oldCache.update(current.gmRewards[i], null);
            }
          } else {
            result._selfGmRewards[i] = new TournamentRewardItem.WithParent(current.gmRewards[i], null);
          }
        }
      }
    }
    if (this._cachedCardBoostInfo && this._value.hasCardBoostInfo && current.hasCardBoostInfo) {
      if (this._value.cardBoostInfo === current.cardBoostInfo && this._parent === parent) {
        result._cachedCardBoostInfo = this._cachedCardBoostInfo;
      } else {
        result._cachedCardBoostInfo = this._cachedCardBoostInfo.update(current.cardBoostInfo, parent && parent.hasCardBoostInfo ? parent.cardBoostInfo : null);
      }
    }
    if (this._selfLeagueConfig) {
      if (this._value.leagueConfig === current.leagueConfig) {
        result._selfLeagueConfig = this._selfLeagueConfig;
      } else {
        result._selfLeagueConfig = [];
        for (let i = 0; i < current.leagueConfig.length; i++) {
          const oldValue = this._value.leagueConfig[i];
          if (oldValue) {
            const oldCache = this._selfLeagueConfig[i];
            if (oldValue === current.leagueConfig[i]) {
              result._selfLeagueConfig[i] = oldCache;
            } else {
              result._selfLeagueConfig[i] = oldCache.update(current.leagueConfig[i], null);
            }
          } else {
            result._selfLeagueConfig[i] = new TournamentConfig_TournamentLeagueConfig.WithParent(current.leagueConfig[i], null);
          }
        }
      }
    }
    if (this._selfSeasonData) {
      if (this._value.seasonData === current.seasonData) {
        result._selfSeasonData = this._selfSeasonData;
      } else {
        result._selfSeasonData = [];
        for (let i = 0; i < current.seasonData.length; i++) {
          const oldValue = this._value.seasonData[i];
          if (oldValue) {
            const oldCache = this._selfSeasonData[i];
            if (oldValue === current.seasonData[i]) {
              result._selfSeasonData[i] = oldCache;
            } else {
              result._selfSeasonData[i] = oldCache.update(current.seasonData[i], null);
            }
          } else {
            result._selfSeasonData[i] = new TournamentSeason.WithParent(current.seasonData[i], null);
          }
        }
      }
    }
    if (this._selfConsumableConfig) {
      if (this._value.consumableConfig === current.consumableConfig) {
        result._selfConsumableConfig = this._selfConsumableConfig;
      } else {
        result._selfConsumableConfig = [];
        for (let i = 0; i < current.consumableConfig.length; i++) {
          const oldValue = this._value.consumableConfig[i];
          if (oldValue) {
            const oldCache = this._selfConsumableConfig[i];
            if (oldValue === current.consumableConfig[i]) {
              result._selfConsumableConfig[i] = oldCache;
            } else {
              result._selfConsumableConfig[i] = oldCache.update(current.consumableConfig[i], null);
            }
          } else {
            result._selfConsumableConfig[i] = new TournamentConfig_TournamentConsumableConfig.WithParent(current.consumableConfig[i], null);
          }
        }
      }
    }
    if (this._cachedQuestData && this._value.hasQuestData && current.hasQuestData) {
      if (this._value.questData === current.questData && this._parent === parent) {
        result._cachedQuestData = this._cachedQuestData;
      } else {
        result._cachedQuestData = this._cachedQuestData.update(current.questData, parent && parent.hasQuestData ? parent.questData : null);
      }
    }
    if (this._cachedTournamentModeData && this._value.hasTournamentModeData && current.hasTournamentModeData) {
      if (this._value.tournamentModeData === current.tournamentModeData && this._parent === parent) {
        result._cachedTournamentModeData = this._cachedTournamentModeData;
      } else {
        result._cachedTournamentModeData = this._cachedTournamentModeData.update(current.tournamentModeData, parent && parent.hasTournamentModeData ? parent.tournamentModeData : null);
      }
    }
    if (this._cachedTournamentMarketConfig && this._value.hasTournamentMarketConfig && current.hasTournamentMarketConfig) {
      if (this._value.tournamentMarketConfig === current.tournamentMarketConfig && this._parent === parent) {
        result._cachedTournamentMarketConfig = this._cachedTournamentMarketConfig;
      } else {
        result._cachedTournamentMarketConfig = this._cachedTournamentMarketConfig.update(current.tournamentMarketConfig, parent && parent.hasTournamentMarketConfig ? parent.tournamentMarketConfig : null);
      }
    }
    return result;
  }
}
TournamentConfig_WithParent.default = new TournamentConfig_WithParent(TournamentConfig.default, null);
TournamentConfig.WithParent = TournamentConfig_WithParent;
class TournamentConfig_Descriptor {
  get map() {
    if (!this._map) {
      this._map = {
        name: "map",
        Name: "Map",
        number: 1,
        protoType: 9,
        protoName: "map",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._map;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 2,
        protoType: 11,
        protoName: "rewards",
        type: TournamentConfig_TournamentRewardConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get gmRewards() {
    if (!this._gmRewards) {
      this._gmRewards = {
        name: "gmRewards",
        Name: "GmRewards",
        number: 11,
        protoType: 11,
        protoName: "gm_rewards",
        type: TournamentRewardItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gmRewards;
  }
  get startTime() {
    if (!this._startTime) {
      this._startTime = {
        name: "startTime",
        Name: "StartTime",
        number: 3,
        protoType: 5,
        protoName: "start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startTime;
  }
  get endTime() {
    if (!this._endTime) {
      this._endTime = {
        name: "endTime",
        Name: "EndTime",
        number: 4,
        protoType: 5,
        protoName: "end_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._endTime;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 5,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get scoreCount() {
    if (!this._scoreCount) {
      this._scoreCount = {
        name: "scoreCount",
        Name: "ScoreCount",
        number: 6,
        protoType: 5,
        protoName: "score_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scoreCount;
  }
  get cardBoostInfo() {
    if (!this._cardBoostInfo) {
      this._cardBoostInfo = {
        name: "cardBoostInfo",
        Name: "CardBoostInfo",
        number: 7,
        protoType: 11,
        protoName: "card_boost_info",
        type: dcei_wildsky_map_event_proto.MapEvent.CardBoostInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardBoostInfo;
  }
  get season() {
    if (!this._season) {
      this._season = {
        name: "season",
        Name: "Season",
        number: 8,
        protoType: 5,
        protoName: "season",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._season;
  }
  get leagueConfig() {
    if (!this._leagueConfig) {
      this._leagueConfig = {
        name: "leagueConfig",
        Name: "LeagueConfig",
        number: 9,
        protoType: 11,
        protoName: "league_config",
        type: TournamentConfig_TournamentLeagueConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leagueConfig;
  }
  get seasonData() {
    if (!this._seasonData) {
      this._seasonData = {
        name: "seasonData",
        Name: "SeasonData",
        number: 10,
        protoType: 11,
        protoName: "season_data",
        type: TournamentSeason,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._seasonData;
  }
  get consumableConfig() {
    if (!this._consumableConfig) {
      this._consumableConfig = {
        name: "consumableConfig",
        Name: "ConsumableConfig",
        number: 12,
        protoType: 11,
        protoName: "consumable_config",
        type: TournamentConfig_TournamentConsumableConfig,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._consumableConfig;
  }
  get questData() {
    if (!this._questData) {
      this._questData = {
        name: "questData",
        Name: "QuestData",
        number: 13,
        protoType: 11,
        protoName: "quest_data",
        type: TournamentQuestData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questData;
  }
  get tournamentMode() {
    if (!this._tournamentMode) {
      this._tournamentMode = {
        name: "tournamentMode",
        Name: "TournamentMode",
        number: 14,
        protoType: 14,
        protoName: "tournament_mode",
        type: TournamentMode,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentMode;
  }
  get tournamentModeData() {
    if (!this._tournamentModeData) {
      this._tournamentModeData = {
        name: "tournamentModeData",
        Name: "TournamentModeData",
        number: 15,
        protoType: 11,
        protoName: "tournament_mode_data",
        type: TournamentConfig_TournamentModeData,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentModeData;
  }
  get tournamentMarketConfig() {
    if (!this._tournamentMarketConfig) {
      this._tournamentMarketConfig = {
        name: "tournamentMarketConfig",
        Name: "TournamentMarketConfig",
        number: 16,
        protoType: 11,
        protoName: "tournament_market_config",
        type: TournamentConfig_TournamentMarketConfig,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentMarketConfig;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.map,
        this.rewards,
        this.gmRewards,
        this.startTime,
        this.endTime,
        this.name,
        this.scoreCount,
        this.cardBoostInfo,
        this.season,
        this.leagueConfig,
        this.seasonData,
        this.consumableConfig,
        this.questData,
        this.tournamentMode,
        this.tournamentModeData,
        this.tournamentMarketConfig,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMap",
        Name: "DummyOneofForMap",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartTime",
        Name: "DummyOneofForStartTime",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEndTime",
        Name: "DummyOneofForEndTime",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScoreCount",
        Name: "DummyOneofForScoreCount",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardBoostInfo",
        Name: "DummyOneofForCardBoostInfo",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSeason",
        Name: "DummyOneofForSeason",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForQuestData",
        Name: "DummyOneofForQuestData",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTournamentMode",
        Name: "DummyOneofForTournamentMode",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTournamentModeData",
        Name: "DummyOneofForTournamentModeData",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTournamentMarketConfig",
        Name: "DummyOneofForTournamentMarketConfig",
        fields: [
          this.fields[15],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentConfig.descriptor = new TournamentConfig_Descriptor();
export class TournamentQuestRewardItem {
  get descriptor() {
    return TournamentQuestRewardItem.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTournamentId = false;
    this._tournamentId = null;
    this._hasQuestKey = false;
    this._questKey = null;
    this._rewards = [];
  }
  isEmpty() {
    if (this._hasTournamentId) return false;
    if (this._hasQuestKey) return false;
    if (this._rewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentQuestRewardItem) {
      return value;
    }
    return TournamentQuestRewardItem.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentQuestRewardItem();
    if (json.tournamentId != null) {
      result._hasTournamentId = true;
      result._tournamentId = JsonToString.fromJson(json.tournamentId);
    }
    if (json.questKey != null) {
      result._hasQuestKey = true;
      result._questKey = JsonToString.fromJson(json.questKey);
    }
    result._rewards = JsonToList(json.rewards, TournamentRewardItem);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTournamentId) {
      result.tournamentId = JsonToString.toJson(this._tournamentId);
    }
    if (this._hasQuestKey) {
      result.questKey = JsonToString.toJson(this._questKey);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, TournamentRewardItem);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get tournamentId() {
    return this._hasTournamentId ? this._tournamentId : JsonToString.default;
  }
  get hasTournamentId() {
    return this._hasTournamentId;
  }
  setTournamentId(path, value) {
    return {type: 'SET', path: path.concat(['tournamentId']), value};
  }
  deleteTournamentId(path) {
    return {type: 'DELETE', path: path.concat(['tournamentId'])};
  }
  /**
   * @returns {string}
   */
  get questKey() {
    return this._hasQuestKey ? this._questKey : JsonToString.default;
  }
  get hasQuestKey() {
    return this._hasQuestKey;
  }
  setQuestKey(path, value) {
    return {type: 'SET', path: path.concat(['questKey']), value};
  }
  deleteQuestKey(path) {
    return {type: 'DELETE', path: path.concat(['questKey'])};
  }
  /**
   * @returns {TournamentRewardItem[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, TournamentRewardItem)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tournamentId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestRewardItem(this);
              copy._hasTournamentId = true;
              copy._tournamentId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTournamentId) {
                return this;
              }
              const copy = new TournamentQuestRewardItem(this);
              copy._hasTournamentId = false;
              copy._tournamentId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "questKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestRewardItem(this);
              copy._hasQuestKey = true;
              copy._questKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasQuestKey) {
                return this;
              }
              const copy = new TournamentQuestRewardItem(this);
              copy._hasQuestKey = false;
              copy._questKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestRewardItem(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(TournamentRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentQuestRewardItem(this);
              copy._rewards = copy._rewards.concat([TournamentRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new TournamentQuestRewardItem(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestRewardItem(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentQuestRewardItem(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentQuestRewardItem(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentQuestRewardItem} other
   * @returns {TournamentQuestRewardItem}
   */
  merge(other) {
    const copy = new TournamentQuestRewardItem(this);
    if (other._hasTournamentId) {
      copy._hasTournamentId = true;
      copy._tournamentId = other._tournamentId;
    }
    if (other._hasQuestKey) {
      copy._hasQuestKey = true;
      copy._questKey = other._questKey;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    return copy;
  }
}
TournamentQuestRewardItem.default = new TournamentQuestRewardItem();
class TournamentQuestRewardItem_Builder {
  constructor(value) {
    this._value = new TournamentQuestRewardItem(value);
  }
  build() {
    return new TournamentQuestRewardItem(this._value);
  }
  setTournamentId(value) {
    this._value._hasTournamentId = true;
    this._value._tournamentId = value;
    return this;
  }
  deleteTournamentId() {
    this._value._hasTournamentId = false;
    this._value._tournamentId = null;
    return this;
  }
  setQuestKey(value) {
    this._value._hasQuestKey = true;
    this._value._questKey = value;
    return this;
  }
  deleteQuestKey() {
    this._value._hasQuestKey = false;
    this._value._questKey = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
}
TournamentQuestRewardItem.Builder = TournamentQuestRewardItem_Builder;
class TournamentQuestRewardItem_WithParent {
  /**
   * @param {TournamentQuestRewardItem} value
   * @param {TournamentQuestRewardItem_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentQuestRewardItem.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTournamentId() {
    if (this._cachedHasTournamentId === undefined) {
      if (this._value.hasTournamentId) {
        this._cachedHasTournamentId = true;
      } else {
        this._cachedHasTournamentId = this._parent ? this._parent.hasTournamentId : false;
      }
    }
    return this._cachedHasTournamentId;
  }
  get tournamentId() {
    if (this._cachedTournamentId === undefined) {
      if (this._value.hasTournamentId) {
        this._cachedTournamentId = this._value.tournamentId;
      } else {
        this._cachedTournamentId = this._parent ? this._parent.tournamentId : this._value.tournamentId;
      }
    }
    return this._cachedTournamentId;
  }
  get hasQuestKey() {
    if (this._cachedHasQuestKey === undefined) {
      if (this._value.hasQuestKey) {
        this._cachedHasQuestKey = true;
      } else {
        this._cachedHasQuestKey = this._parent ? this._parent.hasQuestKey : false;
      }
    }
    return this._cachedHasQuestKey;
  }
  get questKey() {
    if (this._cachedQuestKey === undefined) {
      if (this._value.hasQuestKey) {
        this._cachedQuestKey = this._value.questKey;
      } else {
        this._cachedQuestKey = this._parent ? this._parent.questKey : this._value.questKey;
      }
    }
    return this._cachedQuestKey;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new TournamentRewardItem.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  update(current, parent) {
    const result = new TournamentQuestRewardItem_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new TournamentRewardItem.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentQuestRewardItem_WithParent.default = new TournamentQuestRewardItem_WithParent(TournamentQuestRewardItem.default, null);
TournamentQuestRewardItem.WithParent = TournamentQuestRewardItem_WithParent;
class TournamentQuestRewardItem_Descriptor {
  get tournamentId() {
    if (!this._tournamentId) {
      this._tournamentId = {
        name: "tournamentId",
        Name: "TournamentId",
        number: 1,
        protoType: 9,
        protoName: "tournament_id",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tournamentId;
  }
  get questKey() {
    if (!this._questKey) {
      this._questKey = {
        name: "questKey",
        Name: "QuestKey",
        number: 2,
        protoType: 9,
        protoName: "quest_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questKey;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 3,
        protoType: 11,
        protoName: "rewards",
        type: TournamentRewardItem,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tournamentId,
        this.questKey,
        this.rewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTournamentId",
        Name: "DummyOneofForTournamentId",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForQuestKey",
        Name: "DummyOneofForQuestKey",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentQuestRewardItem.descriptor = new TournamentQuestRewardItem_Descriptor();
class TournamentQuestData_QuestStatus {
  get descriptor() {
    return TournamentQuestData_QuestStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasProgress = false;
    this._progress = null;
    this._hasRewardClaimed = false;
    this._rewardClaimed = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasProgress) return false;
    if (this._hasRewardClaimed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentQuestData_QuestStatus) {
      return value;
    }
    return TournamentQuestData_QuestStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentQuestData_QuestStatus();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.progress != null) {
      result._hasProgress = true;
      result._progress = JsonToInt32.fromJson(json.progress);
    }
    if (json.rewardClaimed != null) {
      result._hasRewardClaimed = true;
      result._rewardClaimed = JsonToBoolean.fromJson(json.rewardClaimed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasProgress) {
      result.progress = JsonToInt32.toJson(this._progress);
    }
    if (this._hasRewardClaimed) {
      result.rewardClaimed = JsonToBoolean.toJson(this._rewardClaimed);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get progress() {
    return this._hasProgress ? this._progress : JsonToInt32.default;
  }
  get hasProgress() {
    return this._hasProgress;
  }
  setProgress(path, value) {
    return {type: 'SET', path: path.concat(['progress']), value};
  }
  deleteProgress(path) {
    return {type: 'DELETE', path: path.concat(['progress'])};
  }
  /**
   * @returns {boolean}
   */
  get rewardClaimed() {
    return this._hasRewardClaimed ? this._rewardClaimed : JsonToBoolean.default;
  }
  get hasRewardClaimed() {
    return this._hasRewardClaimed;
  }
  setRewardClaimed(path, value) {
    return {type: 'SET', path: path.concat(['rewardClaimed']), value};
  }
  deleteRewardClaimed(path) {
    return {type: 'DELETE', path: path.concat(['rewardClaimed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestStatus(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TournamentQuestData_QuestStatus(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestStatus(this);
              copy._hasProgress = true;
              copy._progress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgress) {
                return this;
              }
              const copy = new TournamentQuestData_QuestStatus(this);
              copy._hasProgress = false;
              copy._progress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardClaimed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestStatus(this);
              copy._hasRewardClaimed = true;
              copy._rewardClaimed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardClaimed) {
                return this;
              }
              const copy = new TournamentQuestData_QuestStatus(this);
              copy._hasRewardClaimed = false;
              copy._rewardClaimed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentQuestData_QuestStatus} other
   * @returns {TournamentQuestData_QuestStatus}
   */
  merge(other) {
    const copy = new TournamentQuestData_QuestStatus(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasProgress) {
      copy._hasProgress = true;
      copy._progress = other._progress;
    }
    if (other._hasRewardClaimed) {
      copy._hasRewardClaimed = true;
      copy._rewardClaimed = other._rewardClaimed;
    }
    return copy;
  }
}
TournamentQuestData_QuestStatus.default = new TournamentQuestData_QuestStatus();
class TournamentQuestData_QuestStatus_Builder {
  constructor(value) {
    this._value = new TournamentQuestData_QuestStatus(value);
  }
  build() {
    return new TournamentQuestData_QuestStatus(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setProgress(value) {
    this._value._hasProgress = true;
    this._value._progress = value;
    return this;
  }
  deleteProgress() {
    this._value._hasProgress = false;
    this._value._progress = null;
    return this;
  }
  setRewardClaimed(value) {
    this._value._hasRewardClaimed = true;
    this._value._rewardClaimed = value;
    return this;
  }
  deleteRewardClaimed() {
    this._value._hasRewardClaimed = false;
    this._value._rewardClaimed = null;
    return this;
  }
}
TournamentQuestData_QuestStatus.Builder = TournamentQuestData_QuestStatus_Builder;
class TournamentQuestData_QuestStatus_WithParent {
  /**
   * @param {TournamentQuestData_QuestStatus} value
   * @param {TournamentQuestData_QuestStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentQuestData_QuestStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasProgress() {
    if (this._cachedHasProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedHasProgress = true;
      } else {
        this._cachedHasProgress = this._parent ? this._parent.hasProgress : false;
      }
    }
    return this._cachedHasProgress;
  }
  get progress() {
    if (this._cachedProgress === undefined) {
      if (this._value.hasProgress) {
        this._cachedProgress = this._value.progress;
      } else {
        this._cachedProgress = this._parent ? this._parent.progress : this._value.progress;
      }
    }
    return this._cachedProgress;
  }
  get hasRewardClaimed() {
    if (this._cachedHasRewardClaimed === undefined) {
      if (this._value.hasRewardClaimed) {
        this._cachedHasRewardClaimed = true;
      } else {
        this._cachedHasRewardClaimed = this._parent ? this._parent.hasRewardClaimed : false;
      }
    }
    return this._cachedHasRewardClaimed;
  }
  get rewardClaimed() {
    if (this._cachedRewardClaimed === undefined) {
      if (this._value.hasRewardClaimed) {
        this._cachedRewardClaimed = this._value.rewardClaimed;
      } else {
        this._cachedRewardClaimed = this._parent ? this._parent.rewardClaimed : this._value.rewardClaimed;
      }
    }
    return this._cachedRewardClaimed;
  }
  update(current, parent) {
    const result = new TournamentQuestData_QuestStatus_WithParent(current, parent);
    return result;
  }
}
TournamentQuestData_QuestStatus_WithParent.default = new TournamentQuestData_QuestStatus_WithParent(TournamentQuestData_QuestStatus.default, null);
TournamentQuestData_QuestStatus.WithParent = TournamentQuestData_QuestStatus_WithParent;
class TournamentQuestData_QuestStatus_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get progress() {
    if (!this._progress) {
      this._progress = {
        name: "progress",
        Name: "Progress",
        number: 2,
        protoType: 5,
        protoName: "progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progress;
  }
  get rewardClaimed() {
    if (!this._rewardClaimed) {
      this._rewardClaimed = {
        name: "rewardClaimed",
        Name: "RewardClaimed",
        number: 3,
        protoType: 8,
        protoName: "reward_claimed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardClaimed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.progress,
        this.rewardClaimed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgress",
        Name: "DummyOneofForProgress",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewardClaimed",
        Name: "DummyOneofForRewardClaimed",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentQuestData_QuestStatus.descriptor = new TournamentQuestData_QuestStatus_Descriptor();
class TournamentQuestData_QuestRewardKey {
  get descriptor() {
    return TournamentQuestData_QuestRewardKey.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentQuestData_QuestRewardKey) {
      return value;
    }
    return TournamentQuestData_QuestRewardKey.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentQuestData_QuestRewardKey();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestRewardKey(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TournamentQuestData_QuestRewardKey(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentQuestData_QuestRewardKey} other
   * @returns {TournamentQuestData_QuestRewardKey}
   */
  merge(other) {
    const copy = new TournamentQuestData_QuestRewardKey(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    return copy;
  }
}
TournamentQuestData_QuestRewardKey.default = new TournamentQuestData_QuestRewardKey();
class TournamentQuestData_QuestRewardKey_Builder {
  constructor(value) {
    this._value = new TournamentQuestData_QuestRewardKey(value);
  }
  build() {
    return new TournamentQuestData_QuestRewardKey(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
}
TournamentQuestData_QuestRewardKey.Builder = TournamentQuestData_QuestRewardKey_Builder;
class TournamentQuestData_QuestRewardKey_WithParent {
  /**
   * @param {TournamentQuestData_QuestRewardKey} value
   * @param {TournamentQuestData_QuestRewardKey_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentQuestData_QuestRewardKey.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  update(current, parent) {
    const result = new TournamentQuestData_QuestRewardKey_WithParent(current, parent);
    return result;
  }
}
TournamentQuestData_QuestRewardKey_WithParent.default = new TournamentQuestData_QuestRewardKey_WithParent(TournamentQuestData_QuestRewardKey.default, null);
TournamentQuestData_QuestRewardKey.WithParent = TournamentQuestData_QuestRewardKey_WithParent;
class TournamentQuestData_QuestRewardKey_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentQuestData_QuestRewardKey.descriptor = new TournamentQuestData_QuestRewardKey_Descriptor();
class TournamentQuestData_QuestRewardAmount {
  get descriptor() {
    return TournamentQuestData_QuestRewardAmount.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentQuestData_QuestRewardAmount) {
      return value;
    }
    return TournamentQuestData_QuestRewardAmount.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentQuestData_QuestRewardAmount();
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestRewardAmount(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new TournamentQuestData_QuestRewardAmount(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentQuestData_QuestRewardAmount} other
   * @returns {TournamentQuestData_QuestRewardAmount}
   */
  merge(other) {
    const copy = new TournamentQuestData_QuestRewardAmount(this);
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
TournamentQuestData_QuestRewardAmount.default = new TournamentQuestData_QuestRewardAmount();
class TournamentQuestData_QuestRewardAmount_Builder {
  constructor(value) {
    this._value = new TournamentQuestData_QuestRewardAmount(value);
  }
  build() {
    return new TournamentQuestData_QuestRewardAmount(this._value);
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
TournamentQuestData_QuestRewardAmount.Builder = TournamentQuestData_QuestRewardAmount_Builder;
class TournamentQuestData_QuestRewardAmount_WithParent {
  /**
   * @param {TournamentQuestData_QuestRewardAmount} value
   * @param {TournamentQuestData_QuestRewardAmount_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentQuestData_QuestRewardAmount.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new TournamentQuestData_QuestRewardAmount_WithParent(current, parent);
    return result;
  }
}
TournamentQuestData_QuestRewardAmount_WithParent.default = new TournamentQuestData_QuestRewardAmount_WithParent(TournamentQuestData_QuestRewardAmount.default, null);
TournamentQuestData_QuestRewardAmount.WithParent = TournamentQuestData_QuestRewardAmount_WithParent;
class TournamentQuestData_QuestRewardAmount_Descriptor {
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentQuestData_QuestRewardAmount.descriptor = new TournamentQuestData_QuestRewardAmount_Descriptor();
class TournamentQuestData_QuestDefinition_ProgressSyncType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "SCORE_ONE_BATTLE": return 1;
        case "SCORE_TOTAL": return 2;
        case "PLAY_COUNT": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TournamentQuestData_QuestDefinition_ProgressSyncType.fromJson(value);
  }
  static fromReact(e) {
    return TournamentQuestData_QuestDefinition_ProgressSyncType.fromJson(e);
  }
}
TournamentQuestData_QuestDefinition_ProgressSyncType.NONE = 0;
TournamentQuestData_QuestDefinition_ProgressSyncType.SCORE_ONE_BATTLE = 1;
TournamentQuestData_QuestDefinition_ProgressSyncType.SCORE_TOTAL = 2;
TournamentQuestData_QuestDefinition_ProgressSyncType.PLAY_COUNT = 3;
TournamentQuestData_QuestDefinition_ProgressSyncType.default = 0;
TournamentQuestData_QuestDefinition_ProgressSyncType.values = {
  NONE: 0,
  SCORE_ONE_BATTLE: 1,
  SCORE_TOTAL: 2,
  PLAY_COUNT: 3,
};
TournamentQuestData_QuestDefinition_ProgressSyncType.names = {
  0: "NONE",
  1: "SCORE_ONE_BATTLE",
  2: "SCORE_TOTAL",
  3: "PLAY_COUNT",
};
class TournamentQuestData_QuestDefinition {
  get descriptor() {
    return TournamentQuestData_QuestDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasDescription = false;
    this._description = null;
    this._hasProgressTotal = false;
    this._progressTotal = null;
    this._rewardItems = [];
    this._questRewardAmount = [];
    this._hasProgressSyncType = false;
    this._progressSyncType = null;
    this._hasLeagueRequirement = false;
    this._leagueRequirement = null;
    this._hasEventValue = false;
    this._eventValue = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasDescription) return false;
    if (this._hasProgressTotal) return false;
    if (this._rewardItems.length > 0) return false;
    if (this._questRewardAmount.length > 0) return false;
    if (this._hasProgressSyncType) return false;
    if (this._hasLeagueRequirement) return false;
    if (this._hasEventValue) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentQuestData_QuestDefinition) {
      return value;
    }
    return TournamentQuestData_QuestDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentQuestData_QuestDefinition();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.progressTotal != null) {
      result._hasProgressTotal = true;
      result._progressTotal = JsonToInt32.fromJson(json.progressTotal);
    }
    result._rewardItems = JsonToList(json.rewardItems, TournamentRewardItem);
    result._questRewardAmount = JsonToList(json.questRewardAmount, TournamentQuestData_QuestRewardAmount);
    if (json.progressSyncType != null) {
      result._hasProgressSyncType = true;
      result._progressSyncType = TournamentQuestData_QuestDefinition_ProgressSyncType.fromJson(json.progressSyncType);
    }
    if (json.leagueRequirement != null) {
      result._hasLeagueRequirement = true;
      result._leagueRequirement = JsonToInt32.fromJson(json.leagueRequirement);
    }
    if (json.eventValue != null) {
      result._hasEventValue = true;
      result._eventValue = JsonToDouble.fromJson(json.eventValue);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasProgressTotal) {
      result.progressTotal = JsonToInt32.toJson(this._progressTotal);
    }
    if (this._rewardItems.length > 0) {
      result.rewardItems = ArrayToJson(this._rewardItems, TournamentRewardItem);
    }
    if (this._questRewardAmount.length > 0) {
      result.questRewardAmount = ArrayToJson(this._questRewardAmount, TournamentQuestData_QuestRewardAmount);
    }
    if (this._hasProgressSyncType) {
      result.progressSyncType = TournamentQuestData_QuestDefinition_ProgressSyncType.toJson(this._progressSyncType);
    }
    if (this._hasLeagueRequirement) {
      result.leagueRequirement = JsonToInt32.toJson(this._leagueRequirement);
    }
    if (this._hasEventValue) {
      result.eventValue = JsonToDouble.toJson(this._eventValue);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {number}
   */
  get progressTotal() {
    return this._hasProgressTotal ? this._progressTotal : JsonToInt32.default;
  }
  get hasProgressTotal() {
    return this._hasProgressTotal;
  }
  setProgressTotal(path, value) {
    return {type: 'SET', path: path.concat(['progressTotal']), value};
  }
  deleteProgressTotal(path) {
    return {type: 'DELETE', path: path.concat(['progressTotal'])};
  }
  /**
   * @returns {TournamentRewardItem[]}
   */
  get rewardItems() {
    return this._rewardItems;
  }
  addRewardItems(path, value) {
    return {type: 'ADD', path: path.concat(['rewardItems']), value: value.toJson()};
  }
  setRewardItems(path, value) {
    return {type: 'SET', path: path.concat(['rewardItems']), value: ArrayToJson(value, TournamentRewardItem)};
  }
  setRewardItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewardItems', key]), value: value.toJson()};
  }
  deleteRewardItems(path) {
    return {type: 'DELETE', path: path.concat(['rewardItems'])};
  }
  deleteRewardItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewardItems', key])};
  }
  /**
   * @returns {TournamentQuestData_QuestRewardAmount[]}
   */
  get questRewardAmount() {
    return this._questRewardAmount;
  }
  addQuestRewardAmount(path, value) {
    return {type: 'ADD', path: path.concat(['questRewardAmount']), value: value.toJson()};
  }
  setQuestRewardAmount(path, value) {
    return {type: 'SET', path: path.concat(['questRewardAmount']), value: ArrayToJson(value, TournamentQuestData_QuestRewardAmount)};
  }
  setQuestRewardAmountByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questRewardAmount', key]), value: value.toJson()};
  }
  deleteQuestRewardAmount(path) {
    return {type: 'DELETE', path: path.concat(['questRewardAmount'])};
  }
  deleteQuestRewardAmountByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questRewardAmount', key])};
  }
  /**
   * @returns {number}
   */
  get progressSyncType() {
    return this._hasProgressSyncType ? this._progressSyncType : TournamentQuestData_QuestDefinition_ProgressSyncType.default;
  }
  get hasProgressSyncType() {
    return this._hasProgressSyncType;
  }
  setProgressSyncType(path, value) {
    return {type: 'SET', path: path.concat(['progressSyncType']), value};
  }
  deleteProgressSyncType(path) {
    return {type: 'DELETE', path: path.concat(['progressSyncType'])};
  }
  /**
   * @returns {number}
   */
  get leagueRequirement() {
    return this._hasLeagueRequirement ? this._leagueRequirement : JsonToInt32.default;
  }
  get hasLeagueRequirement() {
    return this._hasLeagueRequirement;
  }
  setLeagueRequirement(path, value) {
    return {type: 'SET', path: path.concat(['leagueRequirement']), value};
  }
  deleteLeagueRequirement(path) {
    return {type: 'DELETE', path: path.concat(['leagueRequirement'])};
  }
  /**
   * @returns {number}
   */
  get eventValue() {
    return this._hasEventValue ? this._eventValue : JsonToDouble.default;
  }
  get hasEventValue() {
    return this._hasEventValue;
  }
  setEventValue(path, value) {
    return {type: 'SET', path: path.concat(['eventValue']), value};
  }
  deleteEventValue(path) {
    return {type: 'DELETE', path: path.concat(['eventValue'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "progressTotal": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasProgressTotal = true;
              copy._progressTotal = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgressTotal) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasProgressTotal = false;
              copy._progressTotal = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardItems": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._rewardItems = [];        for (let i of value) {
                copy._rewardItems.push(TournamentRewardItem.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._rewardItems = copy._rewardItems.concat([TournamentRewardItem.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewardItems.length === 0) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._rewardItems = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._rewardItems = copy._rewardItems.slice();
              copy._rewardItems[path[1]] = TournamentRewardItem.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._rewardItems = copy._rewardItems.slice(0, path[1]).concat(copy._rewardItems.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewardItems.length) {
            return this;
          }
          const oldValue = this._rewardItems[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentQuestData_QuestDefinition(this);
          copy._rewardItems = copy._rewardItems.slice();
          copy._rewardItems[key] = newValue;
          return copy;
        }
      }
      case "questRewardAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._questRewardAmount = [];        for (let i of value) {
                copy._questRewardAmount.push(TournamentQuestData_QuestRewardAmount.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._questRewardAmount = copy._questRewardAmount.concat([TournamentQuestData_QuestRewardAmount.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questRewardAmount.length === 0) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._questRewardAmount = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questRewardAmount.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._questRewardAmount = copy._questRewardAmount.slice();
              copy._questRewardAmount[path[1]] = TournamentQuestData_QuestRewardAmount.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._questRewardAmount = copy._questRewardAmount.slice(0, path[1]).concat(copy._questRewardAmount.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questRewardAmount.length) {
            return this;
          }
          const oldValue = this._questRewardAmount[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentQuestData_QuestDefinition(this);
          copy._questRewardAmount = copy._questRewardAmount.slice();
          copy._questRewardAmount[key] = newValue;
          return copy;
        }
      }
      case "progressSyncType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasProgressSyncType = true;
              copy._progressSyncType = TournamentQuestData_QuestDefinition_ProgressSyncType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasProgressSyncType) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasProgressSyncType = false;
              copy._progressSyncType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "leagueRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasLeagueRequirement = true;
              copy._leagueRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLeagueRequirement) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasLeagueRequirement = false;
              copy._leagueRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "eventValue": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasEventValue = true;
              copy._eventValue = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEventValue) {
                return this;
              }
              const copy = new TournamentQuestData_QuestDefinition(this);
              copy._hasEventValue = false;
              copy._eventValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentQuestData_QuestDefinition} other
   * @returns {TournamentQuestData_QuestDefinition}
   */
  merge(other) {
    const copy = new TournamentQuestData_QuestDefinition(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasProgressTotal) {
      copy._hasProgressTotal = true;
      copy._progressTotal = other._progressTotal;
    }
    copy._rewardItems = this._rewardItems.concat(other._rewardItems);
    copy._questRewardAmount = this._questRewardAmount.concat(other._questRewardAmount);
    if (other._hasProgressSyncType) {
      copy._hasProgressSyncType = true;
      copy._progressSyncType = other._progressSyncType;
    }
    if (other._hasLeagueRequirement) {
      copy._hasLeagueRequirement = true;
      copy._leagueRequirement = other._leagueRequirement;
    }
    if (other._hasEventValue) {
      copy._hasEventValue = true;
      copy._eventValue = other._eventValue;
    }
    return copy;
  }
}
TournamentQuestData_QuestDefinition.default = new TournamentQuestData_QuestDefinition();
TournamentQuestData_QuestDefinition.ProgressSyncType = TournamentQuestData_QuestDefinition_ProgressSyncType;
class TournamentQuestData_QuestDefinition_Builder {
  constructor(value) {
    this._value = new TournamentQuestData_QuestDefinition(value);
  }
  build() {
    return new TournamentQuestData_QuestDefinition(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setProgressTotal(value) {
    this._value._hasProgressTotal = true;
    this._value._progressTotal = value;
    return this;
  }
  deleteProgressTotal() {
    this._value._hasProgressTotal = false;
    this._value._progressTotal = null;
    return this;
  }
  addAllRewardItems(values) {
    this._value._rewardItems = this._value._rewardItems.concat(values);
    return this;
  }
  addRewardItems(value) {
    this._value._rewardItems = this._value._rewardItems.concat([value]);
    return this;
  }
  setRewardItems(index, value) {
    this._value._rewardItems = this._value._rewardItems.concat();
    this._value._rewardItems[index] = value;
    return this;
  }
  clearRewardItems() {
    this._value._rewardItems = [];
    return this;
  }
  addAllQuestRewardAmount(values) {
    this._value._questRewardAmount = this._value._questRewardAmount.concat(values);
    return this;
  }
  addQuestRewardAmount(value) {
    this._value._questRewardAmount = this._value._questRewardAmount.concat([value]);
    return this;
  }
  setQuestRewardAmount(index, value) {
    this._value._questRewardAmount = this._value._questRewardAmount.concat();
    this._value._questRewardAmount[index] = value;
    return this;
  }
  clearQuestRewardAmount() {
    this._value._questRewardAmount = [];
    return this;
  }
  setProgressSyncType(value) {
    this._value._hasProgressSyncType = true;
    this._value._progressSyncType = value;
    return this;
  }
  deleteProgressSyncType() {
    this._value._hasProgressSyncType = false;
    this._value._progressSyncType = null;
    return this;
  }
  setLeagueRequirement(value) {
    this._value._hasLeagueRequirement = true;
    this._value._leagueRequirement = value;
    return this;
  }
  deleteLeagueRequirement() {
    this._value._hasLeagueRequirement = false;
    this._value._leagueRequirement = null;
    return this;
  }
  setEventValue(value) {
    this._value._hasEventValue = true;
    this._value._eventValue = value;
    return this;
  }
  deleteEventValue() {
    this._value._hasEventValue = false;
    this._value._eventValue = null;
    return this;
  }
}
TournamentQuestData_QuestDefinition.Builder = TournamentQuestData_QuestDefinition_Builder;
class TournamentQuestData_QuestDefinition_WithParent {
  /**
   * @param {TournamentQuestData_QuestDefinition} value
   * @param {TournamentQuestData_QuestDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentQuestData_QuestDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasProgressTotal() {
    if (this._cachedHasProgressTotal === undefined) {
      if (this._value.hasProgressTotal) {
        this._cachedHasProgressTotal = true;
      } else {
        this._cachedHasProgressTotal = this._parent ? this._parent.hasProgressTotal : false;
      }
    }
    return this._cachedHasProgressTotal;
  }
  get progressTotal() {
    if (this._cachedProgressTotal === undefined) {
      if (this._value.hasProgressTotal) {
        this._cachedProgressTotal = this._value.progressTotal;
      } else {
        this._cachedProgressTotal = this._parent ? this._parent.progressTotal : this._value.progressTotal;
      }
    }
    return this._cachedProgressTotal;
  }
  get selfRewardItems() {
    if (!this._selfRewardItems) {
      this._selfRewardItems = [];
      for (let i of this._value.rewardItems) {
        this._selfRewardItems.push(new TournamentRewardItem.WithParent(i, null));
      }
    }
    return this._selfRewardItems;
  }
  get inherentRewardItems() {
    if (!this._inherentRewardItems) {
      this._inherentRewardItems = this._parent ? this._parent.rewardItems : [];
    }
    return this._inherentRewardItems;
  }
  get rewardItems() {
    if (!this._allRewardItems) {
      this._allRewardItems = this._parent ? this._parent.rewardItems.concat(this.selfRewardItems) : this.selfRewardItems;
    }
    return this._allRewardItems;
  }
  get selfQuestRewardAmount() {
    if (!this._selfQuestRewardAmount) {
      this._selfQuestRewardAmount = [];
      for (let i of this._value.questRewardAmount) {
        this._selfQuestRewardAmount.push(new TournamentQuestData_QuestRewardAmount.WithParent(i, null));
      }
    }
    return this._selfQuestRewardAmount;
  }
  get inherentQuestRewardAmount() {
    if (!this._inherentQuestRewardAmount) {
      this._inherentQuestRewardAmount = this._parent ? this._parent.questRewardAmount : [];
    }
    return this._inherentQuestRewardAmount;
  }
  get questRewardAmount() {
    if (!this._allQuestRewardAmount) {
      this._allQuestRewardAmount = this._parent ? this._parent.questRewardAmount.concat(this.selfQuestRewardAmount) : this.selfQuestRewardAmount;
    }
    return this._allQuestRewardAmount;
  }
  get hasProgressSyncType() {
    if (this._cachedHasProgressSyncType === undefined) {
      if (this._value.hasProgressSyncType) {
        this._cachedHasProgressSyncType = true;
      } else {
        this._cachedHasProgressSyncType = this._parent ? this._parent.hasProgressSyncType : false;
      }
    }
    return this._cachedHasProgressSyncType;
  }
  get progressSyncType() {
    if (this._cachedProgressSyncType === undefined) {
      if (this._value.hasProgressSyncType) {
        this._cachedProgressSyncType = this._value.progressSyncType;
      } else {
        this._cachedProgressSyncType = this._parent ? this._parent.progressSyncType : this._value.progressSyncType;
      }
    }
    return this._cachedProgressSyncType;
  }
  get hasLeagueRequirement() {
    if (this._cachedHasLeagueRequirement === undefined) {
      if (this._value.hasLeagueRequirement) {
        this._cachedHasLeagueRequirement = true;
      } else {
        this._cachedHasLeagueRequirement = this._parent ? this._parent.hasLeagueRequirement : false;
      }
    }
    return this._cachedHasLeagueRequirement;
  }
  get leagueRequirement() {
    if (this._cachedLeagueRequirement === undefined) {
      if (this._value.hasLeagueRequirement) {
        this._cachedLeagueRequirement = this._value.leagueRequirement;
      } else {
        this._cachedLeagueRequirement = this._parent ? this._parent.leagueRequirement : this._value.leagueRequirement;
      }
    }
    return this._cachedLeagueRequirement;
  }
  get hasEventValue() {
    if (this._cachedHasEventValue === undefined) {
      if (this._value.hasEventValue) {
        this._cachedHasEventValue = true;
      } else {
        this._cachedHasEventValue = this._parent ? this._parent.hasEventValue : false;
      }
    }
    return this._cachedHasEventValue;
  }
  get eventValue() {
    if (this._cachedEventValue === undefined) {
      if (this._value.hasEventValue) {
        this._cachedEventValue = this._value.eventValue;
      } else {
        this._cachedEventValue = this._parent ? this._parent.eventValue : this._value.eventValue;
      }
    }
    return this._cachedEventValue;
  }
  update(current, parent) {
    const result = new TournamentQuestData_QuestDefinition_WithParent(current, parent);
    if (this._selfRewardItems) {
      if (this._value.rewardItems === current.rewardItems) {
        result._selfRewardItems = this._selfRewardItems;
      } else {
        result._selfRewardItems = [];
        for (let i = 0; i < current.rewardItems.length; i++) {
          const oldValue = this._value.rewardItems[i];
          if (oldValue) {
            const oldCache = this._selfRewardItems[i];
            if (oldValue === current.rewardItems[i]) {
              result._selfRewardItems[i] = oldCache;
            } else {
              result._selfRewardItems[i] = oldCache.update(current.rewardItems[i], null);
            }
          } else {
            result._selfRewardItems[i] = new TournamentRewardItem.WithParent(current.rewardItems[i], null);
          }
        }
      }
    }
    if (this._selfQuestRewardAmount) {
      if (this._value.questRewardAmount === current.questRewardAmount) {
        result._selfQuestRewardAmount = this._selfQuestRewardAmount;
      } else {
        result._selfQuestRewardAmount = [];
        for (let i = 0; i < current.questRewardAmount.length; i++) {
          const oldValue = this._value.questRewardAmount[i];
          if (oldValue) {
            const oldCache = this._selfQuestRewardAmount[i];
            if (oldValue === current.questRewardAmount[i]) {
              result._selfQuestRewardAmount[i] = oldCache;
            } else {
              result._selfQuestRewardAmount[i] = oldCache.update(current.questRewardAmount[i], null);
            }
          } else {
            result._selfQuestRewardAmount[i] = new TournamentQuestData_QuestRewardAmount.WithParent(current.questRewardAmount[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentQuestData_QuestDefinition_WithParent.default = new TournamentQuestData_QuestDefinition_WithParent(TournamentQuestData_QuestDefinition.default, null);
TournamentQuestData_QuestDefinition.WithParent = TournamentQuestData_QuestDefinition_WithParent;
class TournamentQuestData_QuestDefinition_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 2,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get progressTotal() {
    if (!this._progressTotal) {
      this._progressTotal = {
        name: "progressTotal",
        Name: "ProgressTotal",
        number: 3,
        protoType: 5,
        protoName: "progress_total",
        type: JsonToInt32,
        options: {
          min: 1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressTotal;
  }
  get rewardItems() {
    if (!this._rewardItems) {
      this._rewardItems = {
        name: "rewardItems",
        Name: "RewardItems",
        number: 4,
        protoType: 11,
        protoName: "reward_items",
        type: TournamentRewardItem,
        isRepeated: true,
        options: {
          comments: "Additional rewards applied",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardItems;
  }
  get questRewardAmount() {
    if (!this._questRewardAmount) {
      this._questRewardAmount = {
        name: "questRewardAmount",
        Name: "QuestRewardAmount",
        number: 8,
        protoType: 11,
        protoName: "quest_reward_amount",
        type: TournamentQuestData_QuestRewardAmount,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questRewardAmount;
  }
  get progressSyncType() {
    if (!this._progressSyncType) {
      this._progressSyncType = {
        name: "progressSyncType",
        Name: "ProgressSyncType",
        number: 5,
        protoType: 14,
        protoName: "progress_sync_type",
        type: TournamentQuestData_QuestDefinition_ProgressSyncType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._progressSyncType;
  }
  get leagueRequirement() {
    if (!this._leagueRequirement) {
      this._leagueRequirement = {
        name: "leagueRequirement",
        Name: "LeagueRequirement",
        number: 6,
        protoType: 5,
        protoName: "league_requirement",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._leagueRequirement;
  }
  get eventValue() {
    if (!this._eventValue) {
      this._eventValue = {
        name: "eventValue",
        Name: "EventValue",
        number: 7,
        protoType: 1,
        protoName: "event_value",
        type: JsonToDouble,
        options: {
          comments: "Value used to sync some progress, such as score X in one battle",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._eventValue;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.description,
        this.progressTotal,
        this.rewardItems,
        this.questRewardAmount,
        this.progressSyncType,
        this.leagueRequirement,
        this.eventValue,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgressTotal",
        Name: "DummyOneofForProgressTotal",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForProgressSyncType",
        Name: "DummyOneofForProgressSyncType",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLeagueRequirement",
        Name: "DummyOneofForLeagueRequirement",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEventValue",
        Name: "DummyOneofForEventValue",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentQuestData_QuestDefinition.descriptor = new TournamentQuestData_QuestDefinition_Descriptor();
export class TournamentQuestData {
  get descriptor() {
    return TournamentQuestData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._questData = [];
    this._questRewardKeys = [];
    this._questsStatus = [];
  }
  isEmpty() {
    if (this._questData.length > 0) return false;
    if (this._questRewardKeys.length > 0) return false;
    if (this._questsStatus.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentQuestData) {
      return value;
    }
    return TournamentQuestData.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentQuestData();
    result._questData = JsonToList(json.questData, TournamentQuestData_QuestDefinition);
    result._questRewardKeys = JsonToList(json.questRewardKeys, TournamentQuestData_QuestRewardKey);
    result._questsStatus = JsonToList(json.questsStatus, TournamentQuestData_QuestStatus);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._questData.length > 0) {
      result.questData = ArrayToJson(this._questData, TournamentQuestData_QuestDefinition);
    }
    if (this._questRewardKeys.length > 0) {
      result.questRewardKeys = ArrayToJson(this._questRewardKeys, TournamentQuestData_QuestRewardKey);
    }
    if (this._questsStatus.length > 0) {
      result.questsStatus = ArrayToJson(this._questsStatus, TournamentQuestData_QuestStatus);
    }
    return result;
  }
  /**
   * @returns {TournamentQuestData_QuestDefinition[]}
   */
  get questData() {
    return this._questData;
  }
  addQuestData(path, value) {
    return {type: 'ADD', path: path.concat(['questData']), value: value.toJson()};
  }
  setQuestData(path, value) {
    return {type: 'SET', path: path.concat(['questData']), value: ArrayToJson(value, TournamentQuestData_QuestDefinition)};
  }
  setQuestDataByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questData', key]), value: value.toJson()};
  }
  deleteQuestData(path) {
    return {type: 'DELETE', path: path.concat(['questData'])};
  }
  deleteQuestDataByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questData', key])};
  }
  /**
   * @returns {TournamentQuestData_QuestRewardKey[]}
   */
  get questRewardKeys() {
    return this._questRewardKeys;
  }
  addQuestRewardKeys(path, value) {
    return {type: 'ADD', path: path.concat(['questRewardKeys']), value: value.toJson()};
  }
  setQuestRewardKeys(path, value) {
    return {type: 'SET', path: path.concat(['questRewardKeys']), value: ArrayToJson(value, TournamentQuestData_QuestRewardKey)};
  }
  setQuestRewardKeysByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questRewardKeys', key]), value: value.toJson()};
  }
  deleteQuestRewardKeys(path) {
    return {type: 'DELETE', path: path.concat(['questRewardKeys'])};
  }
  deleteQuestRewardKeysByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questRewardKeys', key])};
  }
  /**
   * @returns {TournamentQuestData_QuestStatus[]}
   */
  get questsStatus() {
    return this._questsStatus;
  }
  addQuestsStatus(path, value) {
    return {type: 'ADD', path: path.concat(['questsStatus']), value: value.toJson()};
  }
  setQuestsStatus(path, value) {
    return {type: 'SET', path: path.concat(['questsStatus']), value: ArrayToJson(value, TournamentQuestData_QuestStatus)};
  }
  setQuestsStatusByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['questsStatus', key]), value: value.toJson()};
  }
  deleteQuestsStatus(path) {
    return {type: 'DELETE', path: path.concat(['questsStatus'])};
  }
  deleteQuestsStatusByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['questsStatus', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "questData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData(this);
              copy._questData = [];        for (let i of value) {
                copy._questData.push(TournamentQuestData_QuestDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentQuestData(this);
              copy._questData = copy._questData.concat([TournamentQuestData_QuestDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questData.length === 0) {
                return this;
              }
              const copy = new TournamentQuestData(this);
              copy._questData = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questData.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData(this);
              copy._questData = copy._questData.slice();
              copy._questData[path[1]] = TournamentQuestData_QuestDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentQuestData(this);
              copy._questData = copy._questData.slice(0, path[1]).concat(copy._questData.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questData.length) {
            return this;
          }
          const oldValue = this._questData[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentQuestData(this);
          copy._questData = copy._questData.slice();
          copy._questData[key] = newValue;
          return copy;
        }
      }
      case "questRewardKeys": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData(this);
              copy._questRewardKeys = [];        for (let i of value) {
                copy._questRewardKeys.push(TournamentQuestData_QuestRewardKey.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentQuestData(this);
              copy._questRewardKeys = copy._questRewardKeys.concat([TournamentQuestData_QuestRewardKey.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questRewardKeys.length === 0) {
                return this;
              }
              const copy = new TournamentQuestData(this);
              copy._questRewardKeys = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questRewardKeys.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData(this);
              copy._questRewardKeys = copy._questRewardKeys.slice();
              copy._questRewardKeys[path[1]] = TournamentQuestData_QuestRewardKey.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentQuestData(this);
              copy._questRewardKeys = copy._questRewardKeys.slice(0, path[1]).concat(copy._questRewardKeys.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questRewardKeys.length) {
            return this;
          }
          const oldValue = this._questRewardKeys[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentQuestData(this);
          copy._questRewardKeys = copy._questRewardKeys.slice();
          copy._questRewardKeys[key] = newValue;
          return copy;
        }
      }
      case "questsStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData(this);
              copy._questsStatus = [];        for (let i of value) {
                copy._questsStatus.push(TournamentQuestData_QuestStatus.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentQuestData(this);
              copy._questsStatus = copy._questsStatus.concat([TournamentQuestData_QuestStatus.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._questsStatus.length === 0) {
                return this;
              }
              const copy = new TournamentQuestData(this);
              copy._questsStatus = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._questsStatus.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentQuestData(this);
              copy._questsStatus = copy._questsStatus.slice();
              copy._questsStatus[path[1]] = TournamentQuestData_QuestStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentQuestData(this);
              copy._questsStatus = copy._questsStatus.slice(0, path[1]).concat(copy._questsStatus.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._questsStatus.length) {
            return this;
          }
          const oldValue = this._questsStatus[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentQuestData(this);
          copy._questsStatus = copy._questsStatus.slice();
          copy._questsStatus[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentQuestData} other
   * @returns {TournamentQuestData}
   */
  merge(other) {
    const copy = new TournamentQuestData(this);
    copy._questData = this._questData.concat(other._questData);
    copy._questRewardKeys = this._questRewardKeys.concat(other._questRewardKeys);
    copy._questsStatus = this._questsStatus.concat(other._questsStatus);
    return copy;
  }
}
TournamentQuestData.default = new TournamentQuestData();
TournamentQuestData.QuestStatus = TournamentQuestData_QuestStatus;
TournamentQuestData.QuestRewardKey = TournamentQuestData_QuestRewardKey;
TournamentQuestData.QuestRewardAmount = TournamentQuestData_QuestRewardAmount;
TournamentQuestData.QuestDefinition = TournamentQuestData_QuestDefinition;
class TournamentQuestData_Builder {
  constructor(value) {
    this._value = new TournamentQuestData(value);
  }
  build() {
    return new TournamentQuestData(this._value);
  }
  addAllQuestData(values) {
    this._value._questData = this._value._questData.concat(values);
    return this;
  }
  addQuestData(value) {
    this._value._questData = this._value._questData.concat([value]);
    return this;
  }
  setQuestData(index, value) {
    this._value._questData = this._value._questData.concat();
    this._value._questData[index] = value;
    return this;
  }
  clearQuestData() {
    this._value._questData = [];
    return this;
  }
  addAllQuestRewardKeys(values) {
    this._value._questRewardKeys = this._value._questRewardKeys.concat(values);
    return this;
  }
  addQuestRewardKeys(value) {
    this._value._questRewardKeys = this._value._questRewardKeys.concat([value]);
    return this;
  }
  setQuestRewardKeys(index, value) {
    this._value._questRewardKeys = this._value._questRewardKeys.concat();
    this._value._questRewardKeys[index] = value;
    return this;
  }
  clearQuestRewardKeys() {
    this._value._questRewardKeys = [];
    return this;
  }
  addAllQuestsStatus(values) {
    this._value._questsStatus = this._value._questsStatus.concat(values);
    return this;
  }
  addQuestsStatus(value) {
    this._value._questsStatus = this._value._questsStatus.concat([value]);
    return this;
  }
  setQuestsStatus(index, value) {
    this._value._questsStatus = this._value._questsStatus.concat();
    this._value._questsStatus[index] = value;
    return this;
  }
  clearQuestsStatus() {
    this._value._questsStatus = [];
    return this;
  }
}
TournamentQuestData.Builder = TournamentQuestData_Builder;
class TournamentQuestData_WithParent {
  /**
   * @param {TournamentQuestData} value
   * @param {TournamentQuestData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentQuestData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfQuestData() {
    if (!this._selfQuestData) {
      this._selfQuestData = [];
      for (let i of this._value.questData) {
        this._selfQuestData.push(new TournamentQuestData_QuestDefinition.WithParent(i, null));
      }
    }
    return this._selfQuestData;
  }
  get inherentQuestData() {
    if (!this._inherentQuestData) {
      this._inherentQuestData = this._parent ? this._parent.questData : [];
    }
    return this._inherentQuestData;
  }
  get questData() {
    if (!this._allQuestData) {
      this._allQuestData = this._parent ? this._parent.questData.concat(this.selfQuestData) : this.selfQuestData;
    }
    return this._allQuestData;
  }
  get selfQuestRewardKeys() {
    if (!this._selfQuestRewardKeys) {
      this._selfQuestRewardKeys = [];
      for (let i of this._value.questRewardKeys) {
        this._selfQuestRewardKeys.push(new TournamentQuestData_QuestRewardKey.WithParent(i, null));
      }
    }
    return this._selfQuestRewardKeys;
  }
  get inherentQuestRewardKeys() {
    if (!this._inherentQuestRewardKeys) {
      this._inherentQuestRewardKeys = this._parent ? this._parent.questRewardKeys : [];
    }
    return this._inherentQuestRewardKeys;
  }
  get questRewardKeys() {
    if (!this._allQuestRewardKeys) {
      this._allQuestRewardKeys = this._parent ? this._parent.questRewardKeys.concat(this.selfQuestRewardKeys) : this.selfQuestRewardKeys;
    }
    return this._allQuestRewardKeys;
  }
  get selfQuestsStatus() {
    if (!this._selfQuestsStatus) {
      this._selfQuestsStatus = [];
      for (let i of this._value.questsStatus) {
        this._selfQuestsStatus.push(new TournamentQuestData_QuestStatus.WithParent(i, null));
      }
    }
    return this._selfQuestsStatus;
  }
  get inherentQuestsStatus() {
    if (!this._inherentQuestsStatus) {
      this._inherentQuestsStatus = this._parent ? this._parent.questsStatus : [];
    }
    return this._inherentQuestsStatus;
  }
  get questsStatus() {
    if (!this._allQuestsStatus) {
      this._allQuestsStatus = this._parent ? this._parent.questsStatus.concat(this.selfQuestsStatus) : this.selfQuestsStatus;
    }
    return this._allQuestsStatus;
  }
  update(current, parent) {
    const result = new TournamentQuestData_WithParent(current, parent);
    if (this._selfQuestData) {
      if (this._value.questData === current.questData) {
        result._selfQuestData = this._selfQuestData;
      } else {
        result._selfQuestData = [];
        for (let i = 0; i < current.questData.length; i++) {
          const oldValue = this._value.questData[i];
          if (oldValue) {
            const oldCache = this._selfQuestData[i];
            if (oldValue === current.questData[i]) {
              result._selfQuestData[i] = oldCache;
            } else {
              result._selfQuestData[i] = oldCache.update(current.questData[i], null);
            }
          } else {
            result._selfQuestData[i] = new TournamentQuestData_QuestDefinition.WithParent(current.questData[i], null);
          }
        }
      }
    }
    if (this._selfQuestRewardKeys) {
      if (this._value.questRewardKeys === current.questRewardKeys) {
        result._selfQuestRewardKeys = this._selfQuestRewardKeys;
      } else {
        result._selfQuestRewardKeys = [];
        for (let i = 0; i < current.questRewardKeys.length; i++) {
          const oldValue = this._value.questRewardKeys[i];
          if (oldValue) {
            const oldCache = this._selfQuestRewardKeys[i];
            if (oldValue === current.questRewardKeys[i]) {
              result._selfQuestRewardKeys[i] = oldCache;
            } else {
              result._selfQuestRewardKeys[i] = oldCache.update(current.questRewardKeys[i], null);
            }
          } else {
            result._selfQuestRewardKeys[i] = new TournamentQuestData_QuestRewardKey.WithParent(current.questRewardKeys[i], null);
          }
        }
      }
    }
    if (this._selfQuestsStatus) {
      if (this._value.questsStatus === current.questsStatus) {
        result._selfQuestsStatus = this._selfQuestsStatus;
      } else {
        result._selfQuestsStatus = [];
        for (let i = 0; i < current.questsStatus.length; i++) {
          const oldValue = this._value.questsStatus[i];
          if (oldValue) {
            const oldCache = this._selfQuestsStatus[i];
            if (oldValue === current.questsStatus[i]) {
              result._selfQuestsStatus[i] = oldCache;
            } else {
              result._selfQuestsStatus[i] = oldCache.update(current.questsStatus[i], null);
            }
          } else {
            result._selfQuestsStatus[i] = new TournamentQuestData_QuestStatus.WithParent(current.questsStatus[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentQuestData_WithParent.default = new TournamentQuestData_WithParent(TournamentQuestData.default, null);
TournamentQuestData.WithParent = TournamentQuestData_WithParent;
class TournamentQuestData_Descriptor {
  get questData() {
    if (!this._questData) {
      this._questData = {
        name: "questData",
        Name: "QuestData",
        number: 1,
        protoType: 11,
        protoName: "quest_data",
        type: TournamentQuestData_QuestDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questData;
  }
  get questRewardKeys() {
    if (!this._questRewardKeys) {
      this._questRewardKeys = {
        name: "questRewardKeys",
        Name: "QuestRewardKeys",
        number: 3,
        protoType: 11,
        protoName: "quest_reward_keys",
        type: TournamentQuestData_QuestRewardKey,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questRewardKeys;
  }
  get questsStatus() {
    if (!this._questsStatus) {
      this._questsStatus = {
        name: "questsStatus",
        Name: "QuestsStatus",
        number: 2,
        protoType: 11,
        protoName: "quests_status",
        type: TournamentQuestData_QuestStatus,
        isRepeated: true,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._questsStatus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.questData,
        this.questRewardKeys,
        this.questsStatus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TournamentQuestData.descriptor = new TournamentQuestData_Descriptor();
class TournamentSeason_PostSeasonPurchase {
  get descriptor() {
    return TournamentSeason_PostSeasonPurchase.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cardSkins = [];
  }
  isEmpty() {
    if (this._cardSkins.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentSeason_PostSeasonPurchase) {
      return value;
    }
    return TournamentSeason_PostSeasonPurchase.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentSeason_PostSeasonPurchase();
    result._cardSkins = JsonToList(json.cardSkins, dcei_wildsky_card_proto.CardSkin);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cardSkins.length > 0) {
      result.cardSkins = ArrayToJson(this._cardSkins, dcei_wildsky_card_proto.CardSkin);
    }
    return result;
  }
  /**
   * @returns {dcei_wildsky_card_proto.CardSkin[]}
   */
  get cardSkins() {
    return this._cardSkins;
  }
  addCardSkins(path, value) {
    return {type: 'ADD', path: path.concat(['cardSkins']), value: value.toJson()};
  }
  setCardSkins(path, value) {
    return {type: 'SET', path: path.concat(['cardSkins']), value: ArrayToJson(value, dcei_wildsky_card_proto.CardSkin)};
  }
  setCardSkinsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardSkins', key]), value: value.toJson()};
  }
  deleteCardSkins(path) {
    return {type: 'DELETE', path: path.concat(['cardSkins'])};
  }
  deleteCardSkinsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardSkins', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardSkins": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason_PostSeasonPurchase(this);
              copy._cardSkins = [];        for (let i of value) {
                copy._cardSkins.push(dcei_wildsky_card_proto.CardSkin.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new TournamentSeason_PostSeasonPurchase(this);
              copy._cardSkins = copy._cardSkins.concat([dcei_wildsky_card_proto.CardSkin.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardSkins.length === 0) {
                return this;
              }
              const copy = new TournamentSeason_PostSeasonPurchase(this);
              copy._cardSkins = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardSkins.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason_PostSeasonPurchase(this);
              copy._cardSkins = copy._cardSkins.slice();
              copy._cardSkins[path[1]] = dcei_wildsky_card_proto.CardSkin.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new TournamentSeason_PostSeasonPurchase(this);
              copy._cardSkins = copy._cardSkins.slice(0, path[1]).concat(copy._cardSkins.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardSkins.length) {
            return this;
          }
          const oldValue = this._cardSkins[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new TournamentSeason_PostSeasonPurchase(this);
          copy._cardSkins = copy._cardSkins.slice();
          copy._cardSkins[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentSeason_PostSeasonPurchase} other
   * @returns {TournamentSeason_PostSeasonPurchase}
   */
  merge(other) {
    const copy = new TournamentSeason_PostSeasonPurchase(this);
    copy._cardSkins = this._cardSkins.concat(other._cardSkins);
    return copy;
  }
}
TournamentSeason_PostSeasonPurchase.default = new TournamentSeason_PostSeasonPurchase();
class TournamentSeason_PostSeasonPurchase_Builder {
  constructor(value) {
    this._value = new TournamentSeason_PostSeasonPurchase(value);
  }
  build() {
    return new TournamentSeason_PostSeasonPurchase(this._value);
  }
  addAllCardSkins(values) {
    this._value._cardSkins = this._value._cardSkins.concat(values);
    return this;
  }
  addCardSkins(value) {
    this._value._cardSkins = this._value._cardSkins.concat([value]);
    return this;
  }
  setCardSkins(index, value) {
    this._value._cardSkins = this._value._cardSkins.concat();
    this._value._cardSkins[index] = value;
    return this;
  }
  clearCardSkins() {
    this._value._cardSkins = [];
    return this;
  }
}
TournamentSeason_PostSeasonPurchase.Builder = TournamentSeason_PostSeasonPurchase_Builder;
class TournamentSeason_PostSeasonPurchase_WithParent {
  /**
   * @param {TournamentSeason_PostSeasonPurchase} value
   * @param {TournamentSeason_PostSeasonPurchase_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentSeason_PostSeasonPurchase.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCardSkins() {
    if (!this._selfCardSkins) {
      this._selfCardSkins = [];
      for (let i of this._value.cardSkins) {
        this._selfCardSkins.push(new dcei_wildsky_card_proto.CardSkin.WithParent(i, null));
      }
    }
    return this._selfCardSkins;
  }
  get inherentCardSkins() {
    if (!this._inherentCardSkins) {
      this._inherentCardSkins = this._parent ? this._parent.cardSkins : [];
    }
    return this._inherentCardSkins;
  }
  get cardSkins() {
    if (!this._allCardSkins) {
      this._allCardSkins = this._parent ? this._parent.cardSkins.concat(this.selfCardSkins) : this.selfCardSkins;
    }
    return this._allCardSkins;
  }
  update(current, parent) {
    const result = new TournamentSeason_PostSeasonPurchase_WithParent(current, parent);
    if (this._selfCardSkins) {
      if (this._value.cardSkins === current.cardSkins) {
        result._selfCardSkins = this._selfCardSkins;
      } else {
        result._selfCardSkins = [];
        for (let i = 0; i < current.cardSkins.length; i++) {
          const oldValue = this._value.cardSkins[i];
          if (oldValue) {
            const oldCache = this._selfCardSkins[i];
            if (oldValue === current.cardSkins[i]) {
              result._selfCardSkins[i] = oldCache;
            } else {
              result._selfCardSkins[i] = oldCache.update(current.cardSkins[i], null);
            }
          } else {
            result._selfCardSkins[i] = new dcei_wildsky_card_proto.CardSkin.WithParent(current.cardSkins[i], null);
          }
        }
      }
    }
    return result;
  }
}
TournamentSeason_PostSeasonPurchase_WithParent.default = new TournamentSeason_PostSeasonPurchase_WithParent(TournamentSeason_PostSeasonPurchase.default, null);
TournamentSeason_PostSeasonPurchase.WithParent = TournamentSeason_PostSeasonPurchase_WithParent;
class TournamentSeason_PostSeasonPurchase_Descriptor {
  get cardSkins() {
    if (!this._cardSkins) {
      this._cardSkins = {
        name: "cardSkins",
        Name: "CardSkins",
        number: 1,
        protoType: 11,
        protoName: "card_skins",
        type: dcei_wildsky_card_proto.CardSkin,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkins;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardSkins,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
TournamentSeason_PostSeasonPurchase.descriptor = new TournamentSeason_PostSeasonPurchase_Descriptor();
export class TournamentSeason {
  get descriptor() {
    return TournamentSeason.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSeason = false;
    this._season = null;
    this._hasStartTime = false;
    this._startTime = null;
    this._hasEndTime = false;
    this._endTime = null;
    this._hasFinished = false;
    this._finished = null;
    this._hasHighestLeague = false;
    this._highestLeague = null;
    this._hasRankCount = false;
    this._rankCount = null;
    this._hasPostSeasonPurchase = false;
    this._postSeasonPurchase = null;
  }
  isEmpty() {
    if (this._hasSeason) return false;
    if (this._hasStartTime) return false;
    if (this._hasEndTime) return false;
    if (this._hasFinished) return false;
    if (this._hasHighestLeague) return false;
    if (this._hasRankCount) return false;
    if (this._hasPostSeasonPurchase && !this._postSeasonPurchase.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof TournamentSeason) {
      return value;
    }
    return TournamentSeason.fromJson(value);
  }
  static fromJson(json) {
    const result = new TournamentSeason();
    if (json.season != null) {
      result._hasSeason = true;
      result._season = JsonToInt32.fromJson(json.season);
    }
    if (json.startTime != null) {
      result._hasStartTime = true;
      result._startTime = JsonToInt32.fromJson(json.startTime);
    }
    if (json.endTime != null) {
      result._hasEndTime = true;
      result._endTime = JsonToInt32.fromJson(json.endTime);
    }
    if (json.finished != null) {
      result._hasFinished = true;
      result._finished = JsonToBoolean.fromJson(json.finished);
    }
    if (json.highestLeague != null) {
      result._hasHighestLeague = true;
      result._highestLeague = JsonToInt32.fromJson(json.highestLeague);
    }
    if (json.rankCount != null) {
      result._hasRankCount = true;
      result._rankCount = JsonToInt32.fromJson(json.rankCount);
    }
    if (json.postSeasonPurchase != null) {
      result._hasPostSeasonPurchase = true;
      result._postSeasonPurchase = TournamentSeason_PostSeasonPurchase.fromJson(json.postSeasonPurchase);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSeason) {
      result.season = JsonToInt32.toJson(this._season);
    }
    if (this._hasStartTime) {
      result.startTime = JsonToInt32.toJson(this._startTime);
    }
    if (this._hasEndTime) {
      result.endTime = JsonToInt32.toJson(this._endTime);
    }
    if (this._hasFinished) {
      result.finished = JsonToBoolean.toJson(this._finished);
    }
    if (this._hasHighestLeague) {
      result.highestLeague = JsonToInt32.toJson(this._highestLeague);
    }
    if (this._hasRankCount) {
      result.rankCount = JsonToInt32.toJson(this._rankCount);
    }
    if (this._hasPostSeasonPurchase && !this._postSeasonPurchase.isEmpty()) {
      result.postSeasonPurchase = TournamentSeason_PostSeasonPurchase.toJson(this._postSeasonPurchase);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get season() {
    return this._hasSeason ? this._season : JsonToInt32.default;
  }
  get hasSeason() {
    return this._hasSeason;
  }
  setSeason(path, value) {
    return {type: 'SET', path: path.concat(['season']), value};
  }
  deleteSeason(path) {
    return {type: 'DELETE', path: path.concat(['season'])};
  }
  /**
   * @returns {number}
   */
  get startTime() {
    return this._hasStartTime ? this._startTime : JsonToInt32.default;
  }
  get hasStartTime() {
    return this._hasStartTime;
  }
  setStartTime(path, value) {
    return {type: 'SET', path: path.concat(['startTime']), value};
  }
  deleteStartTime(path) {
    return {type: 'DELETE', path: path.concat(['startTime'])};
  }
  /**
   * @returns {number}
   */
  get endTime() {
    return this._hasEndTime ? this._endTime : JsonToInt32.default;
  }
  get hasEndTime() {
    return this._hasEndTime;
  }
  setEndTime(path, value) {
    return {type: 'SET', path: path.concat(['endTime']), value};
  }
  deleteEndTime(path) {
    return {type: 'DELETE', path: path.concat(['endTime'])};
  }
  /**
   * @returns {boolean}
   */
  get finished() {
    return this._hasFinished ? this._finished : JsonToBoolean.default;
  }
  get hasFinished() {
    return this._hasFinished;
  }
  setFinished(path, value) {
    return {type: 'SET', path: path.concat(['finished']), value};
  }
  deleteFinished(path) {
    return {type: 'DELETE', path: path.concat(['finished'])};
  }
  /**
   * @returns {number}
   */
  get highestLeague() {
    return this._hasHighestLeague ? this._highestLeague : JsonToInt32.default;
  }
  get hasHighestLeague() {
    return this._hasHighestLeague;
  }
  setHighestLeague(path, value) {
    return {type: 'SET', path: path.concat(['highestLeague']), value};
  }
  deleteHighestLeague(path) {
    return {type: 'DELETE', path: path.concat(['highestLeague'])};
  }
  /**
   * @returns {number}
   */
  get rankCount() {
    return this._hasRankCount ? this._rankCount : JsonToInt32.default;
  }
  get hasRankCount() {
    return this._hasRankCount;
  }
  setRankCount(path, value) {
    return {type: 'SET', path: path.concat(['rankCount']), value};
  }
  deleteRankCount(path) {
    return {type: 'DELETE', path: path.concat(['rankCount'])};
  }
  /**
   * @returns {TournamentSeason_PostSeasonPurchase}
   */
  get postSeasonPurchase() {
    return this._hasPostSeasonPurchase ? this._postSeasonPurchase : TournamentSeason_PostSeasonPurchase.default;
  }
  get hasPostSeasonPurchase() {
    return this._hasPostSeasonPurchase;
  }
  setPostSeasonPurchase(path, value) {
    return {type: 'SET', path: path.concat(['postSeasonPurchase']), value: value.toJson()};
  }
  deletePostSeasonPurchase(path) {
    return {type: 'DELETE', path: path.concat(['postSeasonPurchase'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "season": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasSeason = true;
              copy._season = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSeason) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasSeason = false;
              copy._season = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "startTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasStartTime = true;
              copy._startTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStartTime) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasStartTime = false;
              copy._startTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "endTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasEndTime = true;
              copy._endTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEndTime) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasEndTime = false;
              copy._endTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "finished": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasFinished = true;
              copy._finished = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFinished) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasFinished = false;
              copy._finished = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "highestLeague": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasHighestLeague = true;
              copy._highestLeague = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHighestLeague) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasHighestLeague = false;
              copy._highestLeague = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rankCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasRankCount = true;
              copy._rankCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRankCount) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasRankCount = false;
              copy._rankCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "postSeasonPurchase": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new TournamentSeason(this);
              copy._hasPostSeasonPurchase = true;
              copy._postSeasonPurchase = TournamentSeason_PostSeasonPurchase.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPostSeasonPurchase) {
                return this;
              }
              const copy = new TournamentSeason(this);
              copy._hasPostSeasonPurchase = false;
              copy._postSeasonPurchase = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPostSeasonPurchase) {
            const copy = new TournamentSeason(this);
            copy._hasPostSeasonPurchase = true;
            copy._postSeasonPurchase = TournamentSeason_PostSeasonPurchase.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._postSeasonPurchase.apply(type, path.slice(1), value);
          if (newValue === this._postSeasonPurchase) {
            return this;
          }
          const copy = new TournamentSeason(this);
          copy._postSeasonPurchase = copy._postSeasonPurchase.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {TournamentSeason} other
   * @returns {TournamentSeason}
   */
  merge(other) {
    const copy = new TournamentSeason(this);
    if (other._hasSeason) {
      copy._hasSeason = true;
      copy._season = other._season;
    }
    if (other._hasStartTime) {
      copy._hasStartTime = true;
      copy._startTime = other._startTime;
    }
    if (other._hasEndTime) {
      copy._hasEndTime = true;
      copy._endTime = other._endTime;
    }
    if (other._hasFinished) {
      copy._hasFinished = true;
      copy._finished = other._finished;
    }
    if (other._hasHighestLeague) {
      copy._hasHighestLeague = true;
      copy._highestLeague = other._highestLeague;
    }
    if (other._hasRankCount) {
      copy._hasRankCount = true;
      copy._rankCount = other._rankCount;
    }
    if (other._hasPostSeasonPurchase) {
      if (copy._hasPostSeasonPurchase) {
        copy._postSeasonPurchase = copy.postSeasonPurchase.merge(other.postSeasonPurchase);
      } else {
        copy._postSeasonPurchase = other._postSeasonPurchase;
      }
      copy._hasPostSeasonPurchase = true;
    }
    return copy;
  }
}
TournamentSeason.default = new TournamentSeason();
TournamentSeason.PostSeasonPurchase = TournamentSeason_PostSeasonPurchase;
class TournamentSeason_Builder {
  constructor(value) {
    this._value = new TournamentSeason(value);
  }
  build() {
    return new TournamentSeason(this._value);
  }
  setSeason(value) {
    this._value._hasSeason = true;
    this._value._season = value;
    return this;
  }
  deleteSeason() {
    this._value._hasSeason = false;
    this._value._season = null;
    return this;
  }
  setStartTime(value) {
    this._value._hasStartTime = true;
    this._value._startTime = value;
    return this;
  }
  deleteStartTime() {
    this._value._hasStartTime = false;
    this._value._startTime = null;
    return this;
  }
  setEndTime(value) {
    this._value._hasEndTime = true;
    this._value._endTime = value;
    return this;
  }
  deleteEndTime() {
    this._value._hasEndTime = false;
    this._value._endTime = null;
    return this;
  }
  setFinished(value) {
    this._value._hasFinished = true;
    this._value._finished = value;
    return this;
  }
  deleteFinished() {
    this._value._hasFinished = false;
    this._value._finished = null;
    return this;
  }
  setHighestLeague(value) {
    this._value._hasHighestLeague = true;
    this._value._highestLeague = value;
    return this;
  }
  deleteHighestLeague() {
    this._value._hasHighestLeague = false;
    this._value._highestLeague = null;
    return this;
  }
  setRankCount(value) {
    this._value._hasRankCount = true;
    this._value._rankCount = value;
    return this;
  }
  deleteRankCount() {
    this._value._hasRankCount = false;
    this._value._rankCount = null;
    return this;
  }
  setPostSeasonPurchase(value) {
    this._value._hasPostSeasonPurchase = true;
    this._value._postSeasonPurchase = value;
    return this;
  }
  deletePostSeasonPurchase() {
    this._value._hasPostSeasonPurchase = false;
    this._value._postSeasonPurchase = null;
    return this;
  }
}
TournamentSeason.Builder = TournamentSeason_Builder;
class TournamentSeason_WithParent {
  /**
   * @param {TournamentSeason} value
   * @param {TournamentSeason_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return TournamentSeason.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSeason() {
    if (this._cachedHasSeason === undefined) {
      if (this._value.hasSeason) {
        this._cachedHasSeason = true;
      } else {
        this._cachedHasSeason = this._parent ? this._parent.hasSeason : false;
      }
    }
    return this._cachedHasSeason;
  }
  get season() {
    if (this._cachedSeason === undefined) {
      if (this._value.hasSeason) {
        this._cachedSeason = this._value.season;
      } else {
        this._cachedSeason = this._parent ? this._parent.season : this._value.season;
      }
    }
    return this._cachedSeason;
  }
  get hasStartTime() {
    if (this._cachedHasStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedHasStartTime = true;
      } else {
        this._cachedHasStartTime = this._parent ? this._parent.hasStartTime : false;
      }
    }
    return this._cachedHasStartTime;
  }
  get startTime() {
    if (this._cachedStartTime === undefined) {
      if (this._value.hasStartTime) {
        this._cachedStartTime = this._value.startTime;
      } else {
        this._cachedStartTime = this._parent ? this._parent.startTime : this._value.startTime;
      }
    }
    return this._cachedStartTime;
  }
  get hasEndTime() {
    if (this._cachedHasEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedHasEndTime = true;
      } else {
        this._cachedHasEndTime = this._parent ? this._parent.hasEndTime : false;
      }
    }
    return this._cachedHasEndTime;
  }
  get endTime() {
    if (this._cachedEndTime === undefined) {
      if (this._value.hasEndTime) {
        this._cachedEndTime = this._value.endTime;
      } else {
        this._cachedEndTime = this._parent ? this._parent.endTime : this._value.endTime;
      }
    }
    return this._cachedEndTime;
  }
  get hasFinished() {
    if (this._cachedHasFinished === undefined) {
      if (this._value.hasFinished) {
        this._cachedHasFinished = true;
      } else {
        this._cachedHasFinished = this._parent ? this._parent.hasFinished : false;
      }
    }
    return this._cachedHasFinished;
  }
  get finished() {
    if (this._cachedFinished === undefined) {
      if (this._value.hasFinished) {
        this._cachedFinished = this._value.finished;
      } else {
        this._cachedFinished = this._parent ? this._parent.finished : this._value.finished;
      }
    }
    return this._cachedFinished;
  }
  get hasHighestLeague() {
    if (this._cachedHasHighestLeague === undefined) {
      if (this._value.hasHighestLeague) {
        this._cachedHasHighestLeague = true;
      } else {
        this._cachedHasHighestLeague = this._parent ? this._parent.hasHighestLeague : false;
      }
    }
    return this._cachedHasHighestLeague;
  }
  get highestLeague() {
    if (this._cachedHighestLeague === undefined) {
      if (this._value.hasHighestLeague) {
        this._cachedHighestLeague = this._value.highestLeague;
      } else {
        this._cachedHighestLeague = this._parent ? this._parent.highestLeague : this._value.highestLeague;
      }
    }
    return this._cachedHighestLeague;
  }
  get hasRankCount() {
    if (this._cachedHasRankCount === undefined) {
      if (this._value.hasRankCount) {
        this._cachedHasRankCount = true;
      } else {
        this._cachedHasRankCount = this._parent ? this._parent.hasRankCount : false;
      }
    }
    return this._cachedHasRankCount;
  }
  get rankCount() {
    if (this._cachedRankCount === undefined) {
      if (this._value.hasRankCount) {
        this._cachedRankCount = this._value.rankCount;
      } else {
        this._cachedRankCount = this._parent ? this._parent.rankCount : this._value.rankCount;
      }
    }
    return this._cachedRankCount;
  }
  get hasPostSeasonPurchase() {
    if (this._cachedHasPostSeasonPurchase === undefined) {
      if (this._value.hasPostSeasonPurchase) {
        this._cachedHasPostSeasonPurchase = true;
      } else {
        this._cachedHasPostSeasonPurchase = this._parent ? this._parent.hasPostSeasonPurchase : false;
      }
    }
    return this._cachedHasPostSeasonPurchase;
  }
  get postSeasonPurchase() {
    if (!this._cachedPostSeasonPurchase) {
      if (this._value.hasPostSeasonPurchase) {
        this._cachedPostSeasonPurchase = new TournamentSeason_PostSeasonPurchase.WithParent(this._value.postSeasonPurchase, this._parent && this._parent.hasPostSeasonPurchase ? this._parent.postSeasonPurchase : null);
      } else {
        this._cachedPostSeasonPurchase = this._parent ? new TournamentSeason_PostSeasonPurchase.WithParent(TournamentSeason_PostSeasonPurchase.default, this._parent.postSeasonPurchase) : TournamentSeason_PostSeasonPurchase.WithParent.default;
      }
    }
    return this._cachedPostSeasonPurchase;
  }
  update(current, parent) {
    const result = new TournamentSeason_WithParent(current, parent);
    if (this._cachedPostSeasonPurchase && this._value.hasPostSeasonPurchase && current.hasPostSeasonPurchase) {
      if (this._value.postSeasonPurchase === current.postSeasonPurchase && this._parent === parent) {
        result._cachedPostSeasonPurchase = this._cachedPostSeasonPurchase;
      } else {
        result._cachedPostSeasonPurchase = this._cachedPostSeasonPurchase.update(current.postSeasonPurchase, parent && parent.hasPostSeasonPurchase ? parent.postSeasonPurchase : null);
      }
    }
    return result;
  }
}
TournamentSeason_WithParent.default = new TournamentSeason_WithParent(TournamentSeason.default, null);
TournamentSeason.WithParent = TournamentSeason_WithParent;
class TournamentSeason_Descriptor {
  get season() {
    if (!this._season) {
      this._season = {
        name: "season",
        Name: "Season",
        number: 1,
        protoType: 5,
        protoName: "season",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._season;
  }
  get startTime() {
    if (!this._startTime) {
      this._startTime = {
        name: "startTime",
        Name: "StartTime",
        number: 2,
        protoType: 5,
        protoName: "start_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startTime;
  }
  get endTime() {
    if (!this._endTime) {
      this._endTime = {
        name: "endTime",
        Name: "EndTime",
        number: 3,
        protoType: 5,
        protoName: "end_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._endTime;
  }
  get finished() {
    if (!this._finished) {
      this._finished = {
        name: "finished",
        Name: "Finished",
        number: 4,
        protoType: 8,
        protoName: "finished",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._finished;
  }
  get highestLeague() {
    if (!this._highestLeague) {
      this._highestLeague = {
        name: "highestLeague",
        Name: "HighestLeague",
        number: 5,
        protoType: 5,
        protoName: "highest_league",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._highestLeague;
  }
  get rankCount() {
    if (!this._rankCount) {
      this._rankCount = {
        name: "rankCount",
        Name: "RankCount",
        number: 6,
        protoType: 5,
        protoName: "rank_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rankCount;
  }
  get postSeasonPurchase() {
    if (!this._postSeasonPurchase) {
      this._postSeasonPurchase = {
        name: "postSeasonPurchase",
        Name: "PostSeasonPurchase",
        number: 7,
        protoType: 11,
        protoName: "post_season_purchase",
        type: TournamentSeason_PostSeasonPurchase,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._postSeasonPurchase;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.season,
        this.startTime,
        this.endTime,
        this.finished,
        this.highestLeague,
        this.rankCount,
        this.postSeasonPurchase,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSeason",
        Name: "DummyOneofForSeason",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStartTime",
        Name: "DummyOneofForStartTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEndTime",
        Name: "DummyOneofForEndTime",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFinished",
        Name: "DummyOneofForFinished",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHighestLeague",
        Name: "DummyOneofForHighestLeague",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRankCount",
        Name: "DummyOneofForRankCount",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPostSeasonPurchase",
        Name: "DummyOneofForPostSeasonPurchase",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
TournamentSeason.descriptor = new TournamentSeason_Descriptor();
export class TournamentStatus {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "STARTING": return 0;
        case "STARTED": return 1;
        case "CLOSING": return 2;
        case "CLOSED": return 3;
        case "DRAFT": return 4;
        case "SCHEDULED": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TournamentStatus.fromJson(value);
  }
  static fromReact(e) {
    return TournamentStatus.fromJson(e);
  }
}
TournamentStatus.STARTING = 0;
TournamentStatus.STARTED = 1;
TournamentStatus.CLOSING = 2;
TournamentStatus.CLOSED = 3;
TournamentStatus.DRAFT = 4;
TournamentStatus.SCHEDULED = 5;
TournamentStatus.default = 0;
TournamentStatus.values = {
  STARTING: 0,
  STARTED: 1,
  CLOSING: 2,
  CLOSED: 3,
  DRAFT: 4,
  SCHEDULED: 5,
};
TournamentStatus.names = {
  0: "STARTING",
  1: "STARTED",
  2: "CLOSING",
  3: "CLOSED",
  4: "DRAFT",
  5: "SCHEDULED",
};
export class TournamentMode {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "REGULAR": return 0;
        case "MAX_CARD_LEVEL_MODE": return 1;
        case "FLEXIBLE_LOADOUT": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return TournamentMode.fromJson(value);
  }
  static fromReact(e) {
    return TournamentMode.fromJson(e);
  }
}
TournamentMode.REGULAR = 0;
TournamentMode.MAX_CARD_LEVEL_MODE = 1;
TournamentMode.FLEXIBLE_LOADOUT = 2;
TournamentMode.default = 0;
TournamentMode.values = {
  REGULAR: 0,
  MAX_CARD_LEVEL_MODE: 1,
  FLEXIBLE_LOADOUT: 2,
};
TournamentMode.names = {
  0: "REGULAR",
  1: "MAX_CARD_LEVEL_MODE",
  2: "FLEXIBLE_LOADOUT",
};
